var Vi = Object.defineProperty;
var Hi = (t, n, e) => n in t ? Vi(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e;
var Or = (t, n, e) => Hi(t, typeof n != "symbol" ? n + "" : n, e);
import { ref as A, useAttrs as ir, useId as Ui, computed as P, cloneVNode as qi, h as _t, provide as Se, watchEffect as De, inject as Ee, defineComponent as R, onUnmounted as yt, Teleport as Wi, reactive as Yi, onUpdated as Fa, onMounted as je, unref as m, nextTick as kt, toRaw as Ot, watch as tt, createBlock as V, openBlock as x, createVNode as k, shallowRef as Ba, getCurrentScope as zi, onScopeDispose as Ki, shallowReadonly as jt, toRef as It, useTemplateRef as Nt, withCtx as N, createElementVNode as v, Transition as lr, normalizeStyle as ja, createElementBlock as _, Fragment as te, renderList as ae, normalizeClass as L, createCommentVNode as B, createTextVNode as ce, resolveDynamicComponent as rt, toDisplayString as U, mergeModels as ve, useModel as xe, renderSlot as ge, mergeProps as Fe, mergeDefaults as ut, withDirectives as Xe, vModelSelect as Gi, withModifiers as et, TransitionGroup as Ji, createStaticVNode as Xi, vShow as Vo, isRef as Zi, isVNode as Qi, resolveComponent as Va, vModelCheckbox as uo, withKeys as Ho, vModelDynamic as el, vModelText as co, vModelRadio as Wr } from "vue";
function Ha(t, n) {
  return function() {
    return t.apply(n, arguments);
  };
}
const { toString: tl } = Object.prototype, { getPrototypeOf: fo } = Object, ur = /* @__PURE__ */ ((t) => (n) => {
  const e = tl.call(n);
  return t[e] || (t[e] = e.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ct = (t) => (t = t.toLowerCase(), (n) => ur(n) === t), cr = (t) => (n) => typeof n === t, { isArray: Zt } = Array, vn = cr("undefined");
function nl(t) {
  return t !== null && !vn(t) && t.constructor !== null && !vn(t.constructor) && Je(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Ua = ct("ArrayBuffer");
function rl(t) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(t) : n = t && t.buffer && Ua(t.buffer), n;
}
const ol = cr("string"), Je = cr("function"), qa = cr("number"), dr = (t) => t !== null && typeof t == "object", al = (t) => t === !0 || t === !1, qn = (t) => {
  if (ur(t) !== "object")
    return !1;
  const n = fo(t);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, sl = ct("Date"), il = ct("File"), ll = ct("Blob"), ul = ct("FileList"), cl = (t) => dr(t) && Je(t.pipe), dl = (t) => {
  let n;
  return t && (typeof FormData == "function" && t instanceof FormData || Je(t.append) && ((n = ur(t)) === "formdata" || // detect form-data instance
  n === "object" && Je(t.toString) && t.toString() === "[object FormData]"));
}, fl = ct("URLSearchParams"), [pl, ml, hl, gl] = ["ReadableStream", "Request", "Response", "Headers"].map(ct), vl = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Dn(t, n, { allOwnKeys: e = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let r, o;
  if (typeof t != "object" && (t = [t]), Zt(t))
    for (r = 0, o = t.length; r < o; r++)
      n.call(null, t[r], r, t);
  else {
    const a = e ? Object.getOwnPropertyNames(t) : Object.keys(t), s = a.length;
    let i;
    for (r = 0; r < s; r++)
      i = a[r], n.call(null, t[i], i, t);
  }
}
function Wa(t, n) {
  n = n.toLowerCase();
  const e = Object.keys(t);
  let r = e.length, o;
  for (; r-- > 0; )
    if (o = e[r], n === o.toLowerCase())
      return o;
  return null;
}
const Rt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ya = (t) => !vn(t) && t !== Rt;
function Yr() {
  const { caseless: t } = Ya(this) && this || {}, n = {}, e = (r, o) => {
    const a = t && Wa(n, o) || o;
    qn(n[a]) && qn(r) ? n[a] = Yr(n[a], r) : qn(r) ? n[a] = Yr({}, r) : Zt(r) ? n[a] = r.slice() : n[a] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Dn(arguments[r], e);
  return n;
}
const bl = (t, n, e, { allOwnKeys: r } = {}) => (Dn(n, (o, a) => {
  e && Je(o) ? t[a] = Ha(o, e) : t[a] = o;
}, { allOwnKeys: r }), t), yl = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), wl = (t, n, e, r) => {
  t.prototype = Object.create(n.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: n.prototype
  }), e && Object.assign(t.prototype, e);
}, xl = (t, n, e, r) => {
  let o, a, s;
  const i = {};
  if (n = n || {}, t == null) return n;
  do {
    for (o = Object.getOwnPropertyNames(t), a = o.length; a-- > 0; )
      s = o[a], (!r || r(s, t, n)) && !i[s] && (n[s] = t[s], i[s] = !0);
    t = e !== !1 && fo(t);
  } while (t && (!e || e(t, n)) && t !== Object.prototype);
  return n;
}, Cl = (t, n, e) => {
  t = String(t), (e === void 0 || e > t.length) && (e = t.length), e -= n.length;
  const r = t.indexOf(n, e);
  return r !== -1 && r === e;
}, Dl = (t) => {
  if (!t) return null;
  if (Zt(t)) return t;
  let n = t.length;
  if (!qa(n)) return null;
  const e = new Array(n);
  for (; n-- > 0; )
    e[n] = t[n];
  return e;
}, El = /* @__PURE__ */ ((t) => (n) => t && n instanceof t)(typeof Uint8Array < "u" && fo(Uint8Array)), _l = (t, n) => {
  const r = (t && t[Symbol.iterator]).call(t);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const a = o.value;
    n.call(t, a[0], a[1]);
  }
}, kl = (t, n) => {
  let e;
  const r = [];
  for (; (e = t.exec(n)) !== null; )
    r.push(e);
  return r;
}, Sl = ct("HTMLFormElement"), $l = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, r, o) {
    return r.toUpperCase() + o;
  }
), Uo = (({ hasOwnProperty: t }) => (n, e) => t.call(n, e))(Object.prototype), Tl = ct("RegExp"), za = (t, n) => {
  const e = Object.getOwnPropertyDescriptors(t), r = {};
  Dn(e, (o, a) => {
    let s;
    (s = n(o, a, t)) !== !1 && (r[a] = s || o);
  }), Object.defineProperties(t, r);
}, Ml = (t) => {
  za(t, (n, e) => {
    if (Je(t) && ["arguments", "caller", "callee"].indexOf(e) !== -1)
      return !1;
    const r = t[e];
    if (Je(r)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + e + "'");
      });
    }
  });
}, Pl = (t, n) => {
  const e = {}, r = (o) => {
    o.forEach((a) => {
      e[a] = !0;
    });
  };
  return Zt(t) ? r(t) : r(String(t).split(n)), e;
}, Al = () => {
}, Ol = (t, n) => t != null && Number.isFinite(t = +t) ? t : n;
function Rl(t) {
  return !!(t && Je(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const Il = (t) => {
  const n = new Array(10), e = (r, o) => {
    if (dr(r)) {
      if (n.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        n[o] = r;
        const a = Zt(r) ? [] : {};
        return Dn(r, (s, i) => {
          const l = e(s, o + 1);
          !vn(l) && (a[i] = l);
        }), n[o] = void 0, a;
      }
    }
    return r;
  };
  return e(t, 0);
}, Ll = ct("AsyncFunction"), Nl = (t) => t && (dr(t) || Je(t)) && Je(t.then) && Je(t.catch), Ka = ((t, n) => t ? setImmediate : n ? ((e, r) => (Rt.addEventListener("message", ({ source: o, data: a }) => {
  o === Rt && a === e && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), Rt.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(
  typeof setImmediate == "function",
  Je(Rt.postMessage)
), Fl = typeof queueMicrotask < "u" ? queueMicrotask.bind(Rt) : typeof process < "u" && process.nextTick || Ka, E = {
  isArray: Zt,
  isArrayBuffer: Ua,
  isBuffer: nl,
  isFormData: dl,
  isArrayBufferView: rl,
  isString: ol,
  isNumber: qa,
  isBoolean: al,
  isObject: dr,
  isPlainObject: qn,
  isReadableStream: pl,
  isRequest: ml,
  isResponse: hl,
  isHeaders: gl,
  isUndefined: vn,
  isDate: sl,
  isFile: il,
  isBlob: ll,
  isRegExp: Tl,
  isFunction: Je,
  isStream: cl,
  isURLSearchParams: fl,
  isTypedArray: El,
  isFileList: ul,
  forEach: Dn,
  merge: Yr,
  extend: bl,
  trim: vl,
  stripBOM: yl,
  inherits: wl,
  toFlatObject: xl,
  kindOf: ur,
  kindOfTest: ct,
  endsWith: Cl,
  toArray: Dl,
  forEachEntry: _l,
  matchAll: kl,
  isHTMLForm: Sl,
  hasOwnProperty: Uo,
  hasOwnProp: Uo,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: za,
  freezeMethods: Ml,
  toObjectSet: Pl,
  toCamelCase: $l,
  noop: Al,
  toFiniteNumber: Ol,
  findKey: Wa,
  global: Rt,
  isContextDefined: Ya,
  isSpecCompliantForm: Rl,
  toJSONObject: Il,
  isAsyncFn: Ll,
  isThenable: Nl,
  setImmediate: Ka,
  asap: Fl
};
function z(t, n, e, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", n && (this.code = n), e && (this.config = e), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
E.inherits(z, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: E.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ga = z.prototype, Ja = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Ja[t] = { value: t };
});
Object.defineProperties(z, Ja);
Object.defineProperty(Ga, "isAxiosError", { value: !0 });
z.from = (t, n, e, r, o, a) => {
  const s = Object.create(Ga);
  return E.toFlatObject(t, s, function(l) {
    return l !== Error.prototype;
  }, (i) => i !== "isAxiosError"), z.call(s, t.message, n, e, r, o), s.cause = t, s.name = t.name, a && Object.assign(s, a), s;
};
const Bl = null;
function zr(t) {
  return E.isPlainObject(t) || E.isArray(t);
}
function Xa(t) {
  return E.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function qo(t, n, e) {
  return t ? t.concat(n).map(function(o, a) {
    return o = Xa(o), !e && a ? "[" + o + "]" : o;
  }).join(e ? "." : "") : n;
}
function jl(t) {
  return E.isArray(t) && !t.some(zr);
}
const Vl = E.toFlatObject(E, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function fr(t, n, e) {
  if (!E.isObject(t))
    throw new TypeError("target must be an object");
  n = n || new FormData(), e = E.toFlatObject(e, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, w) {
    return !E.isUndefined(w[y]);
  });
  const r = e.metaTokens, o = e.visitor || c, a = e.dots, s = e.indexes, l = (e.Blob || typeof Blob < "u" && Blob) && E.isSpecCompliantForm(n);
  if (!E.isFunction(o))
    throw new TypeError("visitor must be a function");
  function u(h) {
    if (h === null) return "";
    if (E.isDate(h))
      return h.toISOString();
    if (!l && E.isBlob(h))
      throw new z("Blob is not supported. Use a Buffer instead.");
    return E.isArrayBuffer(h) || E.isTypedArray(h) ? l && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, y, w) {
    let D = h;
    if (h && !w && typeof h == "object") {
      if (E.endsWith(y, "{}"))
        y = r ? y : y.slice(0, -2), h = JSON.stringify(h);
      else if (E.isArray(h) && jl(h) || (E.isFileList(h) || E.endsWith(y, "[]")) && (D = E.toArray(h)))
        return y = Xa(y), D.forEach(function(M, K) {
          !(E.isUndefined(M) || M === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? qo([y], K, a) : s === null ? y : y + "[]",
            u(M)
          );
        }), !1;
    }
    return zr(h) ? !0 : (n.append(qo(w, y, a), u(h)), !1);
  }
  const d = [], f = Object.assign(Vl, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: zr
  });
  function g(h, y) {
    if (!E.isUndefined(h)) {
      if (d.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      d.push(h), E.forEach(h, function(D, T) {
        (!(E.isUndefined(D) || D === null) && o.call(
          n,
          D,
          E.isString(T) ? T.trim() : T,
          y,
          f
        )) === !0 && g(D, y ? y.concat(T) : [T]);
      }), d.pop();
    }
  }
  if (!E.isObject(t))
    throw new TypeError("data must be an object");
  return g(t), n;
}
function Wo(t) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(r) {
    return n[r];
  });
}
function po(t, n) {
  this._pairs = [], t && fr(t, this, n);
}
const Za = po.prototype;
Za.append = function(n, e) {
  this._pairs.push([n, e]);
};
Za.toString = function(n) {
  const e = n ? function(r) {
    return n.call(this, r, Wo);
  } : Wo;
  return this._pairs.map(function(o) {
    return e(o[0]) + "=" + e(o[1]);
  }, "").join("&");
};
function Hl(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Qa(t, n, e) {
  if (!n)
    return t;
  const r = e && e.encode || Hl;
  E.isFunction(e) && (e = {
    serialize: e
  });
  const o = e && e.serialize;
  let a;
  if (o ? a = o(n, e) : a = E.isURLSearchParams(n) ? n.toString() : new po(n, e).toString(r), a) {
    const s = t.indexOf("#");
    s !== -1 && (t = t.slice(0, s)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class Yo {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, e, r) {
    return this.handlers.push({
      fulfilled: n,
      rejected: e,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    E.forEach(this.handlers, function(r) {
      r !== null && n(r);
    });
  }
}
const es = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ul = typeof URLSearchParams < "u" ? URLSearchParams : po, ql = typeof FormData < "u" ? FormData : null, Wl = typeof Blob < "u" ? Blob : null, Yl = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ul,
    FormData: ql,
    Blob: Wl
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, mo = typeof window < "u" && typeof document < "u", Kr = typeof navigator == "object" && navigator || void 0, zl = mo && (!Kr || ["ReactNative", "NativeScript", "NS"].indexOf(Kr.product) < 0), Kl = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Gl = mo && window.location.href || "http://localhost", Jl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: mo,
  hasStandardBrowserEnv: zl,
  hasStandardBrowserWebWorkerEnv: Kl,
  navigator: Kr,
  origin: Gl
}, Symbol.toStringTag, { value: "Module" })), Ae = {
  ...Jl,
  ...Yl
};
function Xl(t, n) {
  return fr(t, new Ae.classes.URLSearchParams(), Object.assign({
    visitor: function(e, r, o, a) {
      return Ae.isNode && E.isBuffer(e) ? (this.append(r, e.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function Zl(t) {
  return E.matchAll(/\w+|\[(\w*)]/g, t).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function Ql(t) {
  const n = {}, e = Object.keys(t);
  let r;
  const o = e.length;
  let a;
  for (r = 0; r < o; r++)
    a = e[r], n[a] = t[a];
  return n;
}
function ts(t) {
  function n(e, r, o, a) {
    let s = e[a++];
    if (s === "__proto__") return !0;
    const i = Number.isFinite(+s), l = a >= e.length;
    return s = !s && E.isArray(o) ? o.length : s, l ? (E.hasOwnProp(o, s) ? o[s] = [o[s], r] : o[s] = r, !i) : ((!o[s] || !E.isObject(o[s])) && (o[s] = []), n(e, r, o[s], a) && E.isArray(o[s]) && (o[s] = Ql(o[s])), !i);
  }
  if (E.isFormData(t) && E.isFunction(t.entries)) {
    const e = {};
    return E.forEachEntry(t, (r, o) => {
      n(Zl(r), o, e, 0);
    }), e;
  }
  return null;
}
function eu(t, n, e) {
  if (E.isString(t))
    try {
      return (n || JSON.parse)(t), E.trim(t);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (e || JSON.stringify)(t);
}
const En = {
  transitional: es,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, e) {
    const r = e.getContentType() || "", o = r.indexOf("application/json") > -1, a = E.isObject(n);
    if (a && E.isHTMLForm(n) && (n = new FormData(n)), E.isFormData(n))
      return o ? JSON.stringify(ts(n)) : n;
    if (E.isArrayBuffer(n) || E.isBuffer(n) || E.isStream(n) || E.isFile(n) || E.isBlob(n) || E.isReadableStream(n))
      return n;
    if (E.isArrayBufferView(n))
      return n.buffer;
    if (E.isURLSearchParams(n))
      return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let i;
    if (a) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Xl(n, this.formSerializer).toString();
      if ((i = E.isFileList(n)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return fr(
          i ? { "files[]": n } : n,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return a || o ? (e.setContentType("application/json", !1), eu(n)) : n;
  }],
  transformResponse: [function(n) {
    const e = this.transitional || En.transitional, r = e && e.forcedJSONParsing, o = this.responseType === "json";
    if (E.isResponse(n) || E.isReadableStream(n))
      return n;
    if (n && E.isString(n) && (r && !this.responseType || o)) {
      const s = !(e && e.silentJSONParsing) && o;
      try {
        return JSON.parse(n);
      } catch (i) {
        if (s)
          throw i.name === "SyntaxError" ? z.from(i, z.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ae.classes.FormData,
    Blob: Ae.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
E.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  En.headers[t] = {};
});
const tu = E.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), nu = (t) => {
  const n = {};
  let e, r, o;
  return t && t.split(`
`).forEach(function(s) {
    o = s.indexOf(":"), e = s.substring(0, o).trim().toLowerCase(), r = s.substring(o + 1).trim(), !(!e || n[e] && tu[e]) && (e === "set-cookie" ? n[e] ? n[e].push(r) : n[e] = [r] : n[e] = n[e] ? n[e] + ", " + r : r);
  }), n;
}, zo = Symbol("internals");
function cn(t) {
  return t && String(t).trim().toLowerCase();
}
function Wn(t) {
  return t === !1 || t == null ? t : E.isArray(t) ? t.map(Wn) : String(t);
}
function ru(t) {
  const n = /* @__PURE__ */ Object.create(null), e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = e.exec(t); )
    n[r[1]] = r[2];
  return n;
}
const ou = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function Rr(t, n, e, r, o) {
  if (E.isFunction(r))
    return r.call(this, n, e);
  if (o && (n = e), !!E.isString(n)) {
    if (E.isString(r))
      return n.indexOf(r) !== -1;
    if (E.isRegExp(r))
      return r.test(n);
  }
}
function au(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, e, r) => e.toUpperCase() + r);
}
function su(t, n) {
  const e = E.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(t, r + e, {
      value: function(o, a, s) {
        return this[r].call(this, n, o, a, s);
      },
      configurable: !0
    });
  });
}
let Ve = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, e, r) {
    const o = this;
    function a(i, l, u) {
      const c = cn(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = E.findKey(o, c);
      (!d || o[d] === void 0 || u === !0 || u === void 0 && o[d] !== !1) && (o[d || l] = Wn(i));
    }
    const s = (i, l) => E.forEach(i, (u, c) => a(u, c, l));
    if (E.isPlainObject(n) || n instanceof this.constructor)
      s(n, e);
    else if (E.isString(n) && (n = n.trim()) && !ou(n))
      s(nu(n), e);
    else if (E.isHeaders(n))
      for (const [i, l] of n.entries())
        a(l, i, r);
    else
      n != null && a(e, n, r);
    return this;
  }
  get(n, e) {
    if (n = cn(n), n) {
      const r = E.findKey(this, n);
      if (r) {
        const o = this[r];
        if (!e)
          return o;
        if (e === !0)
          return ru(o);
        if (E.isFunction(e))
          return e.call(this, o, r);
        if (E.isRegExp(e))
          return e.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, e) {
    if (n = cn(n), n) {
      const r = E.findKey(this, n);
      return !!(r && this[r] !== void 0 && (!e || Rr(this, this[r], r, e)));
    }
    return !1;
  }
  delete(n, e) {
    const r = this;
    let o = !1;
    function a(s) {
      if (s = cn(s), s) {
        const i = E.findKey(r, s);
        i && (!e || Rr(r, r[i], i, e)) && (delete r[i], o = !0);
      }
    }
    return E.isArray(n) ? n.forEach(a) : a(n), o;
  }
  clear(n) {
    const e = Object.keys(this);
    let r = e.length, o = !1;
    for (; r--; ) {
      const a = e[r];
      (!n || Rr(this, this[a], a, n, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(n) {
    const e = this, r = {};
    return E.forEach(this, (o, a) => {
      const s = E.findKey(r, a);
      if (s) {
        e[s] = Wn(o), delete e[a];
        return;
      }
      const i = n ? au(a) : String(a).trim();
      i !== a && delete e[a], e[i] = Wn(o), r[i] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const e = /* @__PURE__ */ Object.create(null);
    return E.forEach(this, (r, o) => {
      r != null && r !== !1 && (e[o] = n && E.isArray(r) ? r.join(", ") : r);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, e]) => n + ": " + e).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...e) {
    const r = new this(n);
    return e.forEach((o) => r.set(o)), r;
  }
  static accessor(n) {
    const r = (this[zo] = this[zo] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(s) {
      const i = cn(s);
      r[i] || (su(o, s), r[i] = !0);
    }
    return E.isArray(n) ? n.forEach(a) : a(n), this;
  }
};
Ve.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
E.reduceDescriptors(Ve.prototype, ({ value: t }, n) => {
  let e = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => t,
    set(r) {
      this[e] = r;
    }
  };
});
E.freezeMethods(Ve);
function Ir(t, n) {
  const e = this || En, r = n || e, o = Ve.from(r.headers);
  let a = r.data;
  return E.forEach(t, function(i) {
    a = i.call(e, a, o.normalize(), n ? n.status : void 0);
  }), o.normalize(), a;
}
function ns(t) {
  return !!(t && t.__CANCEL__);
}
function Qt(t, n, e) {
  z.call(this, t ?? "canceled", z.ERR_CANCELED, n, e), this.name = "CanceledError";
}
E.inherits(Qt, z, {
  __CANCEL__: !0
});
function rs(t, n, e) {
  const r = e.config.validateStatus;
  !e.status || !r || r(e.status) ? t(e) : n(new z(
    "Request failed with status code " + e.status,
    [z.ERR_BAD_REQUEST, z.ERR_BAD_RESPONSE][Math.floor(e.status / 100) - 4],
    e.config,
    e.request,
    e
  ));
}
function iu(t) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return n && n[1] || "";
}
function lu(t, n) {
  t = t || 10;
  const e = new Array(t), r = new Array(t);
  let o = 0, a = 0, s;
  return n = n !== void 0 ? n : 1e3, function(l) {
    const u = Date.now(), c = r[a];
    s || (s = u), e[o] = l, r[o] = u;
    let d = a, f = 0;
    for (; d !== o; )
      f += e[d++], d = d % t;
    if (o = (o + 1) % t, o === a && (a = (a + 1) % t), u - s < n)
      return;
    const g = c && u - c;
    return g ? Math.round(f * 1e3 / g) : void 0;
  };
}
function uu(t, n) {
  let e = 0, r = 1e3 / n, o, a;
  const s = (u, c = Date.now()) => {
    e = c, o = null, a && (clearTimeout(a), a = null), t.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), d = c - e;
    d >= r ? s(u, c) : (o = u, a || (a = setTimeout(() => {
      a = null, s(o);
    }, r - d)));
  }, () => o && s(o)];
}
const Gn = (t, n, e = 3) => {
  let r = 0;
  const o = lu(50, 250);
  return uu((a) => {
    const s = a.loaded, i = a.lengthComputable ? a.total : void 0, l = s - r, u = o(l), c = s <= i;
    r = s;
    const d = {
      loaded: s,
      total: i,
      progress: i ? s / i : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && i && c ? (i - s) / u : void 0,
      event: a,
      lengthComputable: i != null,
      [n ? "download" : "upload"]: !0
    };
    t(d);
  }, e);
}, Ko = (t, n) => {
  const e = t != null;
  return [(r) => n[0]({
    lengthComputable: e,
    total: t,
    loaded: r
  }), n[1]];
}, Go = (t) => (...n) => E.asap(() => t(...n)), cu = Ae.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, n) => (e) => (e = new URL(e, Ae.origin), t.protocol === e.protocol && t.host === e.host && (n || t.port === e.port)))(
  new URL(Ae.origin),
  Ae.navigator && /(msie|trident)/i.test(Ae.navigator.userAgent)
) : () => !0, du = Ae.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, n, e, r, o, a) {
      const s = [t + "=" + encodeURIComponent(n)];
      E.isNumber(e) && s.push("expires=" + new Date(e).toGMTString()), E.isString(r) && s.push("path=" + r), E.isString(o) && s.push("domain=" + o), a === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(t) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function fu(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function pu(t, n) {
  return n ? t.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : t;
}
function os(t, n, e) {
  let r = !fu(n);
  return t && r || e == !1 ? pu(t, n) : n;
}
const Jo = (t) => t instanceof Ve ? { ...t } : t;
function Ft(t, n) {
  n = n || {};
  const e = {};
  function r(u, c, d, f) {
    return E.isPlainObject(u) && E.isPlainObject(c) ? E.merge.call({ caseless: f }, u, c) : E.isPlainObject(c) ? E.merge({}, c) : E.isArray(c) ? c.slice() : c;
  }
  function o(u, c, d, f) {
    if (E.isUndefined(c)) {
      if (!E.isUndefined(u))
        return r(void 0, u, d, f);
    } else return r(u, c, d, f);
  }
  function a(u, c) {
    if (!E.isUndefined(c))
      return r(void 0, c);
  }
  function s(u, c) {
    if (E.isUndefined(c)) {
      if (!E.isUndefined(u))
        return r(void 0, u);
    } else return r(void 0, c);
  }
  function i(u, c, d) {
    if (d in n)
      return r(u, c);
    if (d in t)
      return r(void 0, u);
  }
  const l = {
    url: a,
    method: a,
    data: a,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: i,
    headers: (u, c, d) => o(Jo(u), Jo(c), d, !0)
  };
  return E.forEach(Object.keys(Object.assign({}, t, n)), function(c) {
    const d = l[c] || o, f = d(t[c], n[c], c);
    E.isUndefined(f) && d !== i || (e[c] = f);
  }), e;
}
const as = (t) => {
  const n = Ft({}, t);
  let { data: e, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: a, headers: s, auth: i } = n;
  n.headers = s = Ve.from(s), n.url = Qa(os(n.baseURL, n.url, n.allowAbsoluteUrls), t.params, t.paramsSerializer), i && s.set(
    "Authorization",
    "Basic " + btoa((i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : ""))
  );
  let l;
  if (E.isFormData(e)) {
    if (Ae.hasStandardBrowserEnv || Ae.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((l = s.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      s.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (Ae.hasStandardBrowserEnv && (r && E.isFunction(r) && (r = r(n)), r || r !== !1 && cu(n.url))) {
    const u = o && a && du.read(a);
    u && s.set(o, u);
  }
  return n;
}, mu = typeof XMLHttpRequest < "u", hu = mu && function(t) {
  return new Promise(function(e, r) {
    const o = as(t);
    let a = o.data;
    const s = Ve.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: l, onDownloadProgress: u } = o, c, d, f, g, h;
    function y() {
      g && g(), h && h(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let w = new XMLHttpRequest();
    w.open(o.method.toUpperCase(), o.url, !0), w.timeout = o.timeout;
    function D() {
      if (!w)
        return;
      const M = Ve.from(
        "getAllResponseHeaders" in w && w.getAllResponseHeaders()
      ), q = {
        data: !i || i === "text" || i === "json" ? w.responseText : w.response,
        status: w.status,
        statusText: w.statusText,
        headers: M,
        config: t,
        request: w
      };
      rs(function(H) {
        e(H), y();
      }, function(H) {
        r(H), y();
      }, q), w = null;
    }
    "onloadend" in w ? w.onloadend = D : w.onreadystatechange = function() {
      !w || w.readyState !== 4 || w.status === 0 && !(w.responseURL && w.responseURL.indexOf("file:") === 0) || setTimeout(D);
    }, w.onabort = function() {
      w && (r(new z("Request aborted", z.ECONNABORTED, t, w)), w = null);
    }, w.onerror = function() {
      r(new z("Network Error", z.ERR_NETWORK, t, w)), w = null;
    }, w.ontimeout = function() {
      let K = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const q = o.transitional || es;
      o.timeoutErrorMessage && (K = o.timeoutErrorMessage), r(new z(
        K,
        q.clarifyTimeoutError ? z.ETIMEDOUT : z.ECONNABORTED,
        t,
        w
      )), w = null;
    }, a === void 0 && s.setContentType(null), "setRequestHeader" in w && E.forEach(s.toJSON(), function(K, q) {
      w.setRequestHeader(q, K);
    }), E.isUndefined(o.withCredentials) || (w.withCredentials = !!o.withCredentials), i && i !== "json" && (w.responseType = o.responseType), u && ([f, h] = Gn(u, !0), w.addEventListener("progress", f)), l && w.upload && ([d, g] = Gn(l), w.upload.addEventListener("progress", d), w.upload.addEventListener("loadend", g)), (o.cancelToken || o.signal) && (c = (M) => {
      w && (r(!M || M.type ? new Qt(null, t, w) : M), w.abort(), w = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const T = iu(o.url);
    if (T && Ae.protocols.indexOf(T) === -1) {
      r(new z("Unsupported protocol " + T + ":", z.ERR_BAD_REQUEST, t));
      return;
    }
    w.send(a || null);
  });
}, gu = (t, n) => {
  const { length: e } = t = t ? t.filter(Boolean) : [];
  if (n || e) {
    let r = new AbortController(), o;
    const a = function(u) {
      if (!o) {
        o = !0, i();
        const c = u instanceof Error ? u : this.reason;
        r.abort(c instanceof z ? c : new Qt(c instanceof Error ? c.message : c));
      }
    };
    let s = n && setTimeout(() => {
      s = null, a(new z(`timeout ${n} of ms exceeded`, z.ETIMEDOUT));
    }, n);
    const i = () => {
      t && (s && clearTimeout(s), s = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", a));
    const { signal: l } = r;
    return l.unsubscribe = () => E.asap(i), l;
  }
}, vu = function* (t, n) {
  let e = t.byteLength;
  if (e < n) {
    yield t;
    return;
  }
  let r = 0, o;
  for (; r < e; )
    o = r + n, yield t.slice(r, o), r = o;
}, bu = async function* (t, n) {
  for await (const e of yu(t))
    yield* vu(e, n);
}, yu = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const n = t.getReader();
  try {
    for (; ; ) {
      const { done: e, value: r } = await n.read();
      if (e)
        break;
      yield r;
    }
  } finally {
    await n.cancel();
  }
}, Xo = (t, n, e, r) => {
  const o = bu(t, n);
  let a = 0, s, i = (l) => {
    s || (s = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await o.next();
        if (u) {
          i(), l.close();
          return;
        }
        let d = c.byteLength;
        if (e) {
          let f = a += d;
          e(f);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw i(u), u;
      }
    },
    cancel(l) {
      return i(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, pr = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", ss = pr && typeof ReadableStream == "function", wu = pr && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (n) => t.encode(n))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), is = (t, ...n) => {
  try {
    return !!t(...n);
  } catch {
    return !1;
  }
}, xu = ss && is(() => {
  let t = !1;
  const n = new Request(Ae.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !n;
}), Zo = 64 * 1024, Gr = ss && is(() => E.isReadableStream(new Response("").body)), Jn = {
  stream: Gr && ((t) => t.body)
};
pr && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((n) => {
    !Jn[n] && (Jn[n] = E.isFunction(t[n]) ? (e) => e[n]() : (e, r) => {
      throw new z(`Response type '${n}' is not supported`, z.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Cu = async (t) => {
  if (t == null)
    return 0;
  if (E.isBlob(t))
    return t.size;
  if (E.isSpecCompliantForm(t))
    return (await new Request(Ae.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (E.isArrayBufferView(t) || E.isArrayBuffer(t))
    return t.byteLength;
  if (E.isURLSearchParams(t) && (t = t + ""), E.isString(t))
    return (await wu(t)).byteLength;
}, Du = async (t, n) => {
  const e = E.toFiniteNumber(t.getContentLength());
  return e ?? Cu(n);
}, Eu = pr && (async (t) => {
  let {
    url: n,
    method: e,
    data: r,
    signal: o,
    cancelToken: a,
    timeout: s,
    onDownloadProgress: i,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = as(t);
  u = u ? (u + "").toLowerCase() : "text";
  let g = gu([o, a && a.toAbortSignal()], s), h;
  const y = g && g.unsubscribe && (() => {
    g.unsubscribe();
  });
  let w;
  try {
    if (l && xu && e !== "get" && e !== "head" && (w = await Du(c, r)) !== 0) {
      let q = new Request(n, {
        method: "POST",
        body: r,
        duplex: "half"
      }), Z;
      if (E.isFormData(r) && (Z = q.headers.get("content-type")) && c.setContentType(Z), q.body) {
        const [H, _e] = Ko(
          w,
          Gn(Go(l))
        );
        r = Xo(q.body, Zo, H, _e);
      }
    }
    E.isString(d) || (d = d ? "include" : "omit");
    const D = "credentials" in Request.prototype;
    h = new Request(n, {
      ...f,
      signal: g,
      method: e.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: D ? d : void 0
    });
    let T = await fetch(h);
    const M = Gr && (u === "stream" || u === "response");
    if (Gr && (i || M && y)) {
      const q = {};
      ["status", "statusText", "headers"].forEach((J) => {
        q[J] = T[J];
      });
      const Z = E.toFiniteNumber(T.headers.get("content-length")), [H, _e] = i && Ko(
        Z,
        Gn(Go(i), !0)
      ) || [];
      T = new Response(
        Xo(T.body, Zo, H, () => {
          _e && _e(), y && y();
        }),
        q
      );
    }
    u = u || "text";
    let K = await Jn[E.findKey(Jn, u) || "text"](T, t);
    return !M && y && y(), await new Promise((q, Z) => {
      rs(q, Z, {
        data: K,
        headers: Ve.from(T.headers),
        status: T.status,
        statusText: T.statusText,
        config: t,
        request: h
      });
    });
  } catch (D) {
    throw y && y(), D && D.name === "TypeError" && /fetch/i.test(D.message) ? Object.assign(
      new z("Network Error", z.ERR_NETWORK, t, h),
      {
        cause: D.cause || D
      }
    ) : z.from(D, D && D.code, t, h);
  }
}), Jr = {
  http: Bl,
  xhr: hu,
  fetch: Eu
};
E.forEach(Jr, (t, n) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: n });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: n });
  }
});
const Qo = (t) => `- ${t}`, _u = (t) => E.isFunction(t) || t === null || t === !1, ls = {
  getAdapter: (t) => {
    t = E.isArray(t) ? t : [t];
    const { length: n } = t;
    let e, r;
    const o = {};
    for (let a = 0; a < n; a++) {
      e = t[a];
      let s;
      if (r = e, !_u(e) && (r = Jr[(s = String(e)).toLowerCase()], r === void 0))
        throw new z(`Unknown adapter '${s}'`);
      if (r)
        break;
      o[s || "#" + a] = r;
    }
    if (!r) {
      const a = Object.entries(o).map(
        ([i, l]) => `adapter ${i} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = n ? a.length > 1 ? `since :
` + a.map(Qo).join(`
`) : " " + Qo(a[0]) : "as no adapter specified";
      throw new z(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Jr
};
function Lr(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Qt(null, t);
}
function ea(t) {
  return Lr(t), t.headers = Ve.from(t.headers), t.data = Ir.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), ls.getAdapter(t.adapter || En.adapter)(t).then(function(r) {
    return Lr(t), r.data = Ir.call(
      t,
      t.transformResponse,
      r
    ), r.headers = Ve.from(r.headers), r;
  }, function(r) {
    return ns(r) || (Lr(t), r && r.response && (r.response.data = Ir.call(
      t,
      t.transformResponse,
      r.response
    ), r.response.headers = Ve.from(r.response.headers))), Promise.reject(r);
  });
}
const us = "1.8.3", mr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, n) => {
  mr[t] = function(r) {
    return typeof r === t || "a" + (n < 1 ? "n " : " ") + t;
  };
});
const ta = {};
mr.transitional = function(n, e, r) {
  function o(a, s) {
    return "[Axios v" + us + "] Transitional option '" + a + "'" + s + (r ? ". " + r : "");
  }
  return (a, s, i) => {
    if (n === !1)
      throw new z(
        o(s, " has been removed" + (e ? " in " + e : "")),
        z.ERR_DEPRECATED
      );
    return e && !ta[s] && (ta[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), n ? n(a, s, i) : !0;
  };
};
mr.spelling = function(n) {
  return (e, r) => (console.warn(`${r} is likely a misspelling of ${n}`), !0);
};
function ku(t, n, e) {
  if (typeof t != "object")
    throw new z("options must be an object", z.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let o = r.length;
  for (; o-- > 0; ) {
    const a = r[o], s = n[a];
    if (s) {
      const i = t[a], l = i === void 0 || s(i, a, t);
      if (l !== !0)
        throw new z("option " + a + " must be " + l, z.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (e !== !0)
      throw new z("Unknown option " + a, z.ERR_BAD_OPTION);
  }
}
const Yn = {
  assertOptions: ku,
  validators: mr
}, gt = Yn.validators;
let Lt = class {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new Yo(),
      response: new Yo()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, e) {
    try {
      return await this._request(n, e);
    } catch (r) {
      if (r instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? a && !String(r.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + a) : r.stack = a;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(n, e) {
    typeof n == "string" ? (e = e || {}, e.url = n) : e = n || {}, e = Ft(this.defaults, e);
    const { transitional: r, paramsSerializer: o, headers: a } = e;
    r !== void 0 && Yn.assertOptions(r, {
      silentJSONParsing: gt.transitional(gt.boolean),
      forcedJSONParsing: gt.transitional(gt.boolean),
      clarifyTimeoutError: gt.transitional(gt.boolean)
    }, !1), o != null && (E.isFunction(o) ? e.paramsSerializer = {
      serialize: o
    } : Yn.assertOptions(o, {
      encode: gt.function,
      serialize: gt.function
    }, !0)), e.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? e.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : e.allowAbsoluteUrls = !0), Yn.assertOptions(e, {
      baseUrl: gt.spelling("baseURL"),
      withXsrfToken: gt.spelling("withXSRFToken")
    }, !0), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let s = a && E.merge(
      a.common,
      a[e.method]
    );
    a && E.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete a[h];
      }
    ), e.headers = Ve.concat(s, a);
    const i = [];
    let l = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(e) === !1 || (l = l && y.synchronous, i.unshift(y.fulfilled, y.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(y) {
      u.push(y.fulfilled, y.rejected);
    });
    let c, d = 0, f;
    if (!l) {
      const h = [ea.bind(this), void 0];
      for (h.unshift.apply(h, i), h.push.apply(h, u), f = h.length, c = Promise.resolve(e); d < f; )
        c = c.then(h[d++], h[d++]);
      return c;
    }
    f = i.length;
    let g = e;
    for (d = 0; d < f; ) {
      const h = i[d++], y = i[d++];
      try {
        g = h(g);
      } catch (w) {
        y.call(this, w);
        break;
      }
    }
    try {
      c = ea.call(this, g);
    } catch (h) {
      return Promise.reject(h);
    }
    for (d = 0, f = u.length; d < f; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(n) {
    n = Ft(this.defaults, n);
    const e = os(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Qa(e, n.params, n.paramsSerializer);
  }
};
E.forEach(["delete", "get", "head", "options"], function(n) {
  Lt.prototype[n] = function(e, r) {
    return this.request(Ft(r || {}, {
      method: n,
      url: e,
      data: (r || {}).data
    }));
  };
});
E.forEach(["post", "put", "patch"], function(n) {
  function e(r) {
    return function(a, s, i) {
      return this.request(Ft(i || {}, {
        method: n,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: s
      }));
    };
  }
  Lt.prototype[n] = e(), Lt.prototype[n + "Form"] = e(!0);
});
let Su = class cs {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let e;
    this.promise = new Promise(function(a) {
      e = a;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let a = r._listeners.length;
      for (; a-- > 0; )
        r._listeners[a](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const s = new Promise((i) => {
        r.subscribe(i), a = i;
      }).then(o);
      return s.cancel = function() {
        r.unsubscribe(a);
      }, s;
    }, n(function(a, s, i) {
      r.reason || (r.reason = new Qt(a, s, i), e(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const e = this._listeners.indexOf(n);
    e !== -1 && this._listeners.splice(e, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), e = (r) => {
      n.abort(r);
    };
    return this.subscribe(e), n.signal.unsubscribe = () => this.unsubscribe(e), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new cs(function(o) {
        n = o;
      }),
      cancel: n
    };
  }
};
function $u(t) {
  return function(e) {
    return t.apply(null, e);
  };
}
function Tu(t) {
  return E.isObject(t) && t.isAxiosError === !0;
}
const Xr = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Xr).forEach(([t, n]) => {
  Xr[n] = t;
});
function ds(t) {
  const n = new Lt(t), e = Ha(Lt.prototype.request, n);
  return E.extend(e, Lt.prototype, n, { allOwnKeys: !0 }), E.extend(e, n, null, { allOwnKeys: !0 }), e.create = function(o) {
    return ds(Ft(t, o));
  }, e;
}
const me = ds(En);
me.Axios = Lt;
me.CanceledError = Qt;
me.CancelToken = Su;
me.isCancel = ns;
me.VERSION = us;
me.toFormData = fr;
me.AxiosError = z;
me.Cancel = me.CanceledError;
me.all = function(n) {
  return Promise.all(n);
};
me.spread = $u;
me.isAxiosError = Tu;
me.mergeConfig = Ft;
me.AxiosHeaders = Ve;
me.formToJSON = (t) => ts(E.isHTMLForm(t) ? new FormData(t) : t);
me.getAdapter = ls.getAdapter;
me.HttpStatusCode = Xr;
me.default = me;
const {
  Axios: s0,
  AxiosError: i0,
  CanceledError: l0,
  isCancel: u0,
  CancelToken: c0,
  VERSION: d0,
  all: f0,
  Cancel: p0,
  isAxiosError: m0,
  spread: h0,
  toFormData: g0,
  AxiosHeaders: v0,
  HttpStatusCode: b0,
  formToJSON: y0,
  getAdapter: w0,
  mergeConfig: x0
} = me, fs = "HttpError", ps = "HttpErrorCanceled";
class zn extends Error {
  constructor(e, r, o, a) {
    super(e || "");
    /**
     * The http response body.
     */
    Or(this, "response");
    /**
     * The http response status code.
     */
    Or(this, "status");
    this.name = a || fs, this.status = r || 0, this.response = o;
  }
}
function Mu() {
  const t = A(0), n = A(!1), e = A(0), r = A([]), o = A(""), a = A(!1);
  return {
    idx: t,
    loading: n,
    maxIdx: e,
    messages: r,
    msg: o,
    showMsg: a,
    show: (l = []) => {
      l && (r.value = l, e.value = l.length - 1, o.value = r.value[t.value], a.value = !0), n.value = !0;
    },
    hide: () => {
      t.value = 0, e.value = 0, r.value = [], o.value = "", n.value = !1;
    }
  };
}
let Nr;
function ms() {
  return Nr === void 0 && (Nr = Mu()), Nr;
}
const na = (() => {
  const { show: t, hide: n } = ms();
  return { show: t, hide: n };
})(), Pu = (t) => {
  const n = t.withDelay || 0;
  return new Promise((e) => {
    setTimeout(() => {
      e(t);
    }, Math.max(n, 0));
  });
}, Xn = me.create({
  baseURL: "/api/v1",
  paramsSerializer: {
    indexes: null
    // array indexes format (null - no brackets, false (default) - empty brackets, true - brackets with indexes)
  },
  responseType: "json",
  withCredentials: !0
});
Xn.interceptors.request.use(Pu);
const Ht = (t, n) => {
  const e = {
    skipLoader: !1,
    ...n
  }, r = window.setTimeout(() => {
    e.skipLoader !== !0 && na.show();
  }, 200);
  return Xn({ ...t, ...n }).then((o) => o.data).catch((o) => {
    var a, s;
    throw me.isAxiosError(o) ? new zn(
      o.message,
      (a = o.response) == null ? void 0 : a.status,
      (s = o.response) == null ? void 0 : s.data,
      me.isCancel(o) ? ps : fs
    ) : o instanceof Error ? new zn(o.message, 0) : new zn("An unknown error has occurred.", 0);
  }).finally(() => {
    e.skipLoader !== !0 && na.hide(), window.clearTimeout(r);
  });
}, hs = {
  delete(t, n) {
    return Ht({ url: t, method: "DELETE" }, n || {});
  },
  get(t, n, e) {
    return Ht({ url: t, method: "GET", params: e }, n || {});
  },
  patch(t, n, e) {
    return Ht({ url: t, data: n, method: "PATCH" }, e || {});
  },
  post(t, n, e) {
    return Ht({ url: t, data: n, method: "POST" }, e || {});
  },
  put(t, n, e) {
    return Ht(
      {
        url: t,
        data: n,
        method: "PUT"
      },
      e || {}
    );
  }
}, C0 = (t) => {
  Xn.defaults = { ...Xn.defaults, ...t };
}, Au = (t) => t instanceof zn, Ou = (t) => Au(t) && t.name === ps;
function Kn(t, n = 500) {
  let e = null;
  return function(...r) {
    e && clearTimeout(e), e = setTimeout(() => {
      t(...r);
    }, n);
  };
}
function D0(t, n = 500) {
  let e = null;
  return (...r) => {
    e ? clearTimeout(e) : t.apply(r), e = setTimeout(() => {
      e = null;
    }, n);
  };
}
const dt = {
  help: "",
  label: "",
  modelValue: void 0,
  placeholder: ""
}, de = {
  default: void 0,
  required: !1
}, E0 = [
  "date",
  "email",
  "month",
  "number",
  // DEPRECATED
  "password",
  "search",
  "tel",
  "text",
  "time",
  "url",
  "week"
], _0 = ["money", "number", "raw-number"], ft = (t) => {
  const n = ir(), e = A(""), r = Ui(), o = P(() => n.id || r), a = P(() => Zr(n, "disabled")), s = P(() => Zr(n, "required")), i = P(() => typeof n.name == "string" && n.name !== "" ? n.name : o.value), l = P(() => ({
    labelledby: t.label ? `${o.value}-label` : void 0,
    describedby: t.help ? `${o.value}-help` : void 0,
    errormessage: e.value ? `${o.value}-error` : void 0
  })), u = (f) => {
    f.type === "invalid" && (e.value = f.target.validationMessage);
  }, c = (f) => {
    if (!e.value)
      return;
    const g = f.target;
    g.checkValidity() ? e.value = "" : e.value = g.validationMessage;
  }, d = Kn(c, 350);
  return {
    aria: l,
    attrs: n,
    inputID: o,
    isDisabled: a,
    isRequired: s,
    nameAttr: i,
    errorState: e,
    onInvalid: u,
    validate: c,
    inputValidation: d
  };
}, Zr = (t, n) => t[n] !== void 0 && t[n] !== null && t[n] !== !1 && t[n] !== 0, Ru = String.raw`^\w+([\-+.']\w+)*@\w+([\-.]\w+)*\.\w+([\-.]\w+)*$`, Iu = String.raw`[0-9]{10}|[0-9]{3}-[0-9]{3}-[0-9]{4}`, Lu = String.raw`^(?:https|http):\/\/[^ ]+$`, ra = (t) => {
  const n = parseFloat(t);
  return isNaN(n) ? t : n;
}, oa = (t) => {
  if (typeof t != "string" || t === "")
    return "";
  const n = new Date(t);
  return n.setMinutes(n.getMinutes() - n.getTimezoneOffset()), n.toISOString().slice(0, 16);
};
function k0(t, n = 100) {
  let e;
  return (...r) => {
    e || (t.apply(r), e = !0, setTimeout(() => e = !1, n));
  };
}
function se() {
  return se = Object.assign || function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, se.apply(this, arguments);
}
function pt(t, n) {
  if (t == null) return {};
  var e = {}, r = Object.keys(t), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(n.indexOf(o) >= 0) && (e[o] = t[o]);
  return e;
}
function Nu(t, n) {
  if (t) {
    if (typeof t == "string") return aa(t, n);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return aa(t, n);
  }
}
function aa(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var e = 0, r = new Array(n); e < n; e++) r[e] = t[e];
  return r;
}
function vt(t, n) {
  var e;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (e = Nu(t)) || n) {
      e && (t = e);
      var r = 0;
      return function() {
        return r >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[r++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return e = t[Symbol.iterator](), e.next.bind(e);
}
function Ue(t, n) {
  if (t in n) {
    for (var e = n[t], r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
      o[a - 2] = arguments[a];
    return typeof e == "function" ? e.apply(void 0, o) : e;
  }
  var s = new Error('Tried to handle "' + t + '" but there is no handler defined. Only defined handlers are: ' + Object.keys(n).map(function(i) {
    return '"' + i + '"';
  }).join(", ") + ".");
  throw Error.captureStackTrace && Error.captureStackTrace(s, Ue), s;
}
var He;
(function(t) {
  t[t.None = 0] = "None", t[t.RenderStrategy = 1] = "RenderStrategy", t[t.Static = 2] = "Static";
})(He || (He = {}));
var ze;
(function(t) {
  t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden";
})(ze || (ze = {}));
function fe(t) {
  var n = t.visible, e = n === void 0 ? !0 : n, r = t.features, o = r === void 0 ? He.None : r, a = pt(t, ["visible", "features"]);
  if (e || o & He.Static && a.props.static)
    return Fn(a);
  if (o & He.RenderStrategy) {
    var s, i, l = (s = a.props.unmount) == null || s ? ze.Unmount : ze.Hidden;
    return Ue(l, (i = {}, i[ze.Unmount] = function() {
      return null;
    }, i[ze.Hidden] = function() {
      return Fn(se({}, a, {
        props: se({}, a.props, {
          hidden: !0,
          style: {
            display: "none"
          }
        })
      }));
    }, i));
  }
  return Fn(a);
}
function Fn(t) {
  var n = t.props, e = t.attrs, r = t.slots, o = t.slot, a = t.name, s = Fu(n, ["unmount", "static"]), i = s.as, l = pt(s, ["as"]), u = r.default == null ? void 0 : r.default(o);
  if (i === "template") {
    if (Object.keys(l).length > 0 || Object.keys(e).length > 0) {
      var c = u ?? [], d = c[0], f = c.slice(1);
      if (!Bu(d) || f.length > 0)
        throw new Error(['Passing props on "template"!', "", "The current component <" + a + ' /> is rendering a "template".', "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(e)).map(function(g) {
          return "  - " + g;
        }).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map(function(g) {
          return "  - " + g;
        }).join(`
`)].join(`
`));
      return qi(d, l);
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return _t(i, l, u);
}
function Fu(t, n) {
  n === void 0 && (n = []);
  for (var e = Object.assign({}, t), r = vt(n), o; !(o = r()).done; ) {
    var a = o.value;
    a in e && delete e[a];
  }
  return e;
}
function Bu(t) {
  return t == null ? !1 : typeof t.type == "string" || typeof t.type == "object" || typeof t.type == "function";
}
var gs = /* @__PURE__ */ Symbol("StackContext"), Kt;
(function(t) {
  t[t.AddElement = 0] = "AddElement", t[t.RemoveElement = 1] = "RemoveElement";
})(Kt || (Kt = {}));
function vs() {
  return Ee(gs, function() {
  });
}
function ju(t) {
  var n = vs();
  De(function(e) {
    var r = t == null ? void 0 : t.value;
    r && (n(Kt.AddElement, r), e(function() {
      return n(Kt.RemoveElement, r);
    }));
  });
}
function bs(t) {
  var n = vs();
  function e() {
    for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++)
      o[a] = arguments[a];
    t == null || t.apply(void 0, o), n.apply(void 0, o);
  }
  Se(gs, e);
}
var ys = /* @__PURE__ */ Symbol("ForcePortalRootContext");
function Vu() {
  return Ee(ys, !1);
}
var sa = /* @__PURE__ */ R({
  name: "ForcePortalRoot",
  props: {
    as: {
      type: [Object, String],
      default: "template"
    },
    force: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(n, e) {
    var r = e.slots, o = e.attrs;
    return Se(ys, n.force), function() {
      var a = pt(n, ["force"]);
      return fe({
        props: a,
        slot: {},
        slots: r,
        attrs: o,
        name: "ForcePortalRoot"
      });
    };
  }
});
function ia() {
  var t = document.getElementById("headlessui-portal-root");
  if (t) return t;
  var n = document.createElement("div");
  return n.setAttribute("id", "headlessui-portal-root"), document.body.appendChild(n);
}
var ho = /* @__PURE__ */ R({
  name: "Portal",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    }
  },
  setup: function(n, e) {
    var r = e.slots, o = e.attrs, a = Vu(), s = Ee(ws, null), i = A(a === !0 || s === null ? ia() : s.resolveTarget());
    De(function() {
      a || s !== null && (i.value = s.resolveTarget());
    });
    var l = A(null);
    return ju(l), yt(function() {
      var u = document.getElementById("headlessui-portal-root");
      if (u && i.value === u && i.value.children.length <= 0) {
        var c;
        (c = i.value.parentElement) == null || c.removeChild(i.value);
      }
    }), bs(), function() {
      if (i.value === null) return null;
      var u = {
        ref: l
      };
      return _t(
        // @ts-expect-error Children can be an object, but TypeScript is not happy
        // with it. Once this is fixed upstream we can remove this assertion.
        Wi,
        {
          to: i.value
        },
        fe({
          props: se({}, n, u),
          slot: {},
          attrs: o,
          slots: r,
          name: "Portal"
        })
      );
    };
  }
}), ws = /* @__PURE__ */ Symbol("PortalGroupContext"), Hu = /* @__PURE__ */ R({
  name: "PortalGroup",
  props: {
    as: {
      type: [Object, String],
      default: "template"
    },
    target: {
      type: Object,
      default: null
    }
  },
  setup: function(n, e) {
    var r = e.attrs, o = e.slots, a = Yi({
      resolveTarget: function() {
        return n.target;
      }
    });
    return Se(ws, a), function() {
      var s = pt(n, ["target"]);
      return fe({
        props: s,
        slot: {},
        attrs: r,
        slots: o,
        name: "PortalGroup"
      });
    };
  }
}), Y;
(function(t) {
  t.Space = " ", t.Enter = "Enter", t.Escape = "Escape", t.Backspace = "Backspace", t.ArrowLeft = "ArrowLeft", t.ArrowUp = "ArrowUp", t.ArrowRight = "ArrowRight", t.ArrowDown = "ArrowDown", t.Home = "Home", t.End = "End", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Tab = "Tab";
})(Y || (Y = {}));
var Uu = 0;
function qu() {
  return ++Uu;
}
function Oe() {
  return qu();
}
function bt(t, n, e) {
  typeof window > "u" || De(function(r) {
    window.addEventListener(t, n, e), r(function() {
      window.removeEventListener(t, n, e);
    });
  });
}
function Qr(t, n) {
  for (var e = vt(t), r; !(r = e()).done; ) {
    var o = r.value;
    if (o.contains(n)) return !0;
  }
  return !1;
}
var eo = /* @__PURE__ */ ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(process.env.NODE_ENV === "test" ? (
  // TODO: Remove this once JSDOM fixes the issue where an element that is
  // "hidden" can be the document.activeElement, because this is not possible
  // in real browsers.
  // TODO: Remove this once JSDOM fixes the issue where an element that is
  function(t) {
    return t + ":not([tabindex='-1']):not([style*='display: none'])";
  }
) : function(t) {
  return t + ":not([tabindex='-1'])";
}).join(","), oe;
(function(t) {
  t[t.First = 1] = "First", t[t.Previous = 2] = "Previous", t[t.Next = 4] = "Next", t[t.Last = 8] = "Last", t[t.WrapAround = 16] = "WrapAround", t[t.NoScroll = 32] = "NoScroll";
})(oe || (oe = {}));
var Ke;
(function(t) {
  t[t.Error = 0] = "Error", t[t.Overflow = 1] = "Overflow", t[t.Success = 2] = "Success", t[t.Underflow = 3] = "Underflow";
})(Ke || (Ke = {}));
var Zn;
(function(t) {
  t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next";
})(Zn || (Zn = {}));
function Qn(t) {
  return t === void 0 && (t = document.body), t == null ? [] : Array.from(t.querySelectorAll(eo));
}
var qt;
(function(t) {
  t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose";
})(qt || (qt = {}));
function Wu(t, n) {
  var e;
  return n === void 0 && (n = qt.Strict), t === document.body ? !1 : Ue(n, (e = {}, e[qt.Strict] = function() {
    return t.matches(eo);
  }, e[qt.Loose] = function() {
    for (var r = t; r !== null; ) {
      if (r.matches(eo)) return !0;
      r = r.parentElement;
    }
    return !1;
  }, e));
}
function dn(t) {
  t == null || t.focus({
    preventScroll: !0
  });
}
function st(t, n) {
  var e = Array.isArray(t) ? t : Qn(t), r = document.activeElement, o = function() {
    if (n & (oe.First | oe.Next)) return Zn.Next;
    if (n & (oe.Previous | oe.Last)) return Zn.Previous;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  }(), a = function() {
    if (n & oe.First) return 0;
    if (n & oe.Previous) return Math.max(0, e.indexOf(r)) - 1;
    if (n & oe.Next) return Math.max(0, e.indexOf(r)) + 1;
    if (n & oe.Last) return e.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  }(), s = n & oe.NoScroll ? {
    preventScroll: !0
  } : {}, i = 0, l = e.length, u = void 0;
  do {
    var c;
    if (i >= l || i + l <= 0) return Ke.Error;
    var d = a + i;
    if (n & oe.WrapAround)
      d = (d + l) % l;
    else {
      if (d < 0) return Ke.Underflow;
      if (d >= l) return Ke.Overflow;
    }
    u = e[d], (c = u) == null || c.focus(s), i += o;
  } while (u !== document.activeElement);
  return u.hasAttribute("tabindex") || u.setAttribute("tabindex", "0"), Ke.Success;
}
function Yu(t, n, e) {
  n === void 0 && (n = A(!0)), e === void 0 && (e = A({}));
  var r = A(typeof window < "u" ? document.activeElement : null), o = A(null);
  function a() {
    if (n.value && t.value.size === 1) {
      var i = e.value.initialFocus, l = document.activeElement;
      if (i) {
        if (i === l)
          return;
      } else if (Qr(t.value, l))
        return;
      if (r.value = l, i)
        dn(i);
      else {
        for (var u = !1, c = vt(t.value), d; !(d = c()).done; ) {
          var f = d.value, g = st(f, oe.First);
          if (g === Ke.Success) {
            u = !0;
            break;
          }
        }
        u || console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      o.value = document.activeElement;
    }
  }
  function s() {
    dn(r.value), r.value = null, o.value = null;
  }
  De(a), Fa(function() {
    n.value ? a() : s();
  }), yt(s), bt("keydown", function(i) {
    if (n.value && i.key === Y.Tab && document.activeElement && t.value.size === 1) {
      i.preventDefault();
      for (var l = vt(t.value), u; !(u = l()).done; ) {
        var c = u.value, d = st(c, (i.shiftKey ? oe.Previous : oe.Next) | oe.WrapAround);
        if (d === Ke.Success) {
          o.value = document.activeElement;
          break;
        }
      }
    }
  }), bt("focus", function(i) {
    if (n.value && t.value.size === 1) {
      var l = o.value;
      if (l) {
        var u = i.target;
        u && u instanceof HTMLElement ? Qr(t.value, u) ? (o.value = u, dn(u)) : (i.preventDefault(), i.stopPropagation(), dn(l)) : dn(o.value);
      }
    }
  }, !0);
}
var la = process.env.NODE_ENV === "test" ? '[data-v-app=""] > *' : "body > *", Vt = /* @__PURE__ */ new Set(), Dt = /* @__PURE__ */ new Map();
function ua(t) {
  t.setAttribute("aria-hidden", "true"), t.inert = !0;
}
function ca(t) {
  var n = Dt.get(t);
  n && (n["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", n["aria-hidden"]), t.inert = n.inert);
}
function zu(t, n) {
  n === void 0 && (n = A(!0)), De(function(e) {
    if (n.value && t.value) {
      var r = t.value;
      Vt.add(r);
      for (var o = vt(Dt.keys()), a; !(a = o()).done; ) {
        var s = a.value;
        s.contains(r) && (ca(s), Dt.delete(s));
      }
      document.querySelectorAll(la).forEach(function(i) {
        if (i instanceof HTMLElement) {
          for (var l = vt(Vt), u; !(u = l()).done; ) {
            var c = u.value;
            if (i.contains(c)) return;
          }
          Vt.size === 1 && (Dt.set(i, {
            "aria-hidden": i.getAttribute("aria-hidden"),
            // @ts-expect-error `inert` does not exist on HTMLElement (yet!)
            inert: i.inert
          }), ua(i));
        }
      }), e(function() {
        if (Vt.delete(r), Vt.size > 0)
          document.querySelectorAll(la).forEach(function(c) {
            if (c instanceof HTMLElement && !Dt.has(c)) {
              for (var d = vt(Vt), f; !(f = d()).done; ) {
                var g = f.value;
                if (c.contains(g)) return;
              }
              Dt.set(c, {
                "aria-hidden": c.getAttribute("aria-hidden"),
                // @ts-expect-error `inert` does not exist on HTMLElement (yet!)
                inert: c.inert
              }), ua(c);
            }
          });
        else
          for (var i = vt(Dt.keys()), l; !(l = i()).done; ) {
            var u = l.value;
            ca(u), Dt.delete(u);
          }
      });
    }
  });
}
var xs = /* @__PURE__ */ Symbol("DescriptionContext");
function Ku() {
  var t = Ee(xs, null);
  if (t === null)
    throw new Error("Missing parent");
  return t;
}
function hr(t) {
  var n = t === void 0 ? {} : t, e = n.slot, r = e === void 0 ? A({}) : e, o = n.name, a = o === void 0 ? "Description" : o, s = n.props, i = s === void 0 ? {} : s, l = A([]);
  function u(c) {
    return l.value.push(c), function() {
      var d = l.value.indexOf(c);
      d !== -1 && l.value.splice(d, 1);
    };
  }
  return Se(xs, {
    register: u,
    slot: r,
    name: a,
    props: i
  }), P(function() {
    return l.value.length > 0 ? l.value.join(" ") : void 0;
  });
}
var Cs = /* @__PURE__ */ R({
  name: "Description",
  props: {
    as: {
      type: [Object, String],
      default: "p"
    }
  },
  render: function() {
    var n = this.context, e = n.name, r = e === void 0 ? "Description" : e, o = n.slot, a = o === void 0 ? A({}) : o, s = n.props, i = s === void 0 ? {} : s, l = this.$props, u = se({}, Object.entries(i).reduce(function(c, d) {
      var f, g = d[0], h = d[1];
      return Object.assign(c, (f = {}, f[g] = m(h), f));
    }, {}), {
      id: this.id
    });
    return fe({
      props: se({}, l, u),
      slot: a.value,
      attrs: this.$attrs,
      slots: this.$slots,
      name: r
    });
  },
  setup: function() {
    var n = Ku(), e = "headlessui-description-" + Oe();
    return je(function() {
      return yt(n.register(e));
    }), {
      id: e,
      context: n
    };
  }
});
function I(t) {
  var n;
  return t == null || t.value == null ? null : (n = t.value.$el) != null ? n : t.value;
}
var Ds = /* @__PURE__ */ Symbol("Context"), Ce;
(function(t) {
  t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed";
})(Ce || (Ce = {}));
function Gu() {
  return en() !== null;
}
function en() {
  return Ee(Ds, null);
}
function gr(t) {
  Se(Ds, t);
}
var Le;
(function(t) {
  t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed";
})(Le || (Le = {}));
var Es = /* @__PURE__ */ Symbol("DialogContext");
function bn(t) {
  var n = Ee(Es, null);
  if (n === null) {
    var e = new Error("<" + t + " /> is missing a parent <Dialog /> component.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, bn), e;
  }
  return n;
}
var Bn = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", vr = /* @__PURE__ */ R({
  name: "Dialog",
  inheritAttrs: !1,
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    static: {
      type: Boolean,
      default: !1
    },
    unmount: {
      type: Boolean,
      default: !0
    },
    open: {
      type: [Boolean, String],
      default: Bn
    },
    initialFocus: {
      type: Object,
      default: null
    }
  },
  emits: {
    close: function(n) {
      return !0;
    }
  },
  render: function() {
    var n = this, e = se({}, this.$attrs, {
      ref: "el",
      id: this.id,
      role: "dialog",
      "aria-modal": this.dialogState === Le.Open ? !0 : void 0,
      "aria-labelledby": this.titleId,
      "aria-describedby": this.describedby,
      onClick: this.handleClick
    }), r = this.$props, o = pt(r, ["open", "initialFocus"]), a = {
      open: this.dialogState === Le.Open
    };
    return _t(sa, {
      force: !0
    }, function() {
      return _t(ho, function() {
        return _t(Hu, {
          target: n.dialogRef
        }, function() {
          return _t(sa, {
            force: !1
          }, function() {
            return fe({
              props: se({}, o, e),
              slot: a,
              attrs: n.$attrs,
              slots: n.$slots,
              visible: n.visible,
              features: He.RenderStrategy | He.Static,
              name: "Dialog"
            });
          });
        });
      });
    });
  },
  setup: function(n, e) {
    var r = e.emit, o = A(/* @__PURE__ */ new Set()), a = en(), s = P(function() {
      if (n.open === Bn && a !== null) {
        var D;
        return Ue(a.value, (D = {}, D[Ce.Open] = !0, D[Ce.Closed] = !1, D));
      }
      return n.open;
    }), i = n.open !== Bn || a !== null;
    if (!i)
      throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
    if (typeof s.value != "boolean")
      throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: " + (s.value === Bn ? void 0 : n.open));
    var l = P(function() {
      return n.open ? Le.Open : Le.Closed;
    }), u = P(function() {
      return a !== null ? a.value === Ce.Open : l.value === Le.Open;
    }), c = A(null), d = A(l.value === Le.Open);
    Fa(function() {
      d.value = l.value === Le.Open;
    });
    var f = "headlessui-dialog-" + Oe(), g = P(function() {
      return {
        initialFocus: n.initialFocus
      };
    });
    Yu(o, d, g), zu(c, d), bs(function(D, T) {
      var M;
      return Ue(D, (M = {}, M[Kt.AddElement] = function() {
        o.value.add(T);
      }, M[Kt.RemoveElement] = function() {
        o.value.delete(T);
      }, M));
    });
    var h = hr({
      name: "DialogDescription",
      slot: P(function() {
        return {
          open: s.value
        };
      })
    }), y = A(null), w = {
      titleId: y,
      dialogState: l,
      setTitleId: function(T) {
        y.value !== T && (y.value = T);
      },
      close: function() {
        r("close", !1);
      }
    };
    return Se(Es, w), bt("mousedown", function(D) {
      var T = D.target;
      l.value === Le.Open && o.value.size === 1 && (Qr(o.value, T) || (w.close(), kt(function() {
        return T == null ? void 0 : T.focus();
      })));
    }), bt("keydown", function(D) {
      D.key === Y.Escape && l.value === Le.Open && (o.value.size > 1 || (D.preventDefault(), D.stopPropagation(), w.close()));
    }), De(function(D) {
      if (l.value === Le.Open) {
        var T = document.documentElement.style.overflow, M = document.documentElement.style.paddingRight, K = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.overflow = "hidden", document.documentElement.style.paddingRight = K + "px", D(function() {
          document.documentElement.style.overflow = T, document.documentElement.style.paddingRight = M;
        });
      }
    }), De(function(D) {
      if (l.value === Le.Open) {
        var T = I(c);
        if (T) {
          var M = new IntersectionObserver(function(K) {
            for (var q = vt(K), Z; !(Z = q()).done; ) {
              var H = Z.value;
              H.boundingClientRect.x === 0 && H.boundingClientRect.y === 0 && H.boundingClientRect.width === 0 && H.boundingClientRect.height === 0 && w.close();
            }
          });
          M.observe(T), D(function() {
            return M.disconnect();
          });
        }
      }
    }), {
      id: f,
      el: c,
      dialogRef: c,
      containers: o,
      dialogState: l,
      titleId: y,
      describedby: h,
      visible: u,
      open: s,
      handleClick: function(T) {
        T.stopPropagation();
      }
    };
  }
}), br = /* @__PURE__ */ R({
  name: "DialogOverlay",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    }
  },
  render: function() {
    var n = bn("DialogOverlay"), e = {
      ref: "el",
      id: this.id,
      "aria-hidden": !0,
      onClick: this.handleClick
    }, r = this.$props;
    return fe({
      props: se({}, r, e),
      slot: {
        open: n.dialogState.value === Le.Open
      },
      attrs: this.$attrs,
      slots: this.$slots,
      name: "DialogOverlay"
    });
  },
  setup: function() {
    var n = bn("DialogOverlay"), e = "headlessui-dialog-overlay-" + Oe();
    return {
      id: e,
      handleClick: function(o) {
        o.target === o.currentTarget && (o.preventDefault(), o.stopPropagation(), n.close());
      }
    };
  }
}), go = /* @__PURE__ */ R({
  name: "DialogTitle",
  props: {
    as: {
      type: [Object, String],
      default: "h2"
    }
  },
  render: function() {
    var n = bn("DialogTitle"), e = {
      id: this.id
    }, r = this.$props;
    return fe({
      props: se({}, r, e),
      slot: {
        open: n.dialogState.value === Le.Open
      },
      attrs: this.$attrs,
      slots: this.$slots,
      name: "DialogTitle"
    });
  },
  setup: function() {
    var n = bn("DialogTitle"), e = "headlessui-dialog-title-" + Oe();
    return je(function() {
      n.setTitleId(e), yt(function() {
        return n.setTitleId(null);
      });
    }), {
      id: e
    };
  }
});
function da(t, n) {
  if (t) return t;
  var e = n ?? "button";
  if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function yr(t, n) {
  var e = A(da(t.value.type, t.value.as));
  return je(function() {
    e.value = da(t.value.type, t.value.as);
  }), De(function() {
    var r;
    e.value || I(n) && I(n) instanceof HTMLButtonElement && !((r = I(n)) != null && r.hasAttribute("type")) && (e.value = "button");
  }), e;
}
var ke;
(function(t) {
  t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed";
})(ke || (ke = {}));
var _s = /* @__PURE__ */ Symbol("DisclosureContext");
function yn(t) {
  var n = Ee(_s, null);
  if (n === null) {
    var e = new Error("<" + t + " /> is missing a parent <Disclosure /> component.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, yn), e;
  }
  return n;
}
var ks = /* @__PURE__ */ Symbol("DisclosurePanelContext");
function Ju() {
  return Ee(ks, null);
}
var Xu = /* @__PURE__ */ R({
  name: "Disclosure",
  props: {
    as: {
      type: [Object, String],
      default: "template"
    },
    defaultOpen: {
      type: [Boolean],
      default: !1
    }
  },
  setup: function(n, e) {
    var r = e.slots, o = e.attrs, a = "headlessui-disclosure-button-" + Oe(), s = "headlessui-disclosure-panel-" + Oe(), i = A(n.defaultOpen ? ke.Open : ke.Closed), l = A(null), u = A(null), c = {
      buttonId: a,
      panelId: s,
      disclosureState: i,
      panel: l,
      button: u,
      toggleDisclosure: function() {
        var f;
        i.value = Ue(i.value, (f = {}, f[ke.Open] = ke.Closed, f[ke.Closed] = ke.Open, f));
      },
      closeDisclosure: function() {
        i.value !== ke.Closed && (i.value = ke.Closed);
      },
      close: function(f) {
        c.closeDisclosure();
        var g = function() {
          return f ? f instanceof HTMLElement ? f : f.value instanceof HTMLElement ? I(f) : I(c.button) : I(c.button);
        }();
        g == null || g.focus();
      }
    };
    return Se(_s, c), gr(P(function() {
      var d;
      return Ue(i.value, (d = {}, d[ke.Open] = Ce.Open, d[ke.Closed] = Ce.Closed, d));
    })), function() {
      var d = pt(n, ["defaultOpen"]), f = {
        open: i.value === ke.Open,
        close: c.close
      };
      return fe({
        props: d,
        slot: f,
        slots: r,
        attrs: o,
        name: "Disclosure"
      });
    };
  }
}), Zu = /* @__PURE__ */ R({
  name: "DisclosureButton",
  props: {
    as: {
      type: [Object, String],
      default: "button"
    },
    disabled: {
      type: [Boolean],
      default: !1
    }
  },
  render: function() {
    var n = yn("DisclosureButton"), e = {
      open: n.disclosureState.value === ke.Open
    }, r = this.isWithinPanel ? {
      ref: "el",
      type: this.type,
      onClick: this.handleClick,
      onKeydown: this.handleKeyDown
    } : {
      id: this.id,
      ref: "el",
      type: this.type,
      "aria-expanded": this.$props.disabled ? void 0 : n.disclosureState.value === ke.Open,
      "aria-controls": I(n.panel) ? n.panelId : void 0,
      disabled: this.$props.disabled ? !0 : void 0,
      onClick: this.handleClick,
      onKeydown: this.handleKeyDown,
      onKeyup: this.handleKeyUp
    };
    return fe({
      props: se({}, this.$props, r),
      slot: e,
      attrs: this.$attrs,
      slots: this.$slots,
      name: "DisclosureButton"
    });
  },
  setup: function(n, e) {
    var r = e.attrs, o = yn("DisclosureButton"), a = Ju(), s = a === null ? !1 : a === o.panelId, i = A(null);
    return s || De(function() {
      o.button.value = i.value;
    }), {
      isWithinPanel: s,
      id: o.buttonId,
      el: i,
      type: yr(P(function() {
        return {
          as: n.as,
          type: r.type
        };
      }), i),
      handleClick: function() {
        if (!n.disabled)
          if (s) {
            var u;
            o.toggleDisclosure(), (u = I(o.button)) == null || u.focus();
          } else
            o.toggleDisclosure();
      },
      handleKeyDown: function(u) {
        var c;
        if (!n.disabled)
          if (s)
            switch (u.key) {
              case Y.Space:
              case Y.Enter:
                u.preventDefault(), u.stopPropagation(), o.toggleDisclosure(), (c = I(o.button)) == null || c.focus();
                break;
            }
          else
            switch (u.key) {
              case Y.Space:
              case Y.Enter:
                u.preventDefault(), u.stopPropagation(), o.toggleDisclosure();
                break;
            }
      },
      handleKeyUp: function(u) {
        switch (u.key) {
          case Y.Space:
            u.preventDefault();
            break;
        }
      }
    };
  }
}), Qu = /* @__PURE__ */ R({
  name: "DisclosurePanel",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    static: {
      type: Boolean,
      default: !1
    },
    unmount: {
      type: Boolean,
      default: !0
    }
  },
  render: function() {
    var n = yn("DisclosurePanel"), e = {
      open: n.disclosureState.value === ke.Open,
      close: n.close
    }, r = {
      id: this.id,
      ref: "el"
    };
    return fe({
      props: se({}, this.$props, r),
      slot: e,
      attrs: this.$attrs,
      slots: this.$slots,
      features: He.RenderStrategy | He.Static,
      visible: this.visible,
      name: "DisclosurePanel"
    });
  },
  setup: function() {
    var n = yn("DisclosurePanel");
    Se(ks, n.panelId);
    var e = en(), r = P(function() {
      return e !== null ? e.value === Ce.Open : n.disclosureState.value === ke.Open;
    });
    return {
      id: n.panelId,
      el: n.panel,
      visible: r
    };
  }
});
function ec(t) {
  throw new Error("Unexpected object: " + t);
}
var we;
(function(t) {
  t[t.First = 0] = "First", t[t.Previous = 1] = "Previous", t[t.Next = 2] = "Next", t[t.Last = 3] = "Last", t[t.Specific = 4] = "Specific", t[t.Nothing = 5] = "Nothing";
})(we || (we = {}));
function tc(t, n) {
  var e = n.resolveItems();
  if (e.length <= 0) return null;
  var r = n.resolveActiveIndex(), o = r ?? -1, a = function() {
    switch (t.focus) {
      case we.First:
        return e.findIndex(function(l) {
          return !n.resolveDisabled(l);
        });
      case we.Previous: {
        var s = e.slice().reverse().findIndex(function(l, u, c) {
          return o !== -1 && c.length - u - 1 >= o ? !1 : !n.resolveDisabled(l);
        });
        return s === -1 ? s : e.length - 1 - s;
      }
      case we.Next:
        return e.findIndex(function(l, u) {
          return u <= o ? !1 : !n.resolveDisabled(l);
        });
      case we.Last: {
        var i = e.slice().reverse().findIndex(function(l) {
          return !n.resolveDisabled(l);
        });
        return i === -1 ? i : e.length - 1 - i;
      }
      case we.Specific:
        return e.findIndex(function(l) {
          return n.resolveId(l) === t.id;
        });
      case we.Nothing:
        return null;
      default:
        ec(t);
    }
  }();
  return a === -1 ? r : a;
}
function Ss(t) {
  var n = t.container, e = t.accept, r = t.walk, o = t.enabled;
  De(function() {
    var a = n.value;
    if (a && !(o !== void 0 && !o.value))
      for (var s = Object.assign(function(l) {
        return e(l);
      }, {
        acceptNode: e
      }), i = document.createTreeWalker(a, NodeFilter.SHOW_ELEMENT, s, !1); i.nextNode(); )
        r(i.currentNode);
  });
}
var Pe;
(function(t) {
  t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed";
})(Pe || (Pe = {}));
function nc(t) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(t);
  });
}
var $s = /* @__PURE__ */ Symbol("MenuContext");
function Gt(t) {
  var n = Ee($s, null);
  if (n === null) {
    var e = new Error("<" + t + " /> is missing a parent <Menu /> component.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, Gt), e;
  }
  return n;
}
var vo = /* @__PURE__ */ R({
  name: "Menu",
  props: {
    as: {
      type: [Object, String],
      default: "template"
    }
  },
  setup: function(n, e) {
    var r = e.slots, o = e.attrs, a = A(Pe.Closed), s = A(null), i = A(null), l = A([]), u = A(""), c = A(null), d = {
      menuState: a,
      buttonRef: s,
      itemsRef: i,
      items: l,
      searchQuery: u,
      activeItemIndex: c,
      closeMenu: function() {
        a.value = Pe.Closed, c.value = null;
      },
      openMenu: function() {
        return a.value = Pe.Open;
      },
      goToItem: function(g, h) {
        var y = tc(g === we.Specific ? {
          focus: we.Specific,
          id: h
        } : {
          focus: g
        }, {
          resolveItems: function() {
            return l.value;
          },
          resolveActiveIndex: function() {
            return c.value;
          },
          resolveId: function(D) {
            return D.id;
          },
          resolveDisabled: function(D) {
            return D.dataRef.disabled;
          }
        });
        u.value === "" && c.value === y || (u.value = "", c.value = y);
      },
      search: function(g) {
        u.value += g.toLowerCase();
        var h = l.value.findIndex(function(y) {
          return y.dataRef.textValue.startsWith(u.value) && !y.dataRef.disabled;
        });
        h === -1 || h === c.value || (c.value = h);
      },
      clearSearch: function() {
        u.value = "";
      },
      registerItem: function(g, h) {
        l.value.push({
          id: g,
          dataRef: h
        });
      },
      unregisterItem: function(g) {
        var h = l.value.slice(), y = c.value !== null ? h[c.value] : null, w = h.findIndex(function(D) {
          return D.id === g;
        });
        w !== -1 && h.splice(w, 1), l.value = h, c.value = function() {
          return w === c.value || y === null ? null : h.indexOf(y);
        }();
      }
    };
    return bt("mousedown", function(f) {
      var g, h, y, w = f.target, D = document.activeElement;
      a.value === Pe.Open && ((g = I(s)) != null && g.contains(w) || ((h = I(i)) != null && h.contains(w) || d.closeMenu(), !(D !== document.body && (D != null && D.contains(w))) && (f.defaultPrevented || (y = I(s)) == null || y.focus({
        preventScroll: !0
      }))));
    }), Se($s, d), gr(P(function() {
      var f;
      return Ue(a.value, (f = {}, f[Pe.Open] = Ce.Open, f[Pe.Closed] = Ce.Closed, f));
    })), function() {
      var f = {
        open: a.value === Pe.Open
      };
      return fe({
        props: n,
        slot: f,
        slots: r,
        attrs: o,
        name: "Menu"
      });
    };
  }
}), bo = /* @__PURE__ */ R({
  name: "MenuButton",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [Object, String],
      default: "button"
    }
  },
  render: function() {
    var n, e = Gt("MenuButton"), r = {
      open: e.menuState.value === Pe.Open
    }, o = {
      ref: "el",
      id: this.id,
      type: this.type,
      "aria-haspopup": !0,
      "aria-controls": (n = I(e.itemsRef)) == null ? void 0 : n.id,
      "aria-expanded": this.$props.disabled ? void 0 : e.menuState.value === Pe.Open,
      onKeydown: this.handleKeyDown,
      onKeyup: this.handleKeyUp,
      onClick: this.handleClick
    };
    return fe({
      props: se({}, this.$props, o),
      slot: r,
      attrs: this.$attrs,
      slots: this.$slots,
      name: "MenuButton"
    });
  },
  setup: function(n, e) {
    var r = e.attrs, o = Gt("MenuButton"), a = "headlessui-menu-button-" + Oe();
    function s(u) {
      switch (u.key) {
        // Ref: https://www.w3.org/TR/wai-aria-practices-1.2/#keyboard-interaction-13
        case Y.Space:
        case Y.Enter:
        case Y.ArrowDown:
          u.preventDefault(), u.stopPropagation(), o.openMenu(), kt(function() {
            var c;
            (c = I(o.itemsRef)) == null || c.focus({
              preventScroll: !0
            }), o.goToItem(we.First);
          });
          break;
        case Y.ArrowUp:
          u.preventDefault(), u.stopPropagation(), o.openMenu(), kt(function() {
            var c;
            (c = I(o.itemsRef)) == null || c.focus({
              preventScroll: !0
            }), o.goToItem(we.Last);
          });
          break;
      }
    }
    function i(u) {
      switch (u.key) {
        case Y.Space:
          u.preventDefault();
          break;
      }
    }
    function l(u) {
      n.disabled || (o.menuState.value === Pe.Open ? (o.closeMenu(), kt(function() {
        var c;
        return (c = I(o.buttonRef)) == null ? void 0 : c.focus({
          preventScroll: !0
        });
      })) : (u.preventDefault(), u.stopPropagation(), o.openMenu(), nc(function() {
        var c;
        return (c = I(o.itemsRef)) == null ? void 0 : c.focus({
          preventScroll: !0
        });
      })));
    }
    return {
      id: a,
      el: o.buttonRef,
      type: yr(P(function() {
        return {
          as: n.as,
          type: r.type
        };
      }), o.buttonRef),
      handleKeyDown: s,
      handleKeyUp: i,
      handleClick: l
    };
  }
}), yo = /* @__PURE__ */ R({
  name: "MenuItems",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    static: {
      type: Boolean,
      default: !1
    },
    unmount: {
      type: Boolean,
      default: !0
    }
  },
  render: function() {
    var n, e, r = Gt("MenuItems"), o = {
      open: r.menuState.value === Pe.Open
    }, a = {
      "aria-activedescendant": r.activeItemIndex.value === null || (n = r.items.value[r.activeItemIndex.value]) == null ? void 0 : n.id,
      "aria-labelledby": (e = I(r.buttonRef)) == null ? void 0 : e.id,
      id: this.id,
      onKeydown: this.handleKeyDown,
      onKeyup: this.handleKeyUp,
      role: "menu",
      tabIndex: 0,
      ref: "el"
    }, s = this.$props;
    return fe({
      props: se({}, s, a),
      slot: o,
      attrs: this.$attrs,
      slots: this.$slots,
      features: He.RenderStrategy | He.Static,
      visible: this.visible,
      name: "MenuItems"
    });
  },
  setup: function() {
    var n = Gt("MenuItems"), e = "headlessui-menu-items-" + Oe(), r = A(null);
    Ss({
      container: P(function() {
        return I(n.itemsRef);
      }),
      enabled: P(function() {
        return n.menuState.value === Pe.Open;
      }),
      accept: function(u) {
        return u.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : u.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
      },
      walk: function(u) {
        u.setAttribute("role", "none");
      }
    });
    function o(l) {
      switch (r.value && clearTimeout(r.value), l.key) {
        // Ref: https://www.w3.org/TR/wai-aria-practices-1.2/#keyboard-interaction-12
        // @ts-expect-error Fallthrough is expected here
        case Y.Space:
          if (n.searchQuery.value !== "")
            return l.preventDefault(), l.stopPropagation(), n.search(l.key);
        // When in type ahead mode, fallthrough
        case Y.Enter:
          if (l.preventDefault(), l.stopPropagation(), n.activeItemIndex.value !== null) {
            var u, c = n.items.value[n.activeItemIndex.value].id;
            (u = document.getElementById(c)) == null || u.click();
          }
          n.closeMenu(), kt(function() {
            var d;
            return (d = I(n.buttonRef)) == null ? void 0 : d.focus({
              preventScroll: !0
            });
          });
          break;
        case Y.ArrowDown:
          return l.preventDefault(), l.stopPropagation(), n.goToItem(we.Next);
        case Y.ArrowUp:
          return l.preventDefault(), l.stopPropagation(), n.goToItem(we.Previous);
        case Y.Home:
        case Y.PageUp:
          return l.preventDefault(), l.stopPropagation(), n.goToItem(we.First);
        case Y.End:
        case Y.PageDown:
          return l.preventDefault(), l.stopPropagation(), n.goToItem(we.Last);
        case Y.Escape:
          l.preventDefault(), l.stopPropagation(), n.closeMenu(), kt(function() {
            var d;
            return (d = I(n.buttonRef)) == null ? void 0 : d.focus({
              preventScroll: !0
            });
          });
          break;
        case Y.Tab:
          l.preventDefault(), l.stopPropagation();
          break;
        default:
          l.key.length === 1 && (n.search(l.key), r.value = setTimeout(function() {
            return n.clearSearch();
          }, 350));
          break;
      }
    }
    function a(l) {
      switch (l.key) {
        case Y.Space:
          l.preventDefault();
          break;
      }
    }
    var s = en(), i = P(function() {
      return s !== null ? s.value === Ce.Open : n.menuState.value === Pe.Open;
    });
    return {
      id: e,
      el: n.itemsRef,
      handleKeyDown: o,
      handleKeyUp: a,
      visible: i
    };
  }
}), wo = /* @__PURE__ */ R({
  name: "MenuItem",
  props: {
    as: {
      type: [Object, String],
      default: "template"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(n, e) {
    var r = e.slots, o = e.attrs, a = Gt("MenuItem"), s = "headlessui-menu-item-" + Oe(), i = P(function() {
      return a.activeItemIndex.value !== null ? a.items.value[a.activeItemIndex.value].id === s : !1;
    }), l = A({
      disabled: n.disabled,
      textValue: ""
    });
    je(function() {
      var g, h, y = (g = document.getElementById(s)) == null || (h = g.textContent) == null ? void 0 : h.toLowerCase().trim();
      y !== void 0 && (l.value.textValue = y);
    }), je(function() {
      return a.registerItem(s, l);
    }), yt(function() {
      return a.unregisterItem(s);
    }), De(function() {
      a.menuState.value === Pe.Open && i.value && kt(function() {
        var g;
        return (g = document.getElementById(s)) == null || g.scrollIntoView == null ? void 0 : g.scrollIntoView({
          block: "nearest"
        });
      });
    });
    function u(g) {
      if (n.disabled) return g.preventDefault();
      a.closeMenu(), kt(function() {
        var h;
        return (h = I(a.buttonRef)) == null ? void 0 : h.focus({
          preventScroll: !0
        });
      });
    }
    function c() {
      if (n.disabled) return a.goToItem(we.Nothing);
      a.goToItem(we.Specific, s);
    }
    function d() {
      n.disabled || i.value || a.goToItem(we.Specific, s);
    }
    function f() {
      n.disabled || i.value && a.goToItem(we.Nothing);
    }
    return function() {
      var g = n.disabled, h = {
        active: i.value,
        disabled: g
      }, y = {
        id: s,
        role: "menuitem",
        tabIndex: g === !0 ? void 0 : -1,
        "aria-disabled": g === !0 ? !0 : void 0,
        onClick: u,
        onFocus: c,
        onPointermove: d,
        onMousemove: d,
        onPointerleave: f,
        onMouseleave: f
      };
      return fe({
        props: se({}, n, y),
        slot: h,
        attrs: o,
        slots: r,
        name: "MenuItem"
      });
    };
  }
}), re;
(function(t) {
  t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed";
})(re || (re = {}));
var Ts = /* @__PURE__ */ Symbol("PopoverContext");
function wn(t) {
  var n = Ee(Ts, null);
  if (n === null) {
    var e = new Error("<" + t + " /> is missing a parent <" + As.name + " /> component.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, wn), e;
  }
  return n;
}
var rc = /* @__PURE__ */ Symbol("PopoverGroupContext");
function Ms() {
  return Ee(rc, null);
}
var Ps = /* @__PURE__ */ Symbol("PopoverPanelContext");
function oc() {
  return Ee(Ps, null);
}
var As = /* @__PURE__ */ R({
  name: "Popover",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    }
  },
  setup: function(n, e) {
    var r = e.slots, o = e.attrs, a = "headlessui-popover-button-" + Oe(), s = "headlessui-popover-panel-" + Oe(), i = A(re.Closed), l = A(null), u = A(null), c = {
      popoverState: i,
      buttonId: a,
      panelId: s,
      panel: u,
      button: l,
      togglePopover: function() {
        var w;
        i.value = Ue(i.value, (w = {}, w[re.Open] = re.Closed, w[re.Closed] = re.Open, w));
      },
      closePopover: function() {
        i.value !== re.Closed && (i.value = re.Closed);
      },
      close: function(w) {
        c.closePopover();
        var D = function() {
          return w ? w instanceof HTMLElement ? w : w.value instanceof HTMLElement ? I(w) : I(c.button) : I(c.button);
        }();
        D == null || D.focus();
      }
    };
    Se(Ts, c), gr(P(function() {
      var y;
      return Ue(i.value, (y = {}, y[re.Open] = Ce.Open, y[re.Closed] = Ce.Closed, y));
    }));
    var d = {
      buttonId: a,
      panelId: s,
      close: function() {
        c.closePopover();
      }
    }, f = Ms(), g = f == null ? void 0 : f.registerPopover;
    function h() {
      var y, w, D;
      return (y = f == null ? void 0 : f.isFocusWithinPopoverGroup()) != null ? y : ((w = I(l)) == null ? void 0 : w.contains(document.activeElement)) || ((D = I(u)) == null ? void 0 : D.contains(document.activeElement));
    }
    return De(function() {
      return g == null ? void 0 : g(d);
    }), bt("focus", function() {
      i.value === re.Open && (h() || l && u && c.closePopover());
    }, !0), bt("mousedown", function(y) {
      var w, D, T = y.target;
      if (i.value === re.Open && !((w = I(l)) != null && w.contains(T)) && !((D = I(u)) != null && D.contains(T)) && (c.closePopover(), !Wu(T, qt.Loose))) {
        var M;
        y.preventDefault(), (M = I(l)) == null || M.focus();
      }
    }), function() {
      var y = {
        open: i.value === re.Open,
        close: c.close
      };
      return fe({
        props: n,
        slot: y,
        slots: r,
        attrs: o,
        name: "Popover"
      });
    };
  }
}), ac = /* @__PURE__ */ R({
  name: "PopoverButton",
  props: {
    as: {
      type: [Object, String],
      default: "button"
    },
    disabled: {
      type: [Boolean],
      default: !1
    }
  },
  render: function() {
    var n = wn("PopoverButton"), e = {
      open: n.popoverState.value === re.Open
    }, r = this.isWithinPanel ? {
      ref: "el",
      type: this.type,
      onKeydown: this.handleKeyDown,
      onClick: this.handleClick
    } : {
      ref: "el",
      id: n.buttonId,
      type: this.type,
      "aria-expanded": this.$props.disabled ? void 0 : n.popoverState.value === re.Open,
      "aria-controls": I(n.panel) ? n.panelId : void 0,
      disabled: this.$props.disabled ? !0 : void 0,
      onKeydown: this.handleKeyDown,
      onKeyup: this.handleKeyUp,
      onClick: this.handleClick
    };
    return fe({
      props: se({}, this.$props, r),
      slot: e,
      attrs: this.$attrs,
      slots: this.$slots,
      name: "PopoverButton"
    });
  },
  setup: function(n, e) {
    var r = e.attrs, o = wn("PopoverButton"), a = Ms(), s = a == null ? void 0 : a.closeOthers, i = oc(), l = i === null ? !1 : i === o.panelId, u = A(null), c = A(typeof window > "u" ? null : document.activeElement);
    bt("focus", function() {
      c.value = u.value, u.value = document.activeElement;
    }, !0);
    var d = A(null);
    return l || De(function() {
      o.button.value = d.value;
    }), {
      isWithinPanel: l,
      el: d,
      type: yr(P(function() {
        return {
          as: n.as,
          type: r.type
        };
      }), d),
      handleKeyDown: function(g) {
        var h, y;
        if (l) {
          if (o.popoverState.value === re.Closed) return;
          switch (g.key) {
            case Y.Space:
            case Y.Enter:
              g.preventDefault(), g.stopPropagation(), o.closePopover(), (h = I(o.button)) == null || h.focus();
              break;
          }
        } else
          switch (g.key) {
            case Y.Space:
            case Y.Enter:
              g.preventDefault(), g.stopPropagation(), o.popoverState.value === re.Closed && (s == null || s(o.buttonId)), o.togglePopover();
              break;
            case Y.Escape:
              if (o.popoverState.value !== re.Open) return s == null ? void 0 : s(o.buttonId);
              if (!I(o.button) || !((y = I(o.button)) != null && y.contains(document.activeElement))) return;
              g.preventDefault(), g.stopPropagation(), o.closePopover();
              break;
            case Y.Tab:
              if (o.popoverState.value !== re.Open || !o.panel || !o.button) return;
              if (g.shiftKey) {
                var w, D;
                if (!c.value || (w = I(o.button)) != null && w.contains(c.value) || (D = I(o.panel)) != null && D.contains(c.value)) return;
                var T = Qn(), M = T.indexOf(c.value), K = T.indexOf(I(o.button));
                if (K > M) return;
                g.preventDefault(), g.stopPropagation(), st(I(o.panel), oe.Last);
              } else
                g.preventDefault(), g.stopPropagation(), st(I(o.panel), oe.First);
              break;
          }
      },
      handleKeyUp: function(g) {
        var h, y;
        if (!l && (g.key === Y.Space && g.preventDefault(), o.popoverState.value === re.Open && o.panel && o.button))
          switch (g.key) {
            case Y.Tab:
              if (!c.value || (h = I(o.button)) != null && h.contains(c.value) || (y = I(o.panel)) != null && y.contains(c.value)) return;
              var w = Qn(), D = w.indexOf(c.value), T = w.indexOf(I(o.button));
              if (T > D) return;
              g.preventDefault(), g.stopPropagation(), st(I(o.panel), oe.Last);
              break;
          }
      },
      handleClick: function() {
        if (!n.disabled)
          if (l) {
            var g;
            o.closePopover(), (g = I(o.button)) == null || g.focus();
          } else {
            var h;
            o.popoverState.value === re.Closed && (s == null || s(o.buttonId)), (h = I(o.button)) == null || h.focus(), o.togglePopover();
          }
      }
    };
  }
}), sc = /* @__PURE__ */ R({
  name: "PopoverPanel",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    static: {
      type: Boolean,
      default: !1
    },
    unmount: {
      type: Boolean,
      default: !0
    },
    focus: {
      type: Boolean,
      default: !1
    }
  },
  render: function() {
    var n = wn("PopoverPanel"), e = {
      open: n.popoverState.value === re.Open,
      close: n.close
    }, r = {
      ref: "el",
      id: this.id,
      onKeydown: this.handleKeyDown
    };
    return fe({
      props: se({}, this.$props, r),
      slot: e,
      attrs: this.$attrs,
      slots: this.$slots,
      features: He.RenderStrategy | He.Static,
      visible: this.visible,
      name: "PopoverPanel"
    });
  },
  setup: function(n) {
    var e = n.focus, r = wn("PopoverPanel");
    Se(Ps, r.panelId), yt(function() {
      r.panel.value = null;
    }), De(function() {
      var s;
      if (e && r.popoverState.value === re.Open && r.panel) {
        var i = document.activeElement;
        (s = I(r.panel)) != null && s.contains(i) || st(I(r.panel), oe.First);
      }
    }), bt("keydown", function(s) {
      var i;
      if (r.popoverState.value === re.Open && I(r.panel) && s.key === Y.Tab && document.activeElement && (i = I(r.panel)) != null && i.contains(document.activeElement)) {
        s.preventDefault();
        var l = st(I(r.panel), s.shiftKey ? oe.Previous : oe.Next);
        if (l === Ke.Underflow) {
          var u;
          return (u = I(r.button)) == null ? void 0 : u.focus();
        } else if (l === Ke.Overflow) {
          if (!I(r.button)) return;
          var c = Qn(), d = c.indexOf(I(r.button)), f = c.splice(d + 1).filter(function(g) {
            var h;
            return !((h = I(r.panel)) != null && h.contains(g));
          });
          st(f, oe.First) === Ke.Error && st(document.body, oe.First);
        }
      }
    }), bt("focus", function() {
      var s;
      e && r.popoverState.value === re.Open && I(r.panel) && ((s = I(r.panel)) != null && s.contains(document.activeElement) || r.closePopover());
    }, !0);
    var o = en(), a = P(function() {
      return o !== null ? o.value === Ce.Open : r.popoverState.value === re.Open;
    });
    return {
      id: r.panelId,
      el: r.panel,
      handleKeyDown: function(i) {
        var l, u;
        switch (i.key) {
          case Y.Escape:
            if (r.popoverState.value !== re.Open || !I(r.panel) || !((l = I(r.panel)) != null && l.contains(document.activeElement))) return;
            i.preventDefault(), i.stopPropagation(), r.closePopover(), (u = I(r.button)) == null || u.focus();
            break;
        }
      },
      visible: a
    };
  }
}), Os = /* @__PURE__ */ Symbol("LabelContext");
function Rs() {
  var t = Ee(Os, null);
  if (t === null) {
    var n = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(n, Rs), n;
  }
  return t;
}
function xo(t) {
  var n = t === void 0 ? {} : t, e = n.slot, r = e === void 0 ? {} : e, o = n.name, a = o === void 0 ? "Label" : o, s = n.props, i = s === void 0 ? {} : s, l = A([]);
  function u(c) {
    return l.value.push(c), function() {
      var d = l.value.indexOf(c);
      d !== -1 && l.value.splice(d, 1);
    };
  }
  return Se(Os, {
    register: u,
    slot: r,
    name: a,
    props: i
  }), P(function() {
    return l.value.length > 0 ? l.value.join(" ") : void 0;
  });
}
var Is = /* @__PURE__ */ R({
  name: "Label",
  props: {
    as: {
      type: [Object, String],
      default: "label"
    },
    passive: {
      type: [Boolean],
      default: !1
    }
  },
  render: function() {
    var n = this.context, e = n.name, r = e === void 0 ? "Label" : e, o = n.slot, a = o === void 0 ? {} : o, s = n.props, i = s === void 0 ? {} : s, l = this.$props, u = l.passive, c = pt(l, ["passive"]), d = se({}, Object.entries(i).reduce(function(g, h) {
      var y, w = h[0], D = h[1];
      return Object.assign(g, (y = {}, y[w] = m(D), y));
    }, {}), {
      id: this.id
    }), f = se({}, c, d);
    return u && delete f.onClick, fe({
      props: f,
      slot: a,
      attrs: this.$attrs,
      slots: this.$slots,
      name: r
    });
  },
  setup: function() {
    var n = Rs(), e = "headlessui-label-" + Oe();
    return je(function() {
      return yt(n.register(e));
    }), {
      id: e,
      context: n
    };
  }
}), Ls = /* @__PURE__ */ Symbol("RadioGroupContext");
function Ns(t) {
  var n = Ee(Ls, null);
  if (n === null) {
    var e = new Error("<" + t + " /> is missing a parent <RadioGroup /> component.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, Ns), e;
  }
  return n;
}
var ic = /* @__PURE__ */ R({
  name: "RadioGroup",
  emits: {
    "update:modelValue": function(n) {
      return !0;
    }
  },
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    disabled: {
      type: [Boolean],
      default: !1
    },
    modelValue: {
      type: [Object, String, Number, Boolean]
    }
  },
  render: function() {
    var n = this.$props, e = pt(n, ["modelValue", "disabled"]), r = {
      ref: "el",
      id: this.id,
      role: "radiogroup",
      "aria-labelledby": this.labelledby,
      "aria-describedby": this.describedby,
      onKeydown: this.handleKeyDown
    };
    return fe({
      props: se({}, e, r),
      slot: {},
      attrs: this.$attrs,
      slots: this.$slots,
      name: "RadioGroup"
    });
  },
  setup: function(n, e) {
    var r = e.emit, o = A(null), a = A([]), s = xo({
      name: "RadioGroupLabel"
    }), i = hr({
      name: "RadioGroupDescription"
    }), l = P(function() {
      return n.modelValue;
    }), u = {
      options: a,
      value: l,
      disabled: P(function() {
        return n.disabled;
      }),
      firstOption: P(function() {
        return a.value.find(function(f) {
          return !f.propsRef.disabled;
        });
      }),
      containsCheckedOption: P(function() {
        return a.value.some(function(f) {
          return Ot(f.propsRef.value) === Ot(n.modelValue);
        });
      }),
      change: function(g) {
        var h;
        if (n.disabled || l.value === g) return !1;
        var y = (h = a.value.find(function(w) {
          return Ot(w.propsRef.value) === Ot(g);
        })) == null ? void 0 : h.propsRef;
        return y != null && y.disabled ? !1 : (r("update:modelValue", g), !0);
      },
      registerOption: function(g) {
        var h, y = Array.from((h = o.value) == null ? void 0 : h.querySelectorAll('[id^="headlessui-radiogroup-option-"]')).reduce(function(w, D, T) {
          var M;
          return Object.assign(w, (M = {}, M[D.id] = T, M));
        }, {});
        a.value.push(g), a.value.sort(function(w, D) {
          return y[w.id] - y[D.id];
        });
      },
      unregisterOption: function(g) {
        var h = a.value.findIndex(function(y) {
          return y.id === g;
        });
        h !== -1 && a.value.splice(h, 1);
      }
    };
    Se(Ls, u), Ss({
      container: P(function() {
        return I(o);
      }),
      accept: function(g) {
        return g.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : g.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
      },
      walk: function(g) {
        g.setAttribute("role", "none");
      }
    });
    function c(f) {
      if (o.value && o.value.contains(f.target)) {
        var g = a.value.filter(function(M) {
          return M.propsRef.disabled === !1;
        }).map(function(M) {
          return M.element;
        });
        switch (f.key) {
          case Y.ArrowLeft:
          case Y.ArrowUp:
            {
              f.preventDefault(), f.stopPropagation();
              var h = st(g, oe.Previous | oe.WrapAround);
              if (h === Ke.Success) {
                var y = a.value.find(function(M) {
                  return M.element === document.activeElement;
                });
                y && u.change(y.propsRef.value);
              }
            }
            break;
          case Y.ArrowRight:
          case Y.ArrowDown:
            {
              f.preventDefault(), f.stopPropagation();
              var w = st(g, oe.Next | oe.WrapAround);
              if (w === Ke.Success) {
                var D = a.value.find(function(M) {
                  return M.element === document.activeElement;
                });
                D && u.change(D.propsRef.value);
              }
            }
            break;
          case Y.Space:
            {
              f.preventDefault(), f.stopPropagation();
              var T = a.value.find(function(M) {
                return M.element === document.activeElement;
              });
              T && u.change(T.propsRef.value);
            }
            break;
        }
      }
    }
    var d = "headlessui-radiogroup-" + Oe();
    return {
      id: d,
      labelledby: s,
      describedby: i,
      el: o,
      handleKeyDown: c
    };
  }
}), At;
(function(t) {
  t[t.Empty = 1] = "Empty", t[t.Active = 2] = "Active";
})(At || (At = {}));
var lc = /* @__PURE__ */ R({
  name: "RadioGroupOption",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    value: {
      type: [Object, String, Number, Boolean]
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  render: function() {
    var n = this.$props, e = pt(n, ["value", "disabled"]), r = {
      checked: this.checked,
      disabled: this.disabled,
      active: !!(this.state & At.Active)
    }, o = {
      id: this.id,
      ref: "el",
      role: "radio",
      "aria-checked": this.checked ? "true" : "false",
      "aria-labelledby": this.labelledby,
      "aria-describedby": this.describedby,
      "aria-disabled": this.disabled ? !0 : void 0,
      tabIndex: this.tabIndex,
      onClick: this.disabled ? void 0 : this.handleClick,
      onFocus: this.disabled ? void 0 : this.handleFocus,
      onBlur: this.disabled ? void 0 : this.handleBlur
    };
    return fe({
      props: se({}, e, o),
      slot: r,
      attrs: this.$attrs,
      slots: this.$slots,
      name: "RadioGroupOption"
    });
  },
  setup: function(n) {
    var e = Ns("RadioGroupOption"), r = "headlessui-radiogroup-option-" + Oe(), o = xo({
      name: "RadioGroupLabel"
    }), a = hr({
      name: "RadioGroupDescription"
    }), s = A(null), i = P(function() {
      return {
        value: n.value,
        disabled: n.disabled
      };
    }), l = A(At.Empty);
    je(function() {
      return e.registerOption({
        id: r,
        element: s,
        propsRef: i
      });
    }), yt(function() {
      return e.unregisterOption(r);
    });
    var u = P(function() {
      var f;
      return ((f = e.firstOption.value) == null ? void 0 : f.id) === r;
    }), c = P(function() {
      return e.disabled.value || n.disabled;
    }), d = P(function() {
      return Ot(e.value.value) === Ot(n.value);
    });
    return {
      id: r,
      el: s,
      labelledby: o,
      describedby: a,
      state: l,
      disabled: c,
      checked: d,
      tabIndex: P(function() {
        return c.value ? -1 : d.value || !e.containsCheckedOption.value && u.value ? 0 : -1;
      }),
      handleClick: function() {
        var g;
        e.change(n.value) && (l.value |= At.Active, (g = s.value) == null || g.focus());
      },
      handleFocus: function() {
        l.value |= At.Active;
      },
      handleBlur: function() {
        l.value &= ~At.Active;
      }
    };
  }
}), fa = Is, Fr = Cs, Fs = /* @__PURE__ */ Symbol("GroupContext"), uc = /* @__PURE__ */ R({
  name: "SwitchGroup",
  props: {
    as: {
      type: [Object, String],
      default: "template"
    }
  },
  setup: function(n, e) {
    var r = e.slots, o = e.attrs, a = A(null), s = xo({
      name: "SwitchLabel",
      props: {
        onClick: function() {
          a.value && (a.value.click(), a.value.focus({
            preventScroll: !0
          }));
        }
      }
    }), i = hr({
      name: "SwitchDescription"
    }), l = {
      switchRef: a,
      labelledby: s,
      describedby: i
    };
    return Se(Fs, l), function() {
      return fe({
        props: n,
        slot: {},
        slots: r,
        attrs: o,
        name: "SwitchGroup"
      });
    };
  }
}), cc = /* @__PURE__ */ R({
  name: "Switch",
  emits: {
    "update:modelValue": function(n) {
      return !0;
    }
  },
  props: {
    as: {
      type: [Object, String],
      default: "button"
    },
    modelValue: {
      type: Boolean,
      default: !1
    }
  },
  render: function() {
    var n = {
      checked: this.$props.modelValue
    }, e = {
      id: this.id,
      ref: "el",
      role: "switch",
      type: this.type,
      tabIndex: 0,
      "aria-checked": this.$props.modelValue,
      "aria-labelledby": this.labelledby,
      "aria-describedby": this.describedby,
      onClick: this.handleClick,
      onKeyup: this.handleKeyUp,
      onKeypress: this.handleKeyPress
    };
    return fe({
      props: se({}, this.$props, e),
      slot: n,
      attrs: this.$attrs,
      slots: this.$slots,
      name: "Switch"
    });
  },
  setup: function(n, e) {
    var r = e.emit, o = e.attrs, a = Ee(Fs, null), s = "headlessui-switch-" + Oe();
    function i() {
      r("update:modelValue", !n.modelValue);
    }
    var l = A(null), u = a === null ? l : a.switchRef;
    return {
      id: s,
      el: u,
      type: yr(P(function() {
        return {
          as: n.as,
          type: o.type
        };
      }), u),
      labelledby: a == null ? void 0 : a.labelledby,
      describedby: a == null ? void 0 : a.describedby,
      handleClick: function(d) {
        d.preventDefault(), i();
      },
      handleKeyUp: function(d) {
        d.key !== Y.Tab && d.preventDefault(), d.key === Y.Space && i();
      },
      // This is needed so that we can "cancel" the click event when we use the `Enter` key on a button.
      handleKeyPress: function(d) {
        d.preventDefault();
      }
    };
  }
}), dc = Is, fc = Cs;
function pc(t) {
  var n = {
    called: !1
  };
  return function() {
    if (!n.called)
      return n.called = !0, t.apply(void 0, arguments);
  };
}
function Bs() {
  var t = [], n = {
    requestAnimationFrame: function(e) {
      function r() {
        return e.apply(this, arguments);
      }
      return r.toString = function() {
        return e.toString();
      }, r;
    }(function() {
      var e = requestAnimationFrame.apply(void 0, arguments);
      n.add(function() {
        return cancelAnimationFrame(e);
      });
    }),
    nextFrame: function() {
      for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++)
        o[a] = arguments[a];
      n.requestAnimationFrame(function() {
        n.requestAnimationFrame.apply(n, o);
      });
    },
    setTimeout: function(e) {
      function r() {
        return e.apply(this, arguments);
      }
      return r.toString = function() {
        return e.toString();
      }, r;
    }(function() {
      var e = setTimeout.apply(void 0, arguments);
      n.add(function() {
        return clearTimeout(e);
      });
    }),
    add: function(r) {
      t.push(r);
    },
    dispose: function() {
      for (var r = vt(t.splice(0)), o; !(o = r()).done; ) {
        var a = o.value;
        a();
      }
    }
  };
  return n;
}
function Br(t) {
  for (var n, e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)
    r[o - 1] = arguments[o];
  t && r.length > 0 && (n = t.classList).add.apply(n, r);
}
function jn(t) {
  for (var n, e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)
    r[o - 1] = arguments[o];
  t && r.length > 0 && (n = t.classList).remove.apply(n, r);
}
var St;
(function(t) {
  t.Finished = "finished", t.Cancelled = "cancelled";
})(St || (St = {}));
function mc(t, n) {
  var e = Bs();
  if (!t) return e.dispose;
  var r = getComputedStyle(t), o = r.transitionDuration, a = r.transitionDelay, s = [o, a].map(function(u) {
    var c = u.split(",").filter(Boolean).map(function(g) {
      return g.includes("ms") ? parseFloat(g) : parseFloat(g) * 1e3;
    }).sort(function(g, h) {
      return h - g;
    }), d = c[0], f = d === void 0 ? 0 : d;
    return f;
  }), i = s[0], l = s[1];
  return i !== 0 ? e.setTimeout(function() {
    return n(St.Finished);
  }, i + l) : n(St.Finished), e.add(function() {
    return n(St.Cancelled);
  }), e.dispose;
}
function pa(t, n, e, r, o, a) {
  var s = Bs(), i = a !== void 0 ? pc(a) : function() {
  };
  return jn.apply(void 0, [t].concat(o)), Br.apply(void 0, [t].concat(n, e)), s.nextFrame(function() {
    jn.apply(void 0, [t].concat(e)), Br.apply(void 0, [t].concat(r)), s.add(mc(t, function(l) {
      return jn.apply(void 0, [t].concat(r, n)), Br.apply(void 0, [t].concat(o)), i(l);
    }));
  }), s.add(function() {
    return jn.apply(void 0, [t].concat(n, e, r, o));
  }), s.add(function() {
    return i(St.Cancelled);
  }), s.dispose;
}
function Pt(t) {
  return t === void 0 && (t = ""), t.split(" ").filter(function(n) {
    return n.trim().length > 1;
  });
}
var Co = /* @__PURE__ */ Symbol("TransitionContext"), ue;
(function(t) {
  t.Visible = "visible", t.Hidden = "hidden";
})(ue || (ue = {}));
function hc() {
  return Ee(Co, null) !== null;
}
function gc() {
  var t = Ee(Co, null);
  if (t === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return t;
}
function vc() {
  var t = Ee(Do, null);
  if (t === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return t;
}
var Do = /* @__PURE__ */ Symbol("NestingContext");
function wr(t) {
  return "children" in t ? wr(t.children) : t.value.filter(function(n) {
    var e = n.state;
    return e === ue.Visible;
  }).length > 0;
}
function js(t) {
  var n = A([]), e = A(!1);
  je(function() {
    return e.value = !0;
  }), yt(function() {
    return e.value = !1;
  });
  function r(a, s) {
    var i;
    s === void 0 && (s = ze.Hidden);
    var l = n.value.findIndex(function(u) {
      var c = u.id;
      return c === a;
    });
    l !== -1 && (Ue(s, (i = {}, i[ze.Unmount] = function() {
      n.value.splice(l, 1);
    }, i[ze.Hidden] = function() {
      n.value[l].state = ue.Hidden;
    }, i)), !wr(n) && e.value && (t == null || t()));
  }
  function o(a) {
    var s = n.value.find(function(i) {
      var l = i.id;
      return l === a;
    });
    return s ? s.state !== ue.Visible && (s.state = ue.Visible) : n.value.push({
      id: a,
      state: ue.Visible
    }), function() {
      return r(a, ze.Unmount);
    };
  }
  return {
    children: n,
    register: o,
    unregister: r
  };
}
var Vs = He.RenderStrategy, wt = /* @__PURE__ */ R({
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    show: {
      type: [Boolean],
      default: null
    },
    unmount: {
      type: [Boolean],
      default: !0
    },
    appear: {
      type: [Boolean],
      default: !1
    },
    enter: {
      type: [String],
      default: ""
    },
    enterFrom: {
      type: [String],
      default: ""
    },
    enterTo: {
      type: [String],
      default: ""
    },
    entered: {
      type: [String],
      default: ""
    },
    leave: {
      type: [String],
      default: ""
    },
    leaveFrom: {
      type: [String],
      default: ""
    },
    leaveTo: {
      type: [String],
      default: ""
    }
  },
  emits: {
    beforeEnter: function() {
      return !0;
    },
    afterEnter: function() {
      return !0;
    },
    beforeLeave: function() {
      return !0;
    },
    afterLeave: function() {
      return !0;
    }
  },
  render: function() {
    var n = this;
    if (this.renderAsRoot)
      return _t(_n, se({}, this.$props, {
        onBeforeEnter: function() {
          return n.$emit("beforeEnter");
        },
        onAfterEnter: function() {
          return n.$emit("afterEnter");
        },
        onBeforeLeave: function() {
          return n.$emit("beforeLeave");
        },
        onAfterLeave: function() {
          return n.$emit("afterLeave");
        }
      }), this.$slots);
    var e = this.$props, r = pt(e, ["appear", "show", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"]), o = {
      ref: "el"
    }, a = r;
    return fe({
      props: se({}, a, o),
      slot: {},
      slots: this.$slots,
      attrs: this.$attrs,
      features: Vs,
      visible: this.state === ue.Visible,
      name: "TransitionChild"
    });
  },
  setup: function(n, e) {
    var r = e.emit;
    if (!hc() && Gu())
      return {
        renderAsRoot: !0
      };
    var o = A(null), a = A(ue.Visible), s = P(function() {
      return n.unmount ? ze.Unmount : ze.Hidden;
    }), i = gc(), l = i.show, u = i.appear, c = vc(), d = c.register, f = c.unregister, g = {
      value: !0
    }, h = Oe(), y = {
      value: !1
    }, w = js(function() {
      y.value || (a.value = ue.Hidden, f(h), r("afterLeave"));
    });
    je(function() {
      var J = d(h);
      yt(J);
    }), De(function() {
      var J;
      if (s.value === ze.Hidden && h) {
        if (l && a.value !== ue.Visible) {
          a.value = ue.Visible;
          return;
        }
        Ue(a.value, (J = {}, J[ue.Hidden] = function() {
          return f(h);
        }, J[ue.Visible] = function() {
          return d(h);
        }, J));
      }
    });
    var D = Pt(n.enter), T = Pt(n.enterFrom), M = Pt(n.enterTo), K = Pt(n.entered), q = Pt(n.leave), Z = Pt(n.leaveFrom), H = Pt(n.leaveTo);
    je(function() {
      De(function() {
        if (a.value === ue.Visible) {
          var J = I(o), ne = J instanceof Comment && J.data === "";
          if (ne)
            throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
        }
      });
    });
    function _e(J) {
      var ne = g.value && !u.value, he = I(o);
      !he || !(he instanceof HTMLElement) || ne || (y.value = !0, l.value && r("beforeEnter"), l.value || r("beforeLeave"), J(l.value ? pa(he, D, T, M, K, function(be) {
        y.value = !1, be === St.Finished && r("afterEnter");
      }) : pa(he, q, Z, H, K, function(be) {
        y.value = !1, be === St.Finished && (wr(w) || (a.value = ue.Hidden, f(h), r("afterLeave")));
      })));
    }
    return je(function() {
      tt([l, u], function(J, ne, he) {
        _e(he), g.value = !1;
      }, {
        immediate: !0
      });
    }), Se(Do, w), gr(P(function() {
      var J;
      return Ue(a.value, (J = {}, J[ue.Visible] = Ce.Open, J[ue.Hidden] = Ce.Closed, J));
    })), {
      el: o,
      renderAsRoot: !1,
      state: a
    };
  }
}), _n = /* @__PURE__ */ R({
  inheritAttrs: !1,
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    show: {
      type: [Boolean],
      default: null
    },
    unmount: {
      type: [Boolean],
      default: !0
    },
    appear: {
      type: [Boolean],
      default: !1
    },
    enter: {
      type: [String],
      default: ""
    },
    enterFrom: {
      type: [String],
      default: ""
    },
    enterTo: {
      type: [String],
      default: ""
    },
    entered: {
      type: [String],
      default: ""
    },
    leave: {
      type: [String],
      default: ""
    },
    leaveFrom: {
      type: [String],
      default: ""
    },
    leaveTo: {
      type: [String],
      default: ""
    }
  },
  emits: {
    beforeEnter: function() {
      return !0;
    },
    afterEnter: function() {
      return !0;
    },
    beforeLeave: function() {
      return !0;
    },
    afterLeave: function() {
      return !0;
    }
  },
  render: function() {
    var n = this, e = this.$props, r = e.unmount, o = pt(e, ["show", "appear", "unmount"]), a = {
      unmount: r
    };
    return fe({
      props: se({}, a, {
        as: "template"
      }),
      slot: {},
      slots: se({}, this.$slots, {
        default: function() {
          return [_t(wt, se({
            onBeforeEnter: function() {
              return n.$emit("beforeEnter");
            },
            onAfterEnter: function() {
              return n.$emit("afterEnter");
            },
            onBeforeLeave: function() {
              return n.$emit("beforeLeave");
            },
            onAfterLeave: function() {
              return n.$emit("afterLeave");
            }
          }, n.$attrs, a, o), n.$slots.default)];
        }
      }),
      attrs: {},
      features: Vs,
      visible: this.state === ue.Visible,
      name: "Transition"
    });
  },
  setup: function(n) {
    var e = en(), r = P(function() {
      if (n.show === null && e !== null) {
        var l;
        return Ue(e.value, (l = {}, l[Ce.Open] = !0, l[Ce.Closed] = !1, l));
      }
      return n.show;
    });
    De(function() {
      if (![!0, !1].includes(r.value))
        throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
    });
    var o = A(r.value ? ue.Visible : ue.Hidden), a = js(function() {
      o.value = ue.Hidden;
    }), s = {
      value: !0
    }, i = {
      show: r,
      appear: P(function() {
        return n.appear || !s.value;
      })
    };
    return je(function() {
      De(function() {
        s.value = !1, r.value ? o.value = ue.Visible : wr(a) || (o.value = ue.Hidden);
      });
    }), Se(Do, a), Se(Co, i), {
      state: o,
      show: r
    };
  }
});
function Hs(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Us(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    })
  ]);
}
function bc(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
      "clip-rule": "evenodd"
    })
  ]);
}
function yc(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", { d: "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" })
  ]);
}
function wc(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    })
  ]);
}
function xc(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Cc(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Dc(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "fill-rule": "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
      "clip-rule": "evenodd"
    })
  ]);
}
const qs = (t) => {
  const n = A(t), e = P(() => r.value.length > 0), r = P(() => n.value.map((o) => ({
    ...o,
    disabled: o.disabled !== void 0 ? typeof o.disabled == "boolean" ? o.disabled : o.disabled() : !1,
    show: o.show !== void 0 ? typeof o.show == "boolean" ? o.show : o.show() : !0
  })).filter((o) => o.show));
  return {
    actions: r,
    hasActions: e
  };
};
function Et(t) {
  return t.split("-")[1];
}
function Ws(t) {
  return t === "y" ? "height" : "width";
}
function Jt(t) {
  return t.split("-")[0];
}
function xr(t) {
  return ["top", "bottom"].includes(Jt(t)) ? "x" : "y";
}
function ma(t, n, e) {
  let { reference: r, floating: o } = t;
  const a = r.x + r.width / 2 - o.width / 2, s = r.y + r.height / 2 - o.height / 2, i = xr(n), l = Ws(i), u = r[l] / 2 - o[l] / 2, c = i === "x";
  let d;
  switch (Jt(n)) {
    case "top":
      d = { x: a, y: r.y - o.height };
      break;
    case "bottom":
      d = { x: a, y: r.y + r.height };
      break;
    case "right":
      d = { x: r.x + r.width, y: s };
      break;
    case "left":
      d = { x: r.x - o.width, y: s };
      break;
    default:
      d = { x: r.x, y: r.y };
  }
  switch (Et(n)) {
    case "start":
      d[i] -= u * (e && c ? -1 : 1);
      break;
    case "end":
      d[i] += u * (e && c ? -1 : 1);
  }
  return d;
}
const Ec = async (t, n, e) => {
  const { placement: r = "bottom", strategy: o = "absolute", middleware: a = [], platform: s } = e, i = a.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(n));
  let u = await s.getElementRects({ reference: t, floating: n, strategy: o }), { x: c, y: d } = ma(u, r, l), f = r, g = {}, h = 0;
  for (let y = 0; y < i.length; y++) {
    const { name: w, fn: D } = i[y], { x: T, y: M, data: K, reset: q } = await D({ x: c, y: d, initialPlacement: r, placement: f, strategy: o, middlewareData: g, rects: u, platform: s, elements: { reference: t, floating: n } });
    c = T ?? c, d = M ?? d, g = { ...g, [w]: { ...g[w], ...K } }, q && h <= 50 && (h++, typeof q == "object" && (q.placement && (f = q.placement), q.rects && (u = q.rects === !0 ? await s.getElementRects({ reference: t, floating: n, strategy: o }) : q.rects), { x: c, y: d } = ma(u, f, l)), y = -1);
  }
  return { x: c, y: d, placement: f, strategy: o, middlewareData: g };
};
function Cr(t, n) {
  return typeof t == "function" ? t(n) : t;
}
function _c(t) {
  return typeof t != "number" ? function(n) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...n };
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function er(t) {
  return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
}
async function Ys(t, n) {
  var e;
  n === void 0 && (n = {});
  const { x: r, y: o, platform: a, rects: s, elements: i, strategy: l } = t, { boundary: u = "clippingAncestors", rootBoundary: c = "viewport", elementContext: d = "floating", altBoundary: f = !1, padding: g = 0 } = Cr(n, t), h = _c(g), y = i[f ? d === "floating" ? "reference" : "floating" : d], w = er(await a.getClippingRect({ element: (e = await (a.isElement == null ? void 0 : a.isElement(y))) == null || e ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)), boundary: u, rootBoundary: c, strategy: l })), D = d === "floating" ? { ...s.floating, x: r, y: o } : s.reference, T = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), M = await (a.isElement == null ? void 0 : a.isElement(T)) && await (a.getScale == null ? void 0 : a.getScale(T)) || { x: 1, y: 1 }, K = er(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: D, offsetParent: T, strategy: l }) : D);
  return { top: (w.top - K.top + h.top) / M.y, bottom: (K.bottom - w.bottom + h.bottom) / M.y, left: (w.left - K.left + h.left) / M.x, right: (K.right - w.right + h.right) / M.x };
}
const kc = Math.min, Sc = Math.max;
function ha(t, n, e) {
  return Sc(t, kc(n, e));
}
const $c = ["top", "right", "bottom", "left"], ga = $c.reduce((t, n) => t.concat(n, n + "-start", n + "-end"), []), Tc = { left: "right", right: "left", bottom: "top", top: "bottom" };
function va(t) {
  return t.replace(/left|right|bottom|top/g, (n) => Tc[n]);
}
function Mc(t, n, e) {
  e === void 0 && (e = !1);
  const r = Et(t), o = xr(t), a = Ws(o);
  let s = o === "x" ? r === (e ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return n.reference[a] > n.floating[a] && (s = va(s)), { main: s, cross: va(s) };
}
const Pc = { start: "end", end: "start" };
function Ac(t) {
  return t.replace(/start|end/g, (n) => Pc[n]);
}
const Oc = function(t) {
  return t === void 0 && (t = {}), { name: "autoPlacement", options: t, async fn(n) {
    var e, r, o;
    const { rects: a, middlewareData: s, placement: i, platform: l, elements: u } = n, { crossAxis: c = !1, alignment: d, allowedPlacements: f = ga, autoAlignment: g = !0, ...h } = Cr(t, n), y = d !== void 0 || f === ga ? function(ne, he, be) {
      return (ne ? [...be.filter(($e) => Et($e) === ne), ...be.filter(($e) => Et($e) !== ne)] : be.filter(($e) => Jt($e) === $e)).filter(($e) => !ne || Et($e) === ne || !!he && Ac($e) !== $e);
    }(d || null, g, f) : f, w = await Ys(n, h), D = ((e = s.autoPlacement) == null ? void 0 : e.index) || 0, T = y[D];
    if (T == null) return {};
    const { main: M, cross: K } = Mc(T, a, await (l.isRTL == null ? void 0 : l.isRTL(u.floating)));
    if (i !== T) return { reset: { placement: y[0] } };
    const q = [w[Jt(T)], w[M], w[K]], Z = [...((r = s.autoPlacement) == null ? void 0 : r.overflows) || [], { placement: T, overflows: q }], H = y[D + 1];
    if (H) return { data: { index: D + 1, overflows: Z }, reset: { placement: H } };
    const _e = Z.map((ne) => {
      const he = Et(ne.placement);
      return [ne.placement, he && c ? ne.overflows.slice(0, 2).reduce((be, $e) => be + $e, 0) : ne.overflows[0], ne.overflows];
    }).sort((ne, he) => ne[1] - he[1]), J = ((o = _e.filter((ne) => ne[2].slice(0, Et(ne[0]) ? 2 : 3).every((he) => he <= 0))[0]) == null ? void 0 : o[0]) || _e[0][0];
    return J !== i ? { data: { index: D + 1, overflows: Z }, reset: { placement: J } } : {};
  } };
}, Rc = function(t) {
  return { name: "offset", options: t, async fn(n) {
    const { x: e, y: r } = n, o = await async function(a, s) {
      const { placement: i, platform: l, elements: u } = a, c = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), d = Jt(i), f = Et(i), g = xr(i) === "x", h = ["left", "top"].includes(d) ? -1 : 1, y = c && g ? -1 : 1, w = Cr(s, a);
      let { mainAxis: D, crossAxis: T, alignmentAxis: M } = typeof w == "number" ? { mainAxis: w, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...w };
      return f && typeof M == "number" && (T = f === "end" ? -1 * M : M), g ? { x: T * y, y: D * h } : { x: D * h, y: T * y };
    }(n, t);
    return { x: e + o.x, y: r + o.y, data: o };
  } };
};
function Ic(t) {
  return t === "x" ? "y" : "x";
}
const Lc = function(t) {
  return t === void 0 && (t = {}), { name: "shift", options: t, async fn(n) {
    const { x: e, y: r, placement: o } = n, { mainAxis: a = !0, crossAxis: s = !1, limiter: i = { fn: (w) => {
      let { x: D, y: T } = w;
      return { x: D, y: T };
    } }, ...l } = Cr(t, n), u = { x: e, y: r }, c = await Ys(n, l), d = xr(Jt(o)), f = Ic(d);
    let g = u[d], h = u[f];
    if (a) {
      const w = d === "y" ? "bottom" : "right";
      g = ha(g + c[d === "y" ? "top" : "left"], g, g - c[w]);
    }
    if (s) {
      const w = f === "y" ? "bottom" : "right";
      h = ha(h + c[f === "y" ? "top" : "left"], h, h - c[w]);
    }
    const y = i.fn({ ...n, [d]: g, [f]: h });
    return { ...y, data: { x: y.x - e, y: y.y - r } };
  } };
};
function nt(t) {
  var n;
  return ((n = t.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function it(t) {
  return nt(t).getComputedStyle(t);
}
function zs(t) {
  return t instanceof nt(t).Node;
}
function Tt(t) {
  return zs(t) ? (t.nodeName || "").toLowerCase() : "";
}
function lt(t) {
  return t instanceof nt(t).HTMLElement;
}
function Ge(t) {
  return t instanceof nt(t).Element;
}
function ba(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof nt(t).ShadowRoot || t instanceof ShadowRoot;
}
function xn(t) {
  const { overflow: n, overflowX: e, overflowY: r, display: o } = it(t);
  return /auto|scroll|overlay|hidden|clip/.test(n + r + e) && !["inline", "contents"].includes(o);
}
function Nc(t) {
  return ["table", "td", "th"].includes(Tt(t));
}
function to(t) {
  const n = Eo(), e = it(t);
  return e.transform !== "none" || e.perspective !== "none" || !n && !!e.backdropFilter && e.backdropFilter !== "none" || !n && !!e.filter && e.filter !== "none" || ["transform", "perspective", "filter"].some((r) => (e.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (e.contain || "").includes(r));
}
function Eo() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function Dr(t) {
  return ["html", "body", "#document"].includes(Tt(t));
}
const ya = Math.min, fn = Math.max, tr = Math.round;
function Ks(t) {
  const n = it(t);
  let e = parseFloat(n.width) || 0, r = parseFloat(n.height) || 0;
  const o = lt(t), a = o ? t.offsetWidth : e, s = o ? t.offsetHeight : r, i = tr(e) !== a || tr(r) !== s;
  return i && (e = a, r = s), { width: e, height: r, fallback: i };
}
function Gs(t) {
  return Ge(t) ? t : t.contextElement;
}
const Js = { x: 1, y: 1 };
function Wt(t) {
  const n = Gs(t);
  if (!lt(n)) return Js;
  const e = n.getBoundingClientRect(), { width: r, height: o, fallback: a } = Ks(n);
  let s = (a ? tr(e.width) : e.width) / r, i = (a ? tr(e.height) : e.height) / o;
  return s && Number.isFinite(s) || (s = 1), i && Number.isFinite(i) || (i = 1), { x: s, y: i };
}
const wa = { x: 0, y: 0 };
function Xs(t, n, e) {
  var r, o;
  if (n === void 0 && (n = !0), !Eo()) return wa;
  const a = t ? nt(t) : window;
  return !e || n && e !== a ? wa : { x: ((r = a.visualViewport) == null ? void 0 : r.offsetLeft) || 0, y: ((o = a.visualViewport) == null ? void 0 : o.offsetTop) || 0 };
}
function Bt(t, n, e, r) {
  n === void 0 && (n = !1), e === void 0 && (e = !1);
  const o = t.getBoundingClientRect(), a = Gs(t);
  let s = Js;
  n && (r ? Ge(r) && (s = Wt(r)) : s = Wt(t));
  const i = Xs(a, e, r);
  let l = (o.left + i.x) / s.x, u = (o.top + i.y) / s.y, c = o.width / s.x, d = o.height / s.y;
  if (a) {
    const f = nt(a), g = r && Ge(r) ? nt(r) : r;
    let h = f.frameElement;
    for (; h && r && g !== f; ) {
      const y = Wt(h), w = h.getBoundingClientRect(), D = getComputedStyle(h);
      w.x += (h.clientLeft + parseFloat(D.paddingLeft)) * y.x, w.y += (h.clientTop + parseFloat(D.paddingTop)) * y.y, l *= y.x, u *= y.y, c *= y.x, d *= y.y, l += w.x, u += w.y, h = nt(h).frameElement;
    }
  }
  return er({ width: c, height: d, x: l, y: u });
}
function $t(t) {
  return ((zs(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function Er(t) {
  return Ge(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function Zs(t) {
  return Bt($t(t)).left + Er(t).scrollLeft;
}
function Xt(t) {
  if (Tt(t) === "html") return t;
  const n = t.assignedSlot || t.parentNode || ba(t) && t.host || $t(t);
  return ba(n) ? n.host : n;
}
function Qs(t) {
  const n = Xt(t);
  return Dr(n) ? n.ownerDocument.body : lt(n) && xn(n) ? n : Qs(n);
}
function pn(t, n) {
  var e;
  n === void 0 && (n = []);
  const r = Qs(t), o = r === ((e = t.ownerDocument) == null ? void 0 : e.body), a = nt(r);
  return o ? n.concat(a, a.visualViewport || [], xn(r) ? r : []) : n.concat(r, pn(r));
}
function xa(t, n, e) {
  let r;
  if (n === "viewport") r = function(o, a) {
    const s = nt(o), i = $t(o), l = s.visualViewport;
    let u = i.clientWidth, c = i.clientHeight, d = 0, f = 0;
    if (l) {
      u = l.width, c = l.height;
      const g = Eo();
      (!g || g && a === "fixed") && (d = l.offsetLeft, f = l.offsetTop);
    }
    return { width: u, height: c, x: d, y: f };
  }(t, e);
  else if (n === "document") r = function(o) {
    const a = $t(o), s = Er(o), i = o.ownerDocument.body, l = fn(a.scrollWidth, a.clientWidth, i.scrollWidth, i.clientWidth), u = fn(a.scrollHeight, a.clientHeight, i.scrollHeight, i.clientHeight);
    let c = -s.scrollLeft + Zs(o);
    const d = -s.scrollTop;
    return it(i).direction === "rtl" && (c += fn(a.clientWidth, i.clientWidth) - l), { width: l, height: u, x: c, y: d };
  }($t(t));
  else if (Ge(n)) r = function(o, a) {
    const s = Bt(o, !0, a === "fixed"), i = s.top + o.clientTop, l = s.left + o.clientLeft, u = lt(o) ? Wt(o) : { x: 1, y: 1 };
    return { width: o.clientWidth * u.x, height: o.clientHeight * u.y, x: l * u.x, y: i * u.y };
  }(n, e);
  else {
    const o = Xs(t);
    r = { ...n, x: n.x - o.x, y: n.y - o.y };
  }
  return er(r);
}
function ei(t, n) {
  const e = Xt(t);
  return !(e === n || !Ge(e) || Dr(e)) && (it(e).position === "fixed" || ei(e, n));
}
function Ca(t, n) {
  return lt(t) && it(t).position !== "fixed" ? n ? n(t) : t.offsetParent : null;
}
function Da(t, n) {
  const e = nt(t);
  if (!lt(t)) return e;
  let r = Ca(t, n);
  for (; r && Nc(r) && it(r).position === "static"; ) r = Ca(r, n);
  return r && (Tt(r) === "html" || Tt(r) === "body" && it(r).position === "static" && !to(r)) ? e : r || function(o) {
    let a = Xt(o);
    for (; lt(a) && !Dr(a); ) {
      if (to(a)) return a;
      a = Xt(a);
    }
    return null;
  }(t) || e;
}
function Fc(t, n, e) {
  const r = lt(n), o = $t(n), a = e === "fixed", s = Bt(t, !0, a, n);
  let i = { scrollLeft: 0, scrollTop: 0 };
  const l = { x: 0, y: 0 };
  if (r || !r && !a) if ((Tt(n) !== "body" || xn(o)) && (i = Er(n)), lt(n)) {
    const u = Bt(n, !0, a, n);
    l.x = u.x + n.clientLeft, l.y = u.y + n.clientTop;
  } else o && (l.x = Zs(o));
  return { x: s.left + i.scrollLeft - l.x, y: s.top + i.scrollTop - l.y, width: s.width, height: s.height };
}
const Bc = { getClippingRect: function(t) {
  let { element: n, boundary: e, rootBoundary: r, strategy: o } = t;
  const a = e === "clippingAncestors" ? function(u, c) {
    const d = c.get(u);
    if (d) return d;
    let f = pn(u).filter((w) => Ge(w) && Tt(w) !== "body"), g = null;
    const h = it(u).position === "fixed";
    let y = h ? Xt(u) : u;
    for (; Ge(y) && !Dr(y); ) {
      const w = it(y), D = to(y);
      D || w.position !== "fixed" || (g = null), (h ? !D && !g : !D && w.position === "static" && g && ["absolute", "fixed"].includes(g.position) || xn(y) && !D && ei(u, y)) ? f = f.filter((T) => T !== y) : g = w, y = Xt(y);
    }
    return c.set(u, f), f;
  }(n, this._c) : [].concat(e), s = [...a, r], i = s[0], l = s.reduce((u, c) => {
    const d = xa(n, c, o);
    return u.top = fn(d.top, u.top), u.right = ya(d.right, u.right), u.bottom = ya(d.bottom, u.bottom), u.left = fn(d.left, u.left), u;
  }, xa(n, i, o));
  return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: n, offsetParent: e, strategy: r } = t;
  const o = lt(e), a = $t(e);
  if (e === a) return n;
  let s = { scrollLeft: 0, scrollTop: 0 }, i = { x: 1, y: 1 };
  const l = { x: 0, y: 0 };
  if ((o || !o && r !== "fixed") && ((Tt(e) !== "body" || xn(a)) && (s = Er(e)), lt(e))) {
    const u = Bt(e);
    i = Wt(e), l.x = u.x + e.clientLeft, l.y = u.y + e.clientTop;
  }
  return { width: n.width * i.x, height: n.height * i.y, x: n.x * i.x - s.scrollLeft * i.x + l.x, y: n.y * i.y - s.scrollTop * i.y + l.y };
}, isElement: Ge, getDimensions: function(t) {
  return Ks(t);
}, getOffsetParent: Da, getDocumentElement: $t, getScale: Wt, async getElementRects(t) {
  let { reference: n, floating: e, strategy: r } = t;
  const o = this.getOffsetParent || Da, a = this.getDimensions;
  return { reference: Fc(n, await o(e), r), floating: { x: 0, y: 0, ...await a(e) } };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => it(t).direction === "rtl" };
function ti(t, n, e, r) {
  r === void 0 && (r = {});
  const { ancestorScroll: o = !0, ancestorResize: a = !0, elementResize: s = !0, animationFrame: i = !1 } = r, l = o || a ? [...Ge(t) ? pn(t) : t.contextElement ? pn(t.contextElement) : [], ...pn(n)] : [];
  l.forEach((f) => {
    const g = !Ge(f) && f.toString().includes("V");
    !o || i && !g || f.addEventListener("scroll", e, { passive: !0 }), a && f.addEventListener("resize", e);
  });
  let u, c = null;
  s && (c = new ResizeObserver(() => {
    e();
  }), Ge(t) && !i && c.observe(t), Ge(t) || !t.contextElement || i || c.observe(t.contextElement), c.observe(n));
  let d = i ? Bt(t) : null;
  return i && function f() {
    const g = Bt(t);
    !d || g.x === d.x && g.y === d.y && g.width === d.width && g.height === d.height || e(), d = g, u = requestAnimationFrame(f);
  }(), e(), () => {
    var f;
    l.forEach((g) => {
      o && g.removeEventListener("scroll", e), a && g.removeEventListener("resize", e);
    }), (f = c) == null || f.disconnect(), c = null, i && cancelAnimationFrame(u);
  };
}
const jc = (t, n, e) => {
  const r = /* @__PURE__ */ new Map(), o = { platform: Bc, ...e }, a = { ...o.platform, _c: r };
  return Ec(t, n, { ...o, platform: a });
};
function Ea(t) {
  var n;
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
function ni(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _a(t, n) {
  const e = ni(t);
  return Math.round(n * e) / e;
}
function ri(t, n, e) {
  e === void 0 && (e = {});
  const r = e.whileElementsMounted, o = P(() => {
    var H;
    return (H = m(e.open)) != null ? H : !0;
  }), a = P(() => m(e.middleware)), s = P(() => {
    var H;
    return (H = m(e.placement)) != null ? H : "bottom";
  }), i = P(() => {
    var H;
    return (H = m(e.strategy)) != null ? H : "absolute";
  }), l = P(() => {
    var H;
    return (H = m(e.transform)) != null ? H : !0;
  }), u = P(() => Ea(t.value)), c = P(() => Ea(n.value)), d = A(0), f = A(0), g = A(i.value), h = A(s.value), y = Ba({}), w = A(!1), D = P(() => {
    const H = {
      position: g.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return H;
    const _e = _a(c.value, d.value), J = _a(c.value, f.value);
    return l.value ? {
      ...H,
      transform: "translate(" + _e + "px, " + J + "px)",
      ...ni(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: g.value,
      left: _e + "px",
      top: J + "px"
    };
  });
  let T;
  function M() {
    u.value == null || c.value == null || jc(u.value, c.value, {
      middleware: a.value,
      placement: s.value,
      strategy: i.value
    }).then((H) => {
      d.value = H.x, f.value = H.y, g.value = H.strategy, h.value = H.placement, y.value = H.middlewareData, w.value = !0;
    });
  }
  function K() {
    typeof T == "function" && (T(), T = void 0);
  }
  function q() {
    if (K(), r === void 0) {
      M();
      return;
    }
    if (u.value != null && c.value != null) {
      T = r(u.value, c.value, M);
      return;
    }
  }
  function Z() {
    o.value || (w.value = !1);
  }
  return tt([a, s, i], M, {
    flush: "sync"
  }), tt([u, c], q, {
    flush: "sync"
  }), tt(o, Z, {
    flush: "sync"
  }), zi() && Ki(K), {
    x: jt(d),
    y: jt(f),
    strategy: jt(g),
    placement: jt(h),
    middlewareData: jt(y),
    isPositioned: jt(w),
    floatingStyles: D,
    update: M
  };
}
const Vc = { class: "py-1" }, Hc = ["disabled", "onClick"], Uc = { class: "relative inline-flex items-center gap-x-1.5" }, _o = /* @__PURE__ */ R({
  __name: "ActionsDropdown",
  props: {
    actions: { default: () => [] },
    placement: { default: "bottom-end" }
  },
  setup(t) {
    const n = t, { actions: e, hasActions: r } = qs(It(n, "actions")), o = Nt("trigger"), a = Nt("wrapper"), { floatingStyles: s } = ri(o, a, {
      placement: n.placement,
      strategy: "fixed",
      whileElementsMounted: ti
    });
    return (i, l) => (x(), V(m(vo), {
      as: "div",
      class: "relative flex justify-end items-center"
    }, {
      default: N(() => [
        k(m(bo), {
          ref: "trigger",
          class: "w-8 h-8 inline-flex items-center justify-center text-gray-700 rounded-full hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed",
          disabled: !m(r)
        }, {
          default: N(() => [
            l[0] || (l[0] = v("span", { class: "sr-only" }, "Open options", -1)),
            k(m(yc), {
              class: "w-5 h-5",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        k(lr, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: N(() => [
            v("div", {
              ref: "wrapper",
              class: "z-[5]",
              style: ja(m(s))
            }, [
              k(m(yo), { class: "w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none" }, {
                default: N(() => [
                  v("div", Vc, [
                    (x(!0), _(te, null, ae(m(e), (u, c) => (x(), V(m(wo), {
                      key: c,
                      as: "div"
                    }, {
                      default: N(({ active: d }) => [
                        v("button", {
                          type: "submit",
                          disabled: u.disabled,
                          class: L([
                            d ? "bg-gray-100 text-gray-900" : "text-gray-700",
                            "block w-full text-left px-4 py-2 text-sm font-semibold disabled:cursor-not-allowed"
                          ]),
                          onClick: u.onClick
                        }, [
                          v("span", Uc, [
                            u.icon ? (x(), V(rt(u.icon), {
                              key: 0,
                              class: "-ml-0.5 h-4 w-4 text-gray-400",
                              "aria-hidden": "true"
                            })) : B("", !0),
                            ce(" " + U(u.label), 1)
                          ])
                        ], 10, Hc)
                      ]),
                      _: 2
                    }, 1024))), 128))
                  ])
                ]),
                _: 1
              })
            ], 4)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), qc = { class: "px-4 py-5 sm:p-6 text-center" }, Wc = ["textContent"], Yc = ["textContent"], zc = /* @__PURE__ */ R({
  __name: "Cards",
  props: {
    cards: {}
  },
  setup(t) {
    return (n, e) => (x(), _("div", {
      class: L(["mt-5 grid grid-cols-1 gap-5", "lg:grid-cols-" + n.cards.length])
    }, [
      (x(!0), _(te, null, ae(n.cards, (r, o) => (x(), _("div", {
        key: o,
        class: "bg-white overflow-hidden shadow rounded-xy"
      }, [
        v("div", qc, [
          v("dl", null, [
            v("dd", {
              class: "mt-1 text-3xl leading-9 font-semibold text-xy-blue",
              textContent: U(r.primary)
            }, null, 8, Wc),
            v("dt", {
              class: "text-sm leading-5 font-medium text-gray-700 truncate",
              textContent: U(r.secondary)
            }, null, 8, Yc)
          ])
        ])
      ]))), 128))
    ], 2));
  }
}), Kc = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }, Gc = { class: "inline-block align-bottom bg-white rounded-xy px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-8 sm:rounded-xy-lg" }, Jc = { class: "mt-3 text-center sm:mt-5" }, Xc = { class: "mt-2" }, Zc = { class: "mt-5 sm:mt-6" }, Qc = /* @__PURE__ */ R({
  __name: "ContentModal",
  props: /* @__PURE__ */ ve({
    btnText: { default: "Go back" },
    title: { default: "" }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ve(["close"], ["update:modelValue"]),
  setup(t, { emit: n }) {
    const e = xe(t, "modelValue"), r = n;
    return tt(e, (o) => {
      o || r("close");
    }), (o, a) => (x(), V(m(_n), {
      as: "template",
      show: e.value
    }, {
      default: N(() => [
        k(m(vr), {
          as: "div",
          static: "",
          class: "fixed z-30 inset-0 overflow-y-auto",
          open: e.value,
          onClose: a[1] || (a[1] = (s) => e.value = !1)
        }, {
          default: N(() => [
            v("div", Kc, [
              k(m(wt), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: N(() => [
                  k(m(br), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              a[2] || (a[2] = v("span", {
                class: "hidden sm:inline-block sm:align-middle sm:h-screen",
                "aria-hidden": "true"
              }, "​", -1)),
              k(m(wt), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: N(() => [
                  v("div", Gc, [
                    v("div", null, [
                      ge(o.$slots, "icon"),
                      v("div", Jc, [
                        k(m(go), { as: "h3" }, {
                          default: N(() => [
                            ce(U(o.title), 1)
                          ]),
                          _: 1
                        }),
                        v("div", Xc, [
                          ge(o.$slots, "default")
                        ])
                      ])
                    ]),
                    v("div", Zc, [
                      v("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full xy-btn",
                        onClick: a[0] || (a[0] = (s) => e.value = !1)
                      }, U(o.btnText), 1)
                    ])
                  ])
                ]),
                _: 3
              })
            ])
          ]),
          _: 3
        }, 8, ["open"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), ed = {
  key: 0,
  class: "text-red-700/80",
  "aria-hidden": ""
}, qe = /* @__PURE__ */ R({
  __name: "InputLabel",
  props: {
    label: { default: "" },
    required: { type: Boolean, default: !1 },
    tag: { default: "label" }
  },
  setup(t) {
    const n = t, e = P(() => n.required && /\*$/gm.exec(n.label) !== null ? n.label.substring(0, n.label.length - 1) : n.label);
    return (r, o) => e.value ? (x(), V(rt(r.tag), Fe({
      key: 0,
      class: "block text-sm leading-snug font-medium text-gray-800"
    }, r.$attrs), {
      default: N(() => [
        ce(U(e.value) + " ", 1),
        n.required ? (x(), _("span", ed, "*")) : B("", !0)
      ]),
      _: 1
    }, 16)) : B("", !0);
  }
}), Re = /* @__PURE__ */ R({
  __name: "InputHelp",
  props: {
    tag: { default: "div" },
    text: { default: "" }
  },
  setup(t) {
    return (n, e) => n.text ? (x(), V(rt(n.tag), Fe({
      key: 0,
      class: "text-sm leading-6 font-normal text-gray-600"
    }, n.$attrs), {
      default: N(() => [
        ce(U(n.text), 1)
      ]),
      _: 1
    }, 16)) : B("", !0);
  }
}), td = {
  key: 0,
  class: "text-sm text-red-700"
}, ot = /* @__PURE__ */ R({
  __name: "InputError",
  props: {
    text: { default: "" }
  },
  setup(t) {
    return (n, e) => n.text ? (x(), _("p", td, U(n.text), 1)) : B("", !0);
  }
}), jr = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], Yt = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: (t) => typeof console < "u" && console.warn(t),
  getWeek: (t) => {
    const n = new Date(t.getTime());
    n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + 3 - (n.getDay() + 6) % 7);
    var e = new Date(n.getFullYear(), 0, 4);
    return 1 + Math.round(((n.getTime() - e.getTime()) / 864e5 - 3 + (e.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, Cn = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: (t) => {
    const n = t % 100;
    if (n > 3 && n < 21)
      return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, Be = (t, n = 2) => `000${t}`.slice(n * -1), Qe = (t) => t === !0 ? 1 : 0;
function ka(t, n) {
  let e;
  return function() {
    clearTimeout(e), e = setTimeout(() => t.apply(this, arguments), n);
  };
}
const Vr = (t) => t instanceof Array ? t : [t];
function Ie(t, n, e) {
  if (e === !0)
    return t.classList.add(n);
  t.classList.remove(n);
}
function ee(t, n, e) {
  const r = window.document.createElement(t);
  return n = n || "", e = e || "", r.className = n, e !== void 0 && (r.textContent = e), r;
}
function Vn(t) {
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
}
function oi(t, n) {
  if (n(t))
    return t;
  if (t.parentNode)
    return oi(t.parentNode, n);
}
function Hn(t, n) {
  const e = ee("div", "numInputWrapper"), r = ee("input", "numInput " + t), o = ee("span", "arrowUp"), a = ee("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? r.type = "number" : (r.type = "text", r.pattern = "\\d*"), n !== void 0)
    for (const s in n)
      r.setAttribute(s, n[s]);
  return e.appendChild(r), e.appendChild(o), e.appendChild(a), e;
}
function We(t) {
  try {
    return typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
  } catch {
    return t.target;
  }
}
const Hr = () => {
}, nr = (t, n, e) => e.months[n ? "shorthand" : "longhand"][t], nd = {
  D: Hr,
  F: function(t, n, e) {
    t.setMonth(e.months.longhand.indexOf(n));
  },
  G: (t, n) => {
    t.setHours(parseFloat(n));
  },
  H: (t, n) => {
    t.setHours(parseFloat(n));
  },
  J: (t, n) => {
    t.setDate(parseFloat(n));
  },
  K: (t, n, e) => {
    t.setHours(t.getHours() % 12 + 12 * Qe(new RegExp(e.amPM[1], "i").test(n)));
  },
  M: function(t, n, e) {
    t.setMonth(e.months.shorthand.indexOf(n));
  },
  S: (t, n) => {
    t.setSeconds(parseFloat(n));
  },
  U: (t, n) => new Date(parseFloat(n) * 1e3),
  W: function(t, n, e) {
    const r = parseInt(n), o = new Date(t.getFullYear(), 0, 2 + (r - 1) * 7, 0, 0, 0, 0);
    return o.setDate(o.getDate() - o.getDay() + e.firstDayOfWeek), o;
  },
  Y: (t, n) => {
    t.setFullYear(parseFloat(n));
  },
  Z: (t, n) => new Date(n),
  d: (t, n) => {
    t.setDate(parseFloat(n));
  },
  h: (t, n) => {
    t.setHours(parseFloat(n));
  },
  i: (t, n) => {
    t.setMinutes(parseFloat(n));
  },
  j: (t, n) => {
    t.setDate(parseFloat(n));
  },
  l: Hr,
  m: (t, n) => {
    t.setMonth(parseFloat(n) - 1);
  },
  n: (t, n) => {
    t.setMonth(parseFloat(n) - 1);
  },
  s: (t, n) => {
    t.setSeconds(parseFloat(n));
  },
  u: (t, n) => new Date(parseFloat(n)),
  w: Hr,
  y: (t, n) => {
    t.setFullYear(2e3 + parseFloat(n));
  }
}, no = {
  D: "(\\w+)",
  F: "(\\w+)",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "(\\w+)",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "(\\w+)",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, mn = {
  Z: (t) => t.toISOString(),
  D: function(t, n, e) {
    return n.weekdays.shorthand[mn.w(t, n, e)];
  },
  F: function(t, n, e) {
    return nr(mn.n(t, n, e) - 1, !1, n);
  },
  G: function(t, n, e) {
    return Be(mn.h(t, n, e));
  },
  H: (t) => Be(t.getHours()),
  J: function(t, n) {
    return n.ordinal !== void 0 ? t.getDate() + n.ordinal(t.getDate()) : t.getDate();
  },
  K: (t, n) => n.amPM[Qe(t.getHours() > 11)],
  M: function(t, n) {
    return nr(t.getMonth(), !0, n);
  },
  S: (t) => Be(t.getSeconds()),
  U: (t) => t.getTime() / 1e3,
  W: function(t, n, e) {
    return e.getWeek(t);
  },
  Y: (t) => Be(t.getFullYear(), 4),
  d: (t) => Be(t.getDate()),
  h: (t) => t.getHours() % 12 ? t.getHours() % 12 : 12,
  i: (t) => Be(t.getMinutes()),
  j: (t) => t.getDate(),
  l: function(t, n) {
    return n.weekdays.longhand[t.getDay()];
  },
  m: (t) => Be(t.getMonth() + 1),
  n: (t) => t.getMonth() + 1,
  s: (t) => t.getSeconds(),
  u: (t) => t.getTime(),
  w: (t) => t.getDay(),
  y: (t) => String(t.getFullYear()).substring(2)
}, ai = ({ config: t = Yt, l10n: n = Cn, isMobile: e = !1 }) => (r, o, a) => {
  const s = a || n;
  return t.formatDate !== void 0 && !e ? t.formatDate(r, o, s) : o.split("").map((i, l, u) => mn[i] && u[l - 1] !== "\\" ? mn[i](r, s, t) : i !== "\\" ? i : "").join("");
}, ro = ({ config: t = Yt, l10n: n = Cn }) => (e, r, o, a) => {
  if (e !== 0 && !e)
    return;
  const s = a || n;
  let i;
  const l = e;
  if (e instanceof Date)
    i = new Date(e.getTime());
  else if (typeof e != "string" && e.toFixed !== void 0)
    i = new Date(e);
  else if (typeof e == "string") {
    const u = r || (t || Yt).dateFormat, c = String(e).trim();
    if (c === "today")
      i = /* @__PURE__ */ new Date(), o = !0;
    else if (/Z$/.test(c) || /GMT$/.test(c))
      i = new Date(e);
    else if (t && t.parseDate)
      i = t.parseDate(e, u);
    else {
      i = !t || !t.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
      let d, f = [];
      for (let g = 0, h = 0, y = ""; g < u.length; g++) {
        const w = u[g], D = w === "\\", T = u[g - 1] === "\\" || D;
        if (no[w] && !T) {
          y += no[w];
          const M = new RegExp(y).exec(e);
          M && (d = !0) && f[w !== "Y" ? "push" : "unshift"]({
            fn: nd[w],
            val: M[++h]
          });
        } else D || (y += ".");
        f.forEach(({ fn: M, val: K }) => i = M(i, K, s) || i);
      }
      i = d ? i : void 0;
    }
  }
  if (!(i instanceof Date && !isNaN(i.getTime()))) {
    t.errorHandler(new Error(`Invalid date provided: ${l}`));
    return;
  }
  return o === !0 && i.setHours(0, 0, 0, 0), i;
};
function Ye(t, n, e = !0) {
  return e !== !1 ? new Date(t.getTime()).setHours(0, 0, 0, 0) - new Date(n.getTime()).setHours(0, 0, 0, 0) : t.getTime() - n.getTime();
}
const rd = (t, n, e) => t > Math.min(n, e) && t < Math.max(n, e), od = {
  DAY: 864e5
};
function Ur(t) {
  let n = t.defaultHour, e = t.defaultMinute, r = t.defaultSeconds;
  if (t.minDate !== void 0) {
    const o = t.minDate.getHours(), a = t.minDate.getMinutes(), s = t.minDate.getSeconds();
    n < o && (n = o), n === o && e < a && (e = a), n === o && e === a && r < s && (r = t.minDate.getSeconds());
  }
  if (t.maxDate !== void 0) {
    const o = t.maxDate.getHours(), a = t.maxDate.getMinutes();
    n = Math.min(n, o), n === o && (e = Math.min(a, e)), n === o && e === a && (r = t.maxDate.getSeconds());
  }
  return { hours: n, minutes: e, seconds: r };
}
typeof Object.assign != "function" && (Object.assign = function(t, ...n) {
  if (!t)
    throw TypeError("Cannot convert undefined or null to object");
  for (const e of n)
    e && Object.keys(e).forEach((r) => t[r] = e[r]);
  return t;
});
const ad = 300;
function sd(t, n) {
  const e = {
    config: Object.assign(Object.assign({}, Yt), ye.defaultConfig),
    l10n: Cn
  };
  e.parseDate = ro({ config: e.config, l10n: e.l10n }), e._handlers = [], e.pluginElements = [], e.loadedPlugins = [], e._bind = h, e._setHoursFromDate = d, e._positionCalendar = Rn, e.changeMonth = ie, e.changeYear = An, e.clear = rn, e.close = on, e._createElement = ee, e.destroy = Pn, e.isEnabled = Mt, e.jumpToDate = D, e.open = Di, e.redraw = Lo, e.set = Si, e.setDate = $i, e.toggle = Ai;
  function r() {
    e.utils = {
      getDaysInMonth(p = e.currentMonth, b = e.currentYear) {
        return p === 1 && (b % 4 === 0 && b % 100 !== 0 || b % 400 === 0) ? 29 : e.l10n.daysInMonth[p];
      }
    };
  }
  function o() {
    e.element = e.input = t, e.isOpen = !1, Ei(), Io(), Mi(), Ti(), r(), e.isMobile || K(), w(), (e.selectedDates.length || e.config.noCalendar) && (e.config.enableTime && d(e.config.noCalendar ? e.latestSelectedDateObj : void 0), Ct(!1)), s();
    const p = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !e.isMobile && p && Rn(), pe("onReady");
  }
  function a(p) {
    return p.bind(e);
  }
  function s() {
    const p = e.config;
    p.weekNumbers === !1 && p.showMonths === 1 || p.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (e.calendarContainer !== void 0 && (e.calendarContainer.style.visibility = "hidden", e.calendarContainer.style.display = "block"), e.daysContainer !== void 0) {
        const b = (e.days.offsetWidth + 1) * p.showMonths;
        e.daysContainer.style.width = b + "px", e.calendarContainer.style.width = b + (e.weekWrapper !== void 0 ? e.weekWrapper.offsetWidth : 0) + "px", e.calendarContainer.style.removeProperty("visibility"), e.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function i(p) {
    if (e.selectedDates.length === 0) {
      const C = e.config.minDate === void 0 || Ye(/* @__PURE__ */ new Date(), e.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(e.config.minDate.getTime()), S = Ur(e.config);
      C.setHours(S.hours, S.minutes, S.seconds, C.getMilliseconds()), e.selectedDates = [C], e.latestSelectedDateObj = C;
    }
    p !== void 0 && p.type !== "blur" && Ii(p);
    const b = e._input.value;
    c(), Ct(), e._input.value !== b && e._debouncedChange();
  }
  function l(p, b) {
    return p % 12 + 12 * Qe(b === e.l10n.amPM[1]);
  }
  function u(p) {
    switch (p % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return p % 12;
    }
  }
  function c() {
    if (e.hourElement === void 0 || e.minuteElement === void 0)
      return;
    let p = (parseInt(e.hourElement.value.slice(-2), 10) || 0) % 24, b = (parseInt(e.minuteElement.value, 10) || 0) % 60, C = e.secondElement !== void 0 ? (parseInt(e.secondElement.value, 10) || 0) % 60 : 0;
    e.amPM !== void 0 && (p = l(p, e.amPM.textContent));
    const S = e.config.minTime !== void 0 || e.config.minDate && e.minDateHasTime && e.latestSelectedDateObj && Ye(e.latestSelectedDateObj, e.config.minDate, !0) === 0;
    if (e.config.maxTime !== void 0 || e.config.maxDate && e.maxDateHasTime && e.latestSelectedDateObj && Ye(e.latestSelectedDateObj, e.config.maxDate, !0) === 0) {
      const $ = e.config.maxTime !== void 0 ? e.config.maxTime : e.config.maxDate;
      p = Math.min(p, $.getHours()), p === $.getHours() && (b = Math.min(b, $.getMinutes())), b === $.getMinutes() && (C = Math.min(C, $.getSeconds()));
    }
    if (S) {
      const $ = e.config.minTime !== void 0 ? e.config.minTime : e.config.minDate;
      p = Math.max(p, $.getHours()), p === $.getHours() && b < $.getMinutes() && (b = $.getMinutes()), b === $.getMinutes() && (C = Math.max(C, $.getSeconds()));
    }
    f(p, b, C);
  }
  function d(p) {
    const b = p || e.latestSelectedDateObj;
    b && f(b.getHours(), b.getMinutes(), b.getSeconds());
  }
  function f(p, b, C) {
    e.latestSelectedDateObj !== void 0 && e.latestSelectedDateObj.setHours(p % 24, b, C || 0, 0), !(!e.hourElement || !e.minuteElement || e.isMobile) && (e.hourElement.value = Be(e.config.time_24hr ? p : (12 + p) % 12 + 12 * Qe(p % 12 === 0)), e.minuteElement.value = Be(b), e.amPM !== void 0 && (e.amPM.textContent = e.l10n.amPM[Qe(p >= 12)]), e.secondElement !== void 0 && (e.secondElement.value = Be(C)));
  }
  function g(p) {
    const b = We(p), C = parseInt(b.value) + (p.delta || 0);
    (C / 1e3 > 1 || p.key === "Enter" && !/[^\d]/.test(C.toString())) && An(C);
  }
  function h(p, b, C, S) {
    if (b instanceof Array)
      return b.forEach((O) => h(p, O, C, S));
    if (p instanceof Array)
      return p.forEach((O) => h(O, b, C, S));
    p.addEventListener(b, C, S), e._handlers.push({
      remove: () => p.removeEventListener(b, C)
    });
  }
  function y() {
    pe("onChange");
  }
  function w() {
    if (e.config.wrap && ["open", "close", "toggle", "clear"].forEach((b) => {
      Array.prototype.forEach.call(e.element.querySelectorAll(`[data-${b}]`), (C) => h(C, "click", e[b]));
    }), e.isMobile) {
      Pi();
      return;
    }
    const p = ka(Ci, 50);
    if (e._debouncedChange = ka(y, ad), e.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && h(e.daysContainer, "mouseover", (b) => {
      e.config.mode === "range" && $r(We(b));
    }), h(window.document.body, "keydown", xi), !e.config.inline && !e.config.static && h(window, "resize", p), window.ontouchstart !== void 0 ? h(window.document, "touchstart", an) : h(window.document, "mousedown", an), h(window.document, "focus", an, { capture: !0 }), e.config.clickOpens === !0 && (h(e._input, "focus", e.open), h(e._input, "click", e.open)), e.daysContainer !== void 0 && (h(e.monthNav, "click", Ri), h(e.monthNav, ["keyup", "increment"], g), h(e.daysContainer, "click", No)), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0) {
      const b = (C) => We(C).select();
      h(e.timeContainer, ["increment"], i), h(e.timeContainer, "blur", i, { capture: !0 }), h(e.timeContainer, "click", T), h([e.hourElement, e.minuteElement], ["focus", "click"], b), e.secondElement !== void 0 && h(e.secondElement, "focus", () => e.secondElement && e.secondElement.select()), e.amPM !== void 0 && h(e.amPM, "click", (C) => {
        i(C), y();
      });
    }
    e.config.allowInput && h(e._input, "blur", wi);
  }
  function D(p, b) {
    const C = p !== void 0 ? e.parseDate(p) : e.latestSelectedDateObj || (e.config.minDate && e.config.minDate > e.now ? e.config.minDate : e.config.maxDate && e.config.maxDate < e.now ? e.config.maxDate : e.now), S = e.currentYear, O = e.currentMonth;
    try {
      C !== void 0 && (e.currentYear = C.getFullYear(), e.currentMonth = C.getMonth());
    } catch ($) {
      $.message = "Invalid date supplied: " + C, e.config.errorHandler($);
    }
    b && e.currentYear !== S && (pe("onYearChange"), be()), b && (e.currentYear !== S || e.currentMonth !== O) && pe("onMonthChange"), e.redraw();
  }
  function T(p) {
    const b = We(p);
    ~b.className.indexOf("arrow") && M(p, b.classList.contains("arrowUp") ? 1 : -1);
  }
  function M(p, b, C) {
    const S = p && We(p), O = C || S && S.parentNode && S.parentNode.firstChild, $ = Mr("increment");
    $.delta = b, O && O.dispatchEvent($);
  }
  function K() {
    const p = window.document.createDocumentFragment();
    if (e.calendarContainer = ee("div", "flatpickr-calendar"), e.calendarContainer.tabIndex = -1, !e.config.noCalendar) {
      if (p.appendChild(Tn()), e.innerContainer = ee("div", "flatpickr-innerContainer"), e.config.weekNumbers) {
        const { weekWrapper: C, weekNumbers: S } = Mn();
        e.innerContainer.appendChild(C), e.weekNumbers = S, e.weekWrapper = C;
      }
      e.rContainer = ee("div", "flatpickr-rContainer"), e.rContainer.appendChild(W()), e.daysContainer || (e.daysContainer = ee("div", "flatpickr-days"), e.daysContainer.tabIndex = -1), he(), e.rContainer.appendChild(e.daysContainer), e.innerContainer.appendChild(e.rContainer), p.appendChild(e.innerContainer);
    }
    e.config.enableTime && p.appendChild(X()), Ie(e.calendarContainer, "rangeMode", e.config.mode === "range"), Ie(e.calendarContainer, "animate", e.config.animate === !0), Ie(e.calendarContainer, "multiMonth", e.config.showMonths > 1), e.calendarContainer.appendChild(p);
    const b = e.config.appendTo !== void 0 && e.config.appendTo.nodeType !== void 0;
    if ((e.config.inline || e.config.static) && (e.calendarContainer.classList.add(e.config.inline ? "inline" : "static"), e.config.inline && (!b && e.element.parentNode ? e.element.parentNode.insertBefore(e.calendarContainer, e._input.nextSibling) : e.config.appendTo !== void 0 && e.config.appendTo.appendChild(e.calendarContainer)), e.config.static)) {
      const C = ee("div", "flatpickr-wrapper");
      e.element.parentNode && e.element.parentNode.insertBefore(C, e.element), C.appendChild(e.element), e.altInput && C.appendChild(e.altInput), C.appendChild(e.calendarContainer);
    }
    !e.config.static && !e.config.inline && (e.config.appendTo !== void 0 ? e.config.appendTo : window.document.body).appendChild(e.calendarContainer);
  }
  function q(p, b, C, S) {
    const O = Mt(b, !0), $ = ee("span", "flatpickr-day " + p, b.getDate().toString());
    return $.dateObj = b, $.$i = S, $.setAttribute("aria-label", e.formatDate(b, e.config.ariaDateFormat)), p.indexOf("hidden") === -1 && Ye(b, e.now) === 0 && (e.todayDateElem = $, $.classList.add("today"), $.setAttribute("aria-current", "date")), O ? ($.tabIndex = -1, Pr(b) && ($.classList.add("selected"), e.selectedDateElem = $, e.config.mode === "range" && (Ie($, "startRange", e.selectedDates[0] && Ye(b, e.selectedDates[0], !0) === 0), Ie($, "endRange", e.selectedDates[1] && Ye(b, e.selectedDates[1], !0) === 0), p === "nextMonthDay" && $.classList.add("inRange")))) : $.classList.add("flatpickr-disabled"), e.config.mode === "range" && Oi(b) && !Pr(b) && $.classList.add("inRange"), e.weekNumbers && e.config.showMonths === 1 && p !== "prevMonthDay" && C % 7 === 1 && e.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + e.config.getWeek(b) + "</span>"), pe("onDayCreate", $), $;
  }
  function Z(p) {
    p.focus(), e.config.mode === "range" && $r(p);
  }
  function H(p) {
    const b = p > 0 ? 0 : e.config.showMonths - 1, C = p > 0 ? e.config.showMonths : -1;
    for (let S = b; S != C; S += p) {
      const O = e.daysContainer.children[S], $ = p > 0 ? 0 : O.children.length - 1, j = p > 0 ? O.children.length : -1;
      for (let F = $; F != j; F += p) {
        const G = O.children[F];
        if (G.className.indexOf("hidden") === -1 && Mt(G.dateObj))
          return G;
      }
    }
  }
  function _e(p, b) {
    const C = p.className.indexOf("Month") === -1 ? p.dateObj.getMonth() : e.currentMonth, S = b > 0 ? e.config.showMonths : -1, O = b > 0 ? 1 : -1;
    for (let $ = C - e.currentMonth; $ != S; $ += O) {
      const j = e.daysContainer.children[$], F = C - e.currentMonth === $ ? p.$i + b : b < 0 ? j.children.length - 1 : 0, G = j.children.length;
      for (let Q = F; Q >= 0 && Q < G && Q != (b > 0 ? G : -1); Q += O) {
        const le = j.children[Q];
        if (le.className.indexOf("hidden") === -1 && Mt(le.dateObj) && Math.abs(p.$i - Q) >= Math.abs(b))
          return Z(le);
      }
    }
    e.changeMonth(O), J(H(O), 0);
  }
  function J(p, b) {
    const C = On(document.activeElement || document.body), S = p !== void 0 ? p : C ? document.activeElement : e.selectedDateElem !== void 0 && On(e.selectedDateElem) ? e.selectedDateElem : e.todayDateElem !== void 0 && On(e.todayDateElem) ? e.todayDateElem : H(b > 0 ? 1 : -1);
    S === void 0 ? e._input.focus() : C ? _e(S, b) : Z(S);
  }
  function ne(p, b) {
    const C = (new Date(p, b, 1).getDay() - e.l10n.firstDayOfWeek + 7) % 7, S = e.utils.getDaysInMonth((b - 1 + 12) % 12, p), O = e.utils.getDaysInMonth(b, p), $ = window.document.createDocumentFragment(), j = e.config.showMonths > 1, F = j ? "prevMonthDay hidden" : "prevMonthDay", G = j ? "nextMonthDay hidden" : "nextMonthDay";
    let Q = S + 1 - C, le = 0;
    for (; Q <= S; Q++, le++)
      $.appendChild(q(F, new Date(p, b - 1, Q), Q, le));
    for (Q = 1; Q <= O; Q++, le++)
      $.appendChild(q("", new Date(p, b, Q), Q, le));
    for (let Me = O + 1; Me <= 42 - C && (e.config.showMonths === 1 || le % 7 !== 0); Me++, le++)
      $.appendChild(q(G, new Date(p, b + 1, Me % O), Me, le));
    const Ze = ee("div", "dayContainer");
    return Ze.appendChild($), Ze;
  }
  function he() {
    if (e.daysContainer === void 0)
      return;
    Vn(e.daysContainer), e.weekNumbers && Vn(e.weekNumbers);
    const p = document.createDocumentFragment();
    for (let b = 0; b < e.config.showMonths; b++) {
      const C = new Date(e.currentYear, e.currentMonth, 1);
      C.setMonth(e.currentMonth + b), p.appendChild(ne(C.getFullYear(), C.getMonth()));
    }
    e.daysContainer.appendChild(p), e.days = e.daysContainer.firstChild, e.config.mode === "range" && e.selectedDates.length === 1 && $r();
  }
  function be() {
    if (e.config.showMonths > 1 || e.config.monthSelectorType !== "dropdown")
      return;
    const p = function(b) {
      return e.config.minDate !== void 0 && e.currentYear === e.config.minDate.getFullYear() && b < e.config.minDate.getMonth() ? !1 : !(e.config.maxDate !== void 0 && e.currentYear === e.config.maxDate.getFullYear() && b > e.config.maxDate.getMonth());
    };
    e.monthsDropdownContainer.tabIndex = -1, e.monthsDropdownContainer.innerHTML = "";
    for (let b = 0; b < 12; b++) {
      if (!p(b))
        continue;
      const C = ee("option", "flatpickr-monthDropdown-month");
      C.value = new Date(e.currentYear, b).getMonth().toString(), C.textContent = nr(b, e.config.shorthandCurrentMonth, e.l10n), C.tabIndex = -1, e.currentMonth === b && (C.selected = !0), e.monthsDropdownContainer.appendChild(C);
    }
  }
  function $e() {
    const p = ee("div", "flatpickr-month"), b = window.document.createDocumentFragment();
    let C;
    e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? C = ee("span", "cur-month") : (e.monthsDropdownContainer = ee("select", "flatpickr-monthDropdown-months"), e.monthsDropdownContainer.setAttribute("aria-label", e.l10n.monthAriaLabel), h(e.monthsDropdownContainer, "change", (j) => {
      const F = We(j), G = parseInt(F.value, 10);
      e.changeMonth(G - e.currentMonth), pe("onMonthChange");
    }), be(), C = e.monthsDropdownContainer);
    const S = Hn("cur-year", { tabindex: "-1" }), O = S.getElementsByTagName("input")[0];
    O.setAttribute("aria-label", e.l10n.yearAriaLabel), e.config.minDate && O.setAttribute("min", e.config.minDate.getFullYear().toString()), e.config.maxDate && (O.setAttribute("max", e.config.maxDate.getFullYear().toString()), O.disabled = !!e.config.minDate && e.config.minDate.getFullYear() === e.config.maxDate.getFullYear());
    const $ = ee("div", "flatpickr-current-month");
    return $.appendChild(C), $.appendChild(S), b.appendChild($), p.appendChild(b), {
      container: p,
      yearElement: O,
      monthElement: C
    };
  }
  function nn() {
    Vn(e.monthNav), e.monthNav.appendChild(e.prevMonthNav), e.config.showMonths && (e.yearElements = [], e.monthElements = []);
    for (let p = e.config.showMonths; p--; ) {
      const b = $e();
      e.yearElements.push(b.yearElement), e.monthElements.push(b.monthElement), e.monthNav.appendChild(b.container);
    }
    e.monthNav.appendChild(e.nextMonthNav);
  }
  function Tn() {
    return e.monthNav = ee("div", "flatpickr-months"), e.yearElements = [], e.monthElements = [], e.prevMonthNav = ee("span", "flatpickr-prev-month"), e.prevMonthNav.innerHTML = e.config.prevArrow, e.nextMonthNav = ee("span", "flatpickr-next-month"), e.nextMonthNav.innerHTML = e.config.nextArrow, nn(), Object.defineProperty(e, "_hidePrevMonthArrow", {
      get: () => e.__hidePrevMonthArrow,
      set(p) {
        e.__hidePrevMonthArrow !== p && (Ie(e.prevMonthNav, "flatpickr-disabled", p), e.__hidePrevMonthArrow = p);
      }
    }), Object.defineProperty(e, "_hideNextMonthArrow", {
      get: () => e.__hideNextMonthArrow,
      set(p) {
        e.__hideNextMonthArrow !== p && (Ie(e.nextMonthNav, "flatpickr-disabled", p), e.__hideNextMonthArrow = p);
      }
    }), e.currentYearElement = e.yearElements[0], Ln(), e.monthNav;
  }
  function X() {
    e.calendarContainer.classList.add("hasTime"), e.config.noCalendar && e.calendarContainer.classList.add("noCalendar");
    const p = Ur(e.config);
    e.timeContainer = ee("div", "flatpickr-time"), e.timeContainer.tabIndex = -1;
    const b = ee("span", "flatpickr-time-separator", ":"), C = Hn("flatpickr-hour", {
      "aria-label": e.l10n.hourAriaLabel
    });
    e.hourElement = C.getElementsByTagName("input")[0];
    const S = Hn("flatpickr-minute", {
      "aria-label": e.l10n.minuteAriaLabel
    });
    if (e.minuteElement = S.getElementsByTagName("input")[0], e.hourElement.tabIndex = e.minuteElement.tabIndex = -1, e.hourElement.value = Be(e.latestSelectedDateObj ? e.latestSelectedDateObj.getHours() : e.config.time_24hr ? p.hours : u(p.hours)), e.minuteElement.value = Be(e.latestSelectedDateObj ? e.latestSelectedDateObj.getMinutes() : p.minutes), e.hourElement.setAttribute("step", e.config.hourIncrement.toString()), e.minuteElement.setAttribute("step", e.config.minuteIncrement.toString()), e.hourElement.setAttribute("min", e.config.time_24hr ? "0" : "1"), e.hourElement.setAttribute("max", e.config.time_24hr ? "23" : "12"), e.hourElement.setAttribute("maxlength", "2"), e.minuteElement.setAttribute("min", "0"), e.minuteElement.setAttribute("max", "59"), e.minuteElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(C), e.timeContainer.appendChild(b), e.timeContainer.appendChild(S), e.config.time_24hr && e.timeContainer.classList.add("time24hr"), e.config.enableSeconds) {
      e.timeContainer.classList.add("hasSeconds");
      const O = Hn("flatpickr-second");
      e.secondElement = O.getElementsByTagName("input")[0], e.secondElement.value = Be(e.latestSelectedDateObj ? e.latestSelectedDateObj.getSeconds() : p.seconds), e.secondElement.setAttribute("step", e.minuteElement.getAttribute("step")), e.secondElement.setAttribute("min", "0"), e.secondElement.setAttribute("max", "59"), e.secondElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(ee("span", "flatpickr-time-separator", ":")), e.timeContainer.appendChild(O);
    }
    return e.config.time_24hr || (e.amPM = ee("span", "flatpickr-am-pm", e.l10n.amPM[Qe((e.latestSelectedDateObj ? e.hourElement.value : e.config.defaultHour) > 11)]), e.amPM.title = e.l10n.toggleTitle, e.amPM.tabIndex = -1, e.timeContainer.appendChild(e.amPM)), e.timeContainer;
  }
  function W() {
    e.weekdayContainer ? Vn(e.weekdayContainer) : e.weekdayContainer = ee("div", "flatpickr-weekdays");
    for (let p = e.config.showMonths; p--; ) {
      const b = ee("div", "flatpickr-weekdaycontainer");
      e.weekdayContainer.appendChild(b);
    }
    return xt(), e.weekdayContainer;
  }
  function xt() {
    if (!e.weekdayContainer)
      return;
    const p = e.l10n.firstDayOfWeek;
    let b = [...e.l10n.weekdays.shorthand];
    p > 0 && p < b.length && (b = [
      ...b.splice(p, b.length),
      ...b.splice(0, p)
    ]);
    for (let C = e.config.showMonths; C--; )
      e.weekdayContainer.children[C].innerHTML = `
      <span class='flatpickr-weekday'>
        ${b.join("</span><span class='flatpickr-weekday'>")}
      </span>
      `;
  }
  function Mn() {
    e.calendarContainer.classList.add("hasWeeks");
    const p = ee("div", "flatpickr-weekwrapper");
    p.appendChild(ee("span", "flatpickr-weekday", e.l10n.weekAbbreviation));
    const b = ee("div", "flatpickr-weeks");
    return p.appendChild(b), {
      weekWrapper: p,
      weekNumbers: b
    };
  }
  function ie(p, b = !0) {
    const C = b ? p : p - e.currentMonth;
    C < 0 && e._hidePrevMonthArrow === !0 || C > 0 && e._hideNextMonthArrow === !0 || (e.currentMonth += C, (e.currentMonth < 0 || e.currentMonth > 11) && (e.currentYear += e.currentMonth > 11 ? 1 : -1, e.currentMonth = (e.currentMonth + 12) % 12, pe("onYearChange"), be()), he(), pe("onMonthChange"), Ln());
  }
  function rn(p = !0, b = !0) {
    if (e.input.value = "", e.altInput !== void 0 && (e.altInput.value = ""), e.mobileInput !== void 0 && (e.mobileInput.value = ""), e.selectedDates = [], e.latestSelectedDateObj = void 0, b === !0 && (e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth()), e.config.enableTime === !0) {
      const { hours: C, minutes: S, seconds: O } = Ur(e.config);
      f(C, S, O);
    }
    e.redraw(), p && pe("onChange");
  }
  function on() {
    e.isOpen = !1, e.isMobile || (e.calendarContainer !== void 0 && e.calendarContainer.classList.remove("open"), e._input !== void 0 && e._input.classList.remove("active")), pe("onClose");
  }
  function Pn() {
    e.config !== void 0 && pe("onDestroy");
    for (let p = e._handlers.length; p--; )
      e._handlers[p].remove();
    if (e._handlers = [], e.mobileInput)
      e.mobileInput.parentNode && e.mobileInput.parentNode.removeChild(e.mobileInput), e.mobileInput = void 0;
    else if (e.calendarContainer && e.calendarContainer.parentNode)
      if (e.config.static && e.calendarContainer.parentNode) {
        const p = e.calendarContainer.parentNode;
        if (p.lastChild && p.removeChild(p.lastChild), p.parentNode) {
          for (; p.firstChild; )
            p.parentNode.insertBefore(p.firstChild, p);
          p.parentNode.removeChild(p);
        }
      } else
        e.calendarContainer.parentNode.removeChild(e.calendarContainer);
    e.altInput && (e.input.type = "text", e.altInput.parentNode && e.altInput.parentNode.removeChild(e.altInput), delete e.altInput), e.input && (e.input.type = e.input._type, e.input.classList.remove("flatpickr-input"), e.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach((p) => {
      try {
        delete e[p];
      } catch {
      }
    });
  }
  function Te(p) {
    return e.config.appendTo && e.config.appendTo.contains(p) ? !0 : e.calendarContainer.contains(p);
  }
  function an(p) {
    if (e.isOpen && !e.config.inline) {
      const b = We(p), C = Te(b), S = b === e.input || b === e.altInput || e.element.contains(b) || p.path && p.path.indexOf && (~p.path.indexOf(e.input) || ~p.path.indexOf(e.altInput)), O = p.type === "blur" ? S && p.relatedTarget && !Te(p.relatedTarget) : !S && !C && !Te(p.relatedTarget), $ = !e.config.ignoredFocusElements.some((j) => j.contains(b));
      O && $ && (e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0 && e.input.value !== "" && e.input.value !== void 0 && i(), e.close(), e.config && e.config.mode === "range" && e.selectedDates.length === 1 && (e.clear(!1), e.redraw()));
    }
  }
  function An(p) {
    if (!p || e.config.minDate && p < e.config.minDate.getFullYear() || e.config.maxDate && p > e.config.maxDate.getFullYear())
      return;
    const b = p, C = e.currentYear !== b;
    e.currentYear = b || e.currentYear, e.config.maxDate && e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth = Math.min(e.config.maxDate.getMonth(), e.currentMonth) : e.config.minDate && e.currentYear === e.config.minDate.getFullYear() && (e.currentMonth = Math.max(e.config.minDate.getMonth(), e.currentMonth)), C && (e.redraw(), pe("onYearChange"), be());
  }
  function Mt(p, b = !0) {
    var C;
    const S = e.parseDate(p, void 0, b);
    if (e.config.minDate && S && Ye(S, e.config.minDate, b !== void 0 ? b : !e.minDateHasTime) < 0 || e.config.maxDate && S && Ye(S, e.config.maxDate, b !== void 0 ? b : !e.maxDateHasTime) > 0)
      return !1;
    if (!e.config.enable && e.config.disable.length === 0)
      return !0;
    if (S === void 0)
      return !1;
    const O = !!e.config.enable, $ = (C = e.config.enable) !== null && C !== void 0 ? C : e.config.disable;
    for (let j = 0, F; j < $.length; j++) {
      if (F = $[j], typeof F == "function" && F(S))
        return O;
      if (F instanceof Date && S !== void 0 && F.getTime() === S.getTime())
        return O;
      if (typeof F == "string") {
        const G = e.parseDate(F, void 0, !0);
        return G && G.getTime() === S.getTime() ? O : !O;
      } else if (typeof F == "object" && S !== void 0 && F.from && F.to && S.getTime() >= F.from.getTime() && S.getTime() <= F.to.getTime())
        return O;
    }
    return !O;
  }
  function On(p) {
    return e.daysContainer !== void 0 ? p.className.indexOf("hidden") === -1 && p.className.indexOf("flatpickr-disabled") === -1 && e.daysContainer.contains(p) : !1;
  }
  function wi(p) {
    p.target === e._input && (e.selectedDates.length > 0 || e._input.value.length > 0) && !(p.relatedTarget && Te(p.relatedTarget)) && e.setDate(e._input.value, !0, p.target === e.altInput ? e.config.altFormat : e.config.dateFormat);
  }
  function xi(p) {
    const b = We(p), C = e.config.wrap ? t.contains(b) : b === e._input, S = e.config.allowInput, O = e.isOpen && (!S || !C), $ = e.config.inline && C && !S;
    if (p.keyCode === 13 && C) {
      if (S)
        return e.setDate(e._input.value, !0, b === e.altInput ? e.config.altFormat : e.config.dateFormat), b.blur();
      e.open();
    } else if (Te(b) || O || $) {
      const j = !!e.timeContainer && e.timeContainer.contains(b);
      switch (p.keyCode) {
        case 13:
          j ? (p.preventDefault(), i(), Tr()) : No(p);
          break;
        case 27:
          p.preventDefault(), Tr();
          break;
        case 8:
        case 46:
          C && !e.config.allowInput && (p.preventDefault(), e.clear());
          break;
        case 37:
        case 39:
          if (!j && !C) {
            if (p.preventDefault(), e.daysContainer !== void 0 && (S === !1 || document.activeElement && On(document.activeElement))) {
              const G = p.keyCode === 39 ? 1 : -1;
              p.ctrlKey ? (p.stopPropagation(), ie(G), J(H(1), 0)) : J(void 0, G);
            }
          } else e.hourElement && e.hourElement.focus();
          break;
        case 38:
        case 40:
          p.preventDefault();
          const F = p.keyCode === 40 ? 1 : -1;
          e.daysContainer && b.$i !== void 0 || b === e.input || b === e.altInput ? p.ctrlKey ? (p.stopPropagation(), An(e.currentYear - F), J(H(1), 0)) : j || J(void 0, F * 7) : b === e.currentYearElement ? An(e.currentYear - F) : e.config.enableTime && (!j && e.hourElement && e.hourElement.focus(), i(p), e._debouncedChange());
          break;
        case 9:
          if (j) {
            const G = [
              e.hourElement,
              e.minuteElement,
              e.secondElement,
              e.amPM
            ].concat(e.pluginElements).filter((le) => le), Q = G.indexOf(b);
            if (Q !== -1) {
              const le = G[Q + (p.shiftKey ? -1 : 1)];
              p.preventDefault(), (le || e._input).focus();
            }
          } else !e.config.noCalendar && e.daysContainer && e.daysContainer.contains(b) && p.shiftKey && (p.preventDefault(), e._input.focus());
          break;
      }
    }
    if (e.amPM !== void 0 && b === e.amPM)
      switch (p.key) {
        case e.l10n.amPM[0].charAt(0):
        case e.l10n.amPM[0].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[0], c(), Ct();
          break;
        case e.l10n.amPM[1].charAt(0):
        case e.l10n.amPM[1].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[1], c(), Ct();
          break;
      }
    (C || Te(b)) && pe("onKeyDown", p);
  }
  function $r(p) {
    if (e.selectedDates.length !== 1 || p && (!p.classList.contains("flatpickr-day") || p.classList.contains("flatpickr-disabled")))
      return;
    const b = p ? p.dateObj.getTime() : e.days.firstElementChild.dateObj.getTime(), C = e.parseDate(e.selectedDates[0], void 0, !0).getTime(), S = Math.min(b, e.selectedDates[0].getTime()), O = Math.max(b, e.selectedDates[0].getTime());
    let $ = !1, j = 0, F = 0;
    for (let G = S; G < O; G += od.DAY)
      Mt(new Date(G), !0) || ($ = $ || G > S && G < O, G < C && (!j || G > j) ? j = G : G > C && (!F || G < F) && (F = G));
    for (let G = 0; G < e.config.showMonths; G++) {
      const Q = e.daysContainer.children[G];
      for (let le = 0, Ze = Q.children.length; le < Ze; le++) {
        const Me = Q.children[le], ht = Me.dateObj.getTime(), sn = j > 0 && ht < j || F > 0 && ht > F;
        if (sn) {
          Me.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach((ln) => {
            Me.classList.remove(ln);
          });
          continue;
        } else if ($ && !sn)
          continue;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach((ln) => {
          Me.classList.remove(ln);
        }), p !== void 0 && (p.classList.add(b <= e.selectedDates[0].getTime() ? "startRange" : "endRange"), C < b && ht === C ? Me.classList.add("startRange") : C > b && ht === C && Me.classList.add("endRange"), ht >= j && (F === 0 || ht <= F) && rd(ht, C, b) && Me.classList.add("inRange"));
      }
    }
  }
  function Ci() {
    e.isOpen && !e.config.static && !e.config.inline && Rn();
  }
  function Di(p, b = e._positionElement) {
    if (e.isMobile === !0) {
      if (p) {
        p.preventDefault();
        const S = We(p);
        S && S.blur();
      }
      e.mobileInput !== void 0 && (e.mobileInput.focus(), e.mobileInput.click()), pe("onOpen");
      return;
    } else if (e._input.disabled || e.config.inline)
      return;
    const C = e.isOpen;
    e.isOpen = !0, C || (e.calendarContainer.classList.add("open"), e._input.classList.add("active"), pe("onOpen"), Rn(b)), e.config.enableTime === !0 && e.config.noCalendar === !0 && e.config.allowInput === !1 && (p === void 0 || !e.timeContainer.contains(p.relatedTarget)) && setTimeout(() => e.hourElement.select(), 50);
  }
  function Oo(p) {
    return (b) => {
      const C = e.config[`_${p}Date`] = e.parseDate(b, e.config.dateFormat), S = e.config[`_${p === "min" ? "max" : "min"}Date`];
      C !== void 0 && (e[p === "min" ? "minDateHasTime" : "maxDateHasTime"] = C.getHours() > 0 || C.getMinutes() > 0 || C.getSeconds() > 0), e.selectedDates && (e.selectedDates = e.selectedDates.filter((O) => Mt(O)), !e.selectedDates.length && p === "min" && d(C), Ct()), e.daysContainer && (Lo(), C !== void 0 ? e.currentYearElement[p] = C.getFullYear().toString() : e.currentYearElement.removeAttribute(p), e.currentYearElement.disabled = !!S && C !== void 0 && S.getFullYear() === C.getFullYear());
    };
  }
  function Ei() {
    const p = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], b = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(t.dataset || {}))), n), C = {};
    e.config.parseDate = b.parseDate, e.config.formatDate = b.formatDate, Object.defineProperty(e.config, "enable", {
      get: () => e.config._enable,
      set: ($) => {
        e.config._enable = Bo($);
      }
    }), Object.defineProperty(e.config, "disable", {
      get: () => e.config._disable,
      set: ($) => {
        e.config._disable = Bo($);
      }
    });
    const S = b.mode === "time";
    if (!b.dateFormat && (b.enableTime || S)) {
      const $ = ye.defaultConfig.dateFormat || Yt.dateFormat;
      C.dateFormat = b.noCalendar || S ? "H:i" + (b.enableSeconds ? ":S" : "") : $ + " H:i" + (b.enableSeconds ? ":S" : "");
    }
    if (b.altInput && (b.enableTime || S) && !b.altFormat) {
      const $ = ye.defaultConfig.altFormat || Yt.altFormat;
      C.altFormat = b.noCalendar || S ? "h:i" + (b.enableSeconds ? ":S K" : " K") : $ + ` h:i${b.enableSeconds ? ":S" : ""} K`;
    }
    Object.defineProperty(e.config, "minDate", {
      get: () => e.config._minDate,
      set: Oo("min")
    }), Object.defineProperty(e.config, "maxDate", {
      get: () => e.config._maxDate,
      set: Oo("max")
    });
    const O = ($) => (j) => {
      e.config[$ === "min" ? "_minTime" : "_maxTime"] = e.parseDate(j, "H:i:S");
    };
    Object.defineProperty(e.config, "minTime", {
      get: () => e.config._minTime,
      set: O("min")
    }), Object.defineProperty(e.config, "maxTime", {
      get: () => e.config._maxTime,
      set: O("max")
    }), b.mode === "time" && (e.config.noCalendar = !0, e.config.enableTime = !0), Object.assign(e.config, C, b);
    for (let $ = 0; $ < p.length; $++)
      e.config[p[$]] = e.config[p[$]] === !0 || e.config[p[$]] === "true";
    jr.filter(($) => e.config[$] !== void 0).forEach(($) => {
      e.config[$] = Vr(e.config[$] || []).map(a);
    }), e.isMobile = !e.config.disableMobile && !e.config.inline && e.config.mode === "single" && !e.config.disable.length && !e.config.enable && !e.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (let $ = 0; $ < e.config.plugins.length; $++) {
      const j = e.config.plugins[$](e) || {};
      for (const F in j)
        jr.indexOf(F) > -1 ? e.config[F] = Vr(j[F]).map(a).concat(e.config[F]) : typeof b[F] > "u" && (e.config[F] = j[F]);
    }
    b.altInputClass || (e.config.altInputClass = Ro().className + " " + e.config.altInputClass), pe("onParseConfig");
  }
  function Ro() {
    return e.config.wrap ? t.querySelector("[data-input]") : t;
  }
  function Io() {
    typeof e.config.locale != "object" && typeof ye.l10ns[e.config.locale] > "u" && e.config.errorHandler(new Error(`flatpickr: invalid locale ${e.config.locale}`)), e.l10n = Object.assign(Object.assign({}, ye.l10ns.default), typeof e.config.locale == "object" ? e.config.locale : e.config.locale !== "default" ? ye.l10ns[e.config.locale] : void 0), no.K = `(${e.l10n.amPM[0]}|${e.l10n.amPM[1]}|${e.l10n.amPM[0].toLowerCase()}|${e.l10n.amPM[1].toLowerCase()})`, Object.assign(Object.assign({}, n), JSON.parse(JSON.stringify(t.dataset || {}))).time_24hr === void 0 && ye.defaultConfig.time_24hr === void 0 && (e.config.time_24hr = e.l10n.time_24hr), e.formatDate = ai(e), e.parseDate = ro({ config: e.config, l10n: e.l10n });
  }
  function Rn(p) {
    if (typeof e.config.position == "function")
      return void e.config.position(e, p);
    if (e.calendarContainer === void 0)
      return;
    pe("onPreCalendarPosition");
    const b = p || e._positionElement, C = Array.prototype.reduce.call(e.calendarContainer.children, (un, Ar) => un + Ar.offsetHeight, 0), S = e.calendarContainer.offsetWidth, O = e.config.position.split(" "), $ = O[0], j = O.length > 1 ? O[1] : null, F = b.getBoundingClientRect(), G = window.innerHeight - F.bottom, Q = $ === "above" || $ !== "below" && G < C && F.top > C, le = window.pageYOffset + F.top + (Q ? -C - 2 : b.offsetHeight + 2);
    if (Ie(e.calendarContainer, "arrowTop", !Q), Ie(e.calendarContainer, "arrowBottom", Q), e.config.inline)
      return;
    let Ze = window.pageXOffset + F.left, Me = !1, Nn = !1;
    j === "center" ? (Ze -= (S - F.width) / 2, Me = !0) : j === "right" && (Ze -= S - F.width, Nn = !0), Ie(e.calendarContainer, "arrowLeft", !Me && !Nn), Ie(e.calendarContainer, "arrowCenter", Me), Ie(e.calendarContainer, "arrowRight", Nn);
    const ht = window.document.body.offsetWidth - (window.pageXOffset + F.right), sn = Ze + S > window.document.body.offsetWidth, ln = ht + S > window.document.body.offsetWidth;
    if (Ie(e.calendarContainer, "rightMost", sn), !e.config.static)
      if (e.calendarContainer.style.top = `${le}px`, !sn)
        e.calendarContainer.style.left = `${Ze}px`, e.calendarContainer.style.right = "auto";
      else if (!ln)
        e.calendarContainer.style.left = "auto", e.calendarContainer.style.right = `${ht}px`;
      else {
        const un = _i();
        if (un === void 0)
          return;
        const Ar = window.document.body.offsetWidth, Li = Math.max(0, Ar / 2 - S / 2), Ni = ".flatpickr-calendar.centerMost:before", Fi = ".flatpickr-calendar.centerMost:after", Bi = un.cssRules.length, ji = `{left:${F.left}px;right:auto;}`;
        Ie(e.calendarContainer, "rightMost", !1), Ie(e.calendarContainer, "centerMost", !0), un.insertRule(`${Ni},${Fi}${ji}`, Bi), e.calendarContainer.style.left = `${Li}px`, e.calendarContainer.style.right = "auto";
      }
  }
  function _i() {
    let p = null;
    for (let b = 0; b < document.styleSheets.length; b++) {
      const C = document.styleSheets[b];
      try {
        C.cssRules;
      } catch {
        continue;
      }
      p = C;
      break;
    }
    return p ?? ki();
  }
  function ki() {
    const p = document.createElement("style");
    return document.head.appendChild(p), p.sheet;
  }
  function Lo() {
    e.config.noCalendar || e.isMobile || (be(), Ln(), he());
  }
  function Tr() {
    e._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(e.close, 0) : e.close();
  }
  function No(p) {
    p.preventDefault(), p.stopPropagation();
    const b = (j) => j.classList && j.classList.contains("flatpickr-day") && !j.classList.contains("flatpickr-disabled") && !j.classList.contains("notAllowed"), C = oi(We(p), b);
    if (C === void 0)
      return;
    const S = C, O = e.latestSelectedDateObj = new Date(S.dateObj.getTime()), $ = (O.getMonth() < e.currentMonth || O.getMonth() > e.currentMonth + e.config.showMonths - 1) && e.config.mode !== "range";
    if (e.selectedDateElem = S, e.config.mode === "single")
      e.selectedDates = [O];
    else if (e.config.mode === "multiple") {
      const j = Pr(O);
      j ? e.selectedDates.splice(parseInt(j), 1) : e.selectedDates.push(O);
    } else e.config.mode === "range" && (e.selectedDates.length === 2 && e.clear(!1, !1), e.latestSelectedDateObj = O, e.selectedDates.push(O), Ye(O, e.selectedDates[0], !0) !== 0 && e.selectedDates.sort((j, F) => j.getTime() - F.getTime()));
    if (c(), $) {
      const j = e.currentYear !== O.getFullYear();
      e.currentYear = O.getFullYear(), e.currentMonth = O.getMonth(), j && (pe("onYearChange"), be()), pe("onMonthChange");
    }
    if (Ln(), he(), Ct(), !$ && e.config.mode !== "range" && e.config.showMonths === 1 ? Z(S) : e.selectedDateElem !== void 0 && e.hourElement === void 0 && e.selectedDateElem && e.selectedDateElem.focus(), e.hourElement !== void 0 && e.hourElement !== void 0 && e.hourElement.focus(), e.config.closeOnSelect) {
      const j = e.config.mode === "single" && !e.config.enableTime, F = e.config.mode === "range" && e.selectedDates.length === 2 && !e.config.enableTime;
      (j || F) && Tr();
    }
    y();
  }
  const In = {
    locale: [Io, xt],
    showMonths: [nn, s, W],
    minDate: [D],
    maxDate: [D],
    clickOpens: [
      () => {
        e.config.clickOpens === !0 ? (h(e._input, "focus", e.open), h(e._input, "click", e.open)) : (e._input.removeEventListener("focus", e.open), e._input.removeEventListener("click", e.open));
      }
    ]
  };
  function Si(p, b) {
    if (p !== null && typeof p == "object") {
      Object.assign(e.config, p);
      for (const C in p)
        In[C] !== void 0 && In[C].forEach((S) => S());
    } else
      e.config[p] = b, In[p] !== void 0 ? In[p].forEach((C) => C()) : jr.indexOf(p) > -1 && (e.config[p] = Vr(b));
    e.redraw(), Ct(!0);
  }
  function Fo(p, b) {
    let C = [];
    if (p instanceof Array)
      C = p.map((S) => e.parseDate(S, b));
    else if (p instanceof Date || typeof p == "number")
      C = [e.parseDate(p, b)];
    else if (typeof p == "string")
      switch (e.config.mode) {
        case "single":
        case "time":
          C = [e.parseDate(p, b)];
          break;
        case "multiple":
          C = p.split(e.config.conjunction).map((S) => e.parseDate(S, b));
          break;
        case "range":
          C = p.split(e.l10n.rangeSeparator).map((S) => e.parseDate(S, b));
          break;
      }
    else
      e.config.errorHandler(new Error(`Invalid date supplied: ${JSON.stringify(p)}`));
    e.selectedDates = e.config.allowInvalidPreload ? C : C.filter((S) => S instanceof Date && Mt(S, !1)), e.config.mode === "range" && e.selectedDates.sort((S, O) => S.getTime() - O.getTime());
  }
  function $i(p, b = !1, C = e.config.dateFormat) {
    if (p !== 0 && !p || p instanceof Array && p.length === 0)
      return e.clear(b);
    Fo(p, C), e.latestSelectedDateObj = e.selectedDates[e.selectedDates.length - 1], e.redraw(), D(void 0, b), d(), e.selectedDates.length === 0 && e.clear(!1), Ct(b), b && pe("onChange");
  }
  function Bo(p) {
    return p.slice().map((b) => typeof b == "string" || typeof b == "number" || b instanceof Date ? e.parseDate(b, void 0, !0) : b && typeof b == "object" && b.from && b.to ? {
      from: e.parseDate(b.from, void 0),
      to: e.parseDate(b.to, void 0)
    } : b).filter((b) => b);
  }
  function Ti() {
    e.selectedDates = [], e.now = e.parseDate(e.config.now) || /* @__PURE__ */ new Date();
    const p = e.config.defaultDate || ((e.input.nodeName === "INPUT" || e.input.nodeName === "TEXTAREA") && e.input.placeholder && e.input.value === e.input.placeholder ? null : e.input.value);
    p && Fo(p, e.config.dateFormat), e._initialDate = e.selectedDates.length > 0 ? e.selectedDates[0] : e.config.minDate && e.config.minDate.getTime() > e.now.getTime() ? e.config.minDate : e.config.maxDate && e.config.maxDate.getTime() < e.now.getTime() ? e.config.maxDate : e.now, e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth(), e.selectedDates.length > 0 && (e.latestSelectedDateObj = e.selectedDates[0]), e.config.minTime !== void 0 && (e.config.minTime = e.parseDate(e.config.minTime, "H:i")), e.config.maxTime !== void 0 && (e.config.maxTime = e.parseDate(e.config.maxTime, "H:i")), e.minDateHasTime = !!e.config.minDate && (e.config.minDate.getHours() > 0 || e.config.minDate.getMinutes() > 0 || e.config.minDate.getSeconds() > 0), e.maxDateHasTime = !!e.config.maxDate && (e.config.maxDate.getHours() > 0 || e.config.maxDate.getMinutes() > 0 || e.config.maxDate.getSeconds() > 0);
  }
  function Mi() {
    if (e.input = Ro(), !e.input) {
      e.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    e.input._type = e.input.type, e.input.type = "text", e.input.classList.add("flatpickr-input"), e._input = e.input, e.config.altInput && (e.altInput = ee(e.input.nodeName, e.config.altInputClass), e._input = e.altInput, e.altInput.placeholder = e.input.placeholder, e.altInput.disabled = e.input.disabled, e.altInput.required = e.input.required, e.altInput.tabIndex = e.input.tabIndex, e.altInput.type = "text", e.input.setAttribute("type", "hidden"), !e.config.static && e.input.parentNode && e.input.parentNode.insertBefore(e.altInput, e.input.nextSibling)), e.config.allowInput || e._input.setAttribute("readonly", "readonly"), e._positionElement = e.config.positionElement || e._input;
  }
  function Pi() {
    const p = e.config.enableTime ? e.config.noCalendar ? "time" : "datetime-local" : "date";
    e.mobileInput = ee("input", e.input.className + " flatpickr-mobile"), e.mobileInput.tabIndex = 1, e.mobileInput.type = p, e.mobileInput.disabled = e.input.disabled, e.mobileInput.required = e.input.required, e.mobileInput.placeholder = e.input.placeholder, e.mobileFormatStr = p === "datetime-local" ? "Y-m-d\\TH:i:S" : p === "date" ? "Y-m-d" : "H:i:S", e.selectedDates.length > 0 && (e.mobileInput.defaultValue = e.mobileInput.value = e.formatDate(e.selectedDates[0], e.mobileFormatStr)), e.config.minDate && (e.mobileInput.min = e.formatDate(e.config.minDate, "Y-m-d")), e.config.maxDate && (e.mobileInput.max = e.formatDate(e.config.maxDate, "Y-m-d")), e.input.getAttribute("step") && (e.mobileInput.step = String(e.input.getAttribute("step"))), e.input.type = "hidden", e.altInput !== void 0 && (e.altInput.type = "hidden");
    try {
      e.input.parentNode && e.input.parentNode.insertBefore(e.mobileInput, e.input.nextSibling);
    } catch {
    }
    h(e.mobileInput, "change", (b) => {
      e.setDate(We(b).value, !1, e.mobileFormatStr), pe("onChange"), pe("onClose");
    });
  }
  function Ai(p) {
    if (e.isOpen === !0)
      return e.close();
    e.open(p);
  }
  function pe(p, b) {
    if (e.config === void 0)
      return;
    const C = e.config[p];
    if (C !== void 0 && C.length > 0)
      for (let S = 0; C[S] && S < C.length; S++)
        C[S](e.selectedDates, e.input.value, e, b);
    p === "onChange" && (e.input.dispatchEvent(Mr("change")), e.input.dispatchEvent(Mr("input")));
  }
  function Mr(p) {
    const b = document.createEvent("Event");
    return b.initEvent(p, !0, !0), b;
  }
  function Pr(p) {
    for (let b = 0; b < e.selectedDates.length; b++)
      if (Ye(e.selectedDates[b], p) === 0)
        return "" + b;
    return !1;
  }
  function Oi(p) {
    return e.config.mode !== "range" || e.selectedDates.length < 2 ? !1 : Ye(p, e.selectedDates[0]) >= 0 && Ye(p, e.selectedDates[1]) <= 0;
  }
  function Ln() {
    e.config.noCalendar || e.isMobile || !e.monthNav || (e.yearElements.forEach((p, b) => {
      const C = new Date(e.currentYear, e.currentMonth, 1);
      C.setMonth(e.currentMonth + b), e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? e.monthElements[b].textContent = nr(C.getMonth(), e.config.shorthandCurrentMonth, e.l10n) + " " : e.monthsDropdownContainer.value = C.getMonth().toString(), p.value = C.getFullYear().toString();
    }), e._hidePrevMonthArrow = e.config.minDate !== void 0 && (e.currentYear === e.config.minDate.getFullYear() ? e.currentMonth <= e.config.minDate.getMonth() : e.currentYear < e.config.minDate.getFullYear()), e._hideNextMonthArrow = e.config.maxDate !== void 0 && (e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth + 1 > e.config.maxDate.getMonth() : e.currentYear > e.config.maxDate.getFullYear()));
  }
  function jo(p) {
    return e.selectedDates.map((b) => e.formatDate(b, p)).filter((b, C, S) => e.config.mode !== "range" || e.config.enableTime || S.indexOf(b) === C).join(e.config.mode !== "range" ? e.config.conjunction : e.l10n.rangeSeparator);
  }
  function Ct(p = !0) {
    e.mobileInput !== void 0 && e.mobileFormatStr && (e.mobileInput.value = e.latestSelectedDateObj !== void 0 ? e.formatDate(e.latestSelectedDateObj, e.mobileFormatStr) : ""), e.input.value = jo(e.config.dateFormat), e.altInput !== void 0 && (e.altInput.value = jo(e.config.altFormat)), p !== !1 && pe("onValueUpdate");
  }
  function Ri(p) {
    const b = We(p), C = e.prevMonthNav.contains(b), S = e.nextMonthNav.contains(b);
    C || S ? ie(C ? -1 : 1) : e.yearElements.indexOf(b) >= 0 ? b.select() : b.classList.contains("arrowUp") ? e.changeYear(e.currentYear + 1) : b.classList.contains("arrowDown") && e.changeYear(e.currentYear - 1);
  }
  function Ii(p) {
    p.preventDefault();
    const b = p.type === "keydown", C = We(p), S = C;
    e.amPM !== void 0 && C === e.amPM && (e.amPM.textContent = e.l10n.amPM[Qe(e.amPM.textContent === e.l10n.amPM[0])]);
    const O = parseFloat(S.getAttribute("min")), $ = parseFloat(S.getAttribute("max")), j = parseFloat(S.getAttribute("step")), F = parseInt(S.value, 10), G = p.delta || (b ? p.which === 38 ? 1 : -1 : 0);
    let Q = F + j * G;
    if (typeof S.value < "u" && S.value.length === 2) {
      const le = S === e.hourElement, Ze = S === e.minuteElement;
      Q < O ? (Q = $ + Q + Qe(!le) + (Qe(le) && Qe(!e.amPM)), Ze && M(void 0, -1, e.hourElement)) : Q > $ && (Q = S === e.hourElement ? Q - $ - Qe(!e.amPM) : O, Ze && M(void 0, 1, e.hourElement)), e.amPM && le && (j === 1 ? Q + F === 23 : Math.abs(Q - F) > j) && (e.amPM.textContent = e.l10n.amPM[Qe(e.amPM.textContent === e.l10n.amPM[0])]), S.value = Be(Q);
    }
  }
  return o(), e;
}
function zt(t, n) {
  const e = Array.prototype.slice.call(t).filter((o) => o instanceof HTMLElement), r = [];
  for (let o = 0; o < e.length; o++) {
    const a = e[o];
    try {
      if (a.getAttribute("data-fp-omit") !== null)
        continue;
      a._flatpickr !== void 0 && (a._flatpickr.destroy(), a._flatpickr = void 0), a._flatpickr = sd(a, n || {}), r.push(a._flatpickr);
    } catch (s) {
      console.error(s);
    }
  }
  return r.length === 1 ? r[0] : r;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(t) {
  return zt(this, t);
}, HTMLElement.prototype.flatpickr = function(t) {
  return zt([this], t);
});
var ye = function(t, n) {
  return typeof t == "string" ? zt(window.document.querySelectorAll(t), n) : t instanceof Node ? zt([t], n) : zt(t, n);
};
ye.defaultConfig = {};
ye.l10ns = {
  en: Object.assign({}, Cn),
  default: Object.assign({}, Cn)
};
ye.localize = (t) => {
  ye.l10ns.default = Object.assign(Object.assign({}, ye.l10ns.default), t);
};
ye.setDefaults = (t) => {
  ye.defaultConfig = Object.assign(Object.assign({}, ye.defaultConfig), t);
};
ye.parseDate = ro({});
ye.formatDate = ai({});
ye.compareDates = Ye;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(t) {
  return zt(this, t);
});
Date.prototype.fp_incr = function(t) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof t == "string" ? parseInt(t, 10) : t));
};
typeof window < "u" && (window.flatpickr = ye);
const id = ["id", "aria-labelledby", "aria-describedby", "aria-errormessage", "placeholder"], ko = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "DateRangePicker",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    modelValue: {},
    maxDate: {},
    maxRange: {},
    startDate: {},
    label: {},
    help: {},
    placeholder: {}
  }, {
    ...dt,
    maxDate: () => /* @__PURE__ */ new Date(),
    maxRange: 0,
    placeholder: "mm-dd-yyyy range",
    startDate: 0
  }), {
    modelValue: {
      ...de,
      default: { maxDate: 0, minDate: 0 }
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", {
      ...de,
      default: { maxDate: 0, minDate: 0 }
    }), { aria: r, errorState: o, inputID: a, isRequired: s, onInvalid: i, validate: l } = ft(n), u = (c) => {
      e.value = c;
    };
    return je(() => {
      const c = {
        allowInput: !0,
        dateFormat: "m-d-Y",
        mode: "range",
        maxDate: n.maxDate,
        minDate: n.startDate,
        onClose: (d) => {
          d.length === 2 ? u({
            minDate: d[0].setUTCHours(0, 0, 0, 0) / 1e3,
            maxDate: Math.floor(
              d[1].setUTCHours(23, 59, 59, 999) / 1e3
            )
          }) : d.length === 0 && u({
            minDate: 0,
            maxDate: 0
          });
        }
      };
      e.value && // NOTE(spk): even with a "default" value this may be a literal null
      e.value.minDate != 0 && e.value.maxDate != 0 && (c.defaultDate = [
        e.value.minDate * 1e3,
        e.value.maxDate * 1e3
      ]), n.maxRange && (c.onChange = (d, f, g) => {
        if (d.length === 1) {
          var h = new Date(d[0].getTime()), y = new Date(d[0].getTime());
          h.setDate(h.getDate() + n.maxRange), y.setDate(y.getDate() - n.maxRange);
          const w = /* @__PURE__ */ new Date();
          h > w && (h = w), g.set("minDate", y), g.set("maxDate", h);
        }
      }), ye(`#${a.value}`, c);
    }), (c, d) => (x(), _("div", null, [
      k(qe, {
        id: m(r).labelledby,
        class: "mb-2",
        for: m(a),
        label: c.label,
        required: m(s)
      }, null, 8, ["id", "for", "label", "required"]),
      v("input", Fe({
        id: m(a),
        "aria-labelledby": m(r).labelledby,
        "aria-describedby": m(r).describedby,
        "aria-errormessage": m(r).errormessage,
        class: [
          "block w-full rounded-md border-0 py-2 shadow-sm ring-1 ring-inset focus:ring-2 sm:text-sm sm:leading-6",
          "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-700 disabled:ring-gray-200",
          m(o) ? "text-red-900 ring-red-700 placeholder:text-red-300 focus:ring-red-700" : "text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-xy-blue-500"
        ],
        placeholder: c.placeholder
      }, c.$attrs, {
        type: "text",
        onInput: d[0] || (d[0] = //@ts-ignore
        (...f) => m(l) && m(l)(...f)),
        onInvalid: d[1] || (d[1] = //@ts-ignore
        (...f) => m(i) && m(i)(...f))
      }), null, 16, id),
      k(Re, {
        id: m(r).describedby,
        class: "mt-1",
        text: c.help
      }, null, 8, ["id", "text"]),
      k(ot, {
        id: m(r).errormessage,
        class: "mt-0.5",
        text: m(o)
      }, null, 8, ["id", "text"])
    ]));
  }
}), ld = ["id", "aria-labelledby", "aria-describedby", "aria-errormessage"], ud = ["textContent"], cd = ["value", "disabled", "textContent"], So = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "Select",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    modelValue: {},
    options: {},
    label: {},
    help: {},
    placeholder: {}
  }, {
    ...dt,
    placeholder: "Select an option"
  }), {
    modelValue: de,
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", de), { aria: r, inputID: o, isRequired: a, validate: s, errorState: i, onInvalid: l } = ft(n);
    return (u, c) => (x(), _("div", null, [
      k(qe, {
        id: m(r).labelledby,
        class: "mb-2",
        for: m(o),
        label: u.label,
        required: m(a)
      }, null, 8, ["id", "for", "label", "required"]),
      Xe(v("select", Fe({
        id: m(o),
        "onUpdate:modelValue": c[0] || (c[0] = (d) => e.value = d),
        "aria-labelledby": m(r).labelledby,
        "aria-describedby": m(r).describedby,
        "aria-errormessage": m(r).errormessage,
        class: [
          "block w-full rounded-md border-0 py-2 shadow-sm ring-1 ring-inset focus:ring-2 sm:text-sm sm:leading-6 pl-3 pr-10",
          "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-700 disabled:ring-gray-200 disabled:opacity-100",
          m(i) ? "text-red-900 ring-red-700 placeholder:text-red-300 focus:ring-red-700" : "text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-xy-blue-500"
        ]
      }, u.$attrs, {
        onChange: c[1] || (c[1] = //@ts-ignore
        (...d) => m(s) && m(s)(...d)),
        onInvalid: c[2] || (c[2] = //@ts-ignore
        (...d) => m(l) && m(l)(...d))
      }), [
        v("option", {
          value: "",
          disabled: "",
          selected: "",
          textContent: U(u.placeholder)
        }, null, 8, ud),
        (x(!0), _(te, null, ae(u.options, (d) => (x(), _("option", {
          key: d.value,
          value: d.value,
          disabled: d.disabled,
          textContent: U(d.label)
        }, null, 8, cd))), 128))
      ], 16, ld), [
        [Gi, e.value]
      ]),
      k(Re, {
        id: m(r).describedby,
        class: "mt-1",
        text: u.help
      }, null, 8, ["id", "text"]),
      k(ot, {
        id: m(r).errormessage,
        class: "mt-0.5",
        text: m(i)
      }, null, 8, ["id", "text"])
    ]));
  }
}), si = /* @__PURE__ */ R({
  __name: "DateFilter",
  props: {
    dateRange: {},
    sortDir: {}
  },
  emits: ["sort-dir-changed", "date-range-changed"],
  setup(t, { emit: n }) {
    const e = t, r = A(e.dateRange), o = A(e.sortDir), a = [
      { label: "Newest-Oldest", value: "desc" },
      { label: "Oldest-Newest", value: "asc" }
    ], s = n, i = (u) => {
      (u === "asc" || u === "desc") && s("sort-dir-changed", u);
    }, l = (u) => {
      u && s("date-range-changed", u);
    };
    return (u, c) => (x(), _(te, null, [
      k(So, {
        modelValue: o.value,
        "onUpdate:modelValue": [
          c[0] || (c[0] = (d) => o.value = d),
          i
        ],
        options: a
      }, null, 8, ["modelValue"]),
      k(ko, {
        modelValue: r.value,
        "onUpdate:modelValue": [
          c[1] || (c[1] = (d) => r.value = d),
          l
        ],
        class: "ml-3"
      }, null, 8, ["modelValue"])
    ], 64));
  }
});
function kn(t, n = "GET", e = {}) {
  const r = A(), o = Ba(), a = A(!1), s = A(!1), i = A(!1), l = A(!1);
  let u = 0, c;
  const d = () => {
    c !== void 0 && c.abort();
  }, f = (g = {}, h = {}) => {
    u++;
    const y = u;
    c = new AbortController(), l.value = !1, s.value = !1, i.value = !0;
    const w = {
      data: ["PATCH", "patch", "POST", "post", "PUT", "put"].includes(n) ? g : {},
      method: n,
      params: ["GET", "get"].includes(n) ? g : {},
      signal: c.signal,
      url: t
    };
    return Ht(w, { ...e, ...h }).then(
      (D) => (r.value = D, o.value = void 0, l.value = !1, D),
      (D) => {
        throw o.value = D, Ou(D) && (l.value = !0), D;
      }
    ).finally(() => {
      y == u && (s.value = !0, i.value = !1), a.value = !0;
    });
  };
  return e != null && e.immediate && e.immediate === !0 && f(), {
    result: r,
    error: o,
    isFinished: s,
    isLoading: i,
    isAborted: l,
    hasFetched: a,
    abort: d,
    execute: f
  };
}
function S0(t, n = {}) {
  return kn(t, "GET", n);
}
function $0(t, n = {}) {
  return kn(t, "DELETE", n);
}
function T0(t, n = {}) {
  return kn(t, "PATCH", n);
}
function M0(t, n = {}) {
  return kn(t, "POST", n);
}
function P0(t, n = {}) {
  return kn(t, "PUT", n);
}
const Sa = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", dd = (t = 8) => {
  let n = "";
  for (let e = 0; e < t; e++)
    n += Sa.charAt(Math.floor(Math.random() * Sa.length));
  return n;
}, fd = {
  CreateIdAttribute: dd
};
function pd(t = {}) {
  const n = A(/* @__PURE__ */ new Map());
  let e = {
    removeDelay: 1e4,
    email: ""
  };
  const r = (f) => {
    e = {
      ...e,
      ...f
    };
  }, o = (f) => {
    n.value.delete(f);
  }, a = (f) => {
    const g = fd.CreateIdAttribute();
    return n.value.set(g, f), (f.persistent === void 0 || !f.persistent) && setTimeout(() => o(g), e.removeDelay), g;
  }, s = (f) => a(f), i = (f, g = !1) => a({ message: f, persistent: g, type: "error" }), l = (f, g = !1) => a({
    message: f,
    persistent: g,
    type: "info"
  }), u = (f, g = !1) => a({
    message: f,
    persistent: g,
    type: "success"
  }), c = (f, g = !1) => a({
    message: f,
    persistent: g,
    type: "warning"
  }), d = (f = "", g = !1) => {
    const h = f || e.email, y = h ? `Whoops! Something went wrong, please reach out to 
        <a class="underline text-xy-blue" href="mailto:${h}">${h}</a> 
        if the issue persists.` : "Whoops! Something went wrong.";
    return a({
      message: y,
      persistent: g,
      type: "error"
    });
  };
  return r(t || {}), {
    flasher: {
      add: a,
      remove: o,
      flash: s,
      error: i,
      warning: c,
      info: l,
      success: u,
      genericError: d
    },
    flashes: n,
    configure: r
  };
}
const md = (t) => {
  if (window.Flashes)
    for (const n of window.Flashes) {
      if (typeof n.type > "u") {
        const e = n.message.split(": ");
        t.add({ type: e[0], message: e[1] });
        continue;
      }
      t.add(n);
    }
};
let qr;
function Ut() {
  return qr === void 0 && (qr = pd()), qr;
}
const ii = {
  error(t, n) {
    Ut().flasher.error(t, n);
  },
  info(t, n) {
    Ut().flasher.info(t, n);
  },
  success(t, n) {
    Ut().flasher.success(t, n);
  },
  warning(t, n) {
    Ut().flasher.warning(t, n);
  },
  genericError(t, n) {
    Ut().flasher.genericError(t, n);
  }
}, A0 = (t, n) => {
  var u;
  const e = A(t), r = {
    initial: ((u = e == null ? void 0 : e.value[0]) == null ? void 0 : u.value) || "",
    paramName: (n == null ? void 0 : n.paramName) || "tab"
  }, o = A(r.initial), a = (c) => !!e.value.find((d) => d.value === c), s = (c) => o.value === c, l = new URLSearchParams(window.location.search).get(r.paramName);
  return l && a(l) && (o.value = l), tt(o, (c) => {
    const d = new URLSearchParams(window.location.search);
    d.set(r.paramName, c.toString());
    const f = d.toString() !== "" ? `?${d.toString()}` : "";
    window.history.replaceState(
      { tab: c },
      document.title,
      `${window.location.pathname}${f}`
    );
  }), {
    activeTab: o,
    isActiveTab: s,
    tabs: e
  };
}, O0 = (t) => {
  const n = A(t);
  return tt(
    n,
    (e) => {
      const r = new URLSearchParams(window.location.search);
      for (const a in e) {
        const s = e[a];
        if (s == null || s == null) {
          r.delete(a);
          continue;
        }
        if (Array.isArray(s)) {
          r.delete(a), s.forEach((i) => {
            r.append(a, i.toString());
          });
          continue;
        }
        !r.has(a) && !s || r.set(a, s.toString());
      }
      const o = r.toString() !== "" ? `?${r.toString()}` : "";
      window.history.replaceState(
        Ot(e),
        document.title,
        `${window.location.pathname}${o}`
      );
    },
    { deep: !0 }
  ), n;
}, hd = { class: "px-4 flex items-center justify-between sm:px-0" }, gd = { class: "w-0 flex-1 flex" }, vd = { class: "hidden md:flex" }, bd = ["onClick", "textContent"], yd = { class: "w-0 flex-1 flex justify-end" }, li = /* @__PURE__ */ R({
  __name: "Paginator",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const n = xe(t, "modelValue"), e = (o) => {
      n.value = {
        ...n.value,
        page: o
      };
    }, r = P(() => {
      const o = [];
      if (n.value.totalPages <= 4) {
        for (let s = 0; s < n.value.totalPages; s++)
          o.push(s + 1);
        return o;
      }
      if (n.value.totalPages - n.value.page >= 3) {
        for (let s = 0; s < 4; s++)
          o.push(n.value.page + s);
        return o;
      }
      for (let s = 0; s < 4; s++)
        o.unshift(n.value.totalPages - s);
      return o;
    });
    return (o, a) => (x(), _("div", hd, [
      v("div", gd, [
        v("a", {
          href: "#",
          class: L([
            "-mt-px border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm leading-5 font-medium focus:outline-none focus:text-gray-700 focus:border-gray-400",
            n.value.page == 1 ? "text-gray-500 cursor-not-allowed pointer-events-none" : "text-gray-700 hover:text-gray-900 hover:border-gray-300"
          ]),
          onClick: a[0] || (a[0] = et((s) => e(n.value.page - 1), ["prevent"]))
        }, a[2] || (a[2] = [
          v("svg", {
            class: "mr-3 h-5 w-5",
            fill: "currentColor",
            viewBox: "0 0 20 20"
          }, [
            v("path", {
              "fill-rule": "evenodd",
              d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
              "clip-rule": "evenodd"
            })
          ], -1),
          ce(" Previous ")
        ]), 2)
      ]),
      v("div", vd, [
        (x(!0), _(te, null, ae(r.value, (s) => (x(), _("a", {
          key: s,
          href: "#",
          class: L([
            "-mt-px border-t-2 pt-4 px-4 inline-flex items-center text-sm leading-5 font-medium",
            n.value.page === s ? "border-blue-500 text-blue-600 focus:outline-none focus:text-blue-800 focus:border-blue-700" : "border-transparent text-gray-700 hover:text-gray-900 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400"
          ]),
          onClick: et((i) => e(s), ["prevent"]),
          textContent: U(s)
        }, null, 10, bd))), 128))
      ]),
      v("div", yd, [
        v("a", {
          href: "#",
          class: L([
            "-mt-px border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm leading-5 font-medium focus:outline-none focus:text-gray-700 focus:border-gray-400",
            n.value.page >= n.value.totalPages ? "text-gray-500 cursor-not-allowed pointer-events-none" : "text-gray-700 hover:text-gray-900 hover:border-gray-300"
          ]),
          onClick: a[1] || (a[1] = et((s) => e(n.value.page + 1), ["prevent"]))
        }, a[3] || (a[3] = [
          ce(" Next "),
          v("svg", {
            class: "ml-3 h-5 w-5",
            fill: "currentColor",
            viewBox: "0 0 20 20"
          }, [
            v("path", {
              "fill-rule": "evenodd",
              d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
              "clip-rule": "evenodd"
            })
          ], -1)
        ]), 2)
      ])
    ]));
  }
}), wd = {
  key: 0,
  class: "flex"
}, xd = /* @__PURE__ */ R({
  __name: "DetailList",
  props: {
    borderless: { type: Boolean, default: !1 },
    defaultSort: { default: "created_at" },
    defaultSortDir: { default: "desc" },
    disableDate: { type: Boolean, default: !1 },
    disableNavigation: { type: Boolean, default: !1 },
    perPage: { default: 10 },
    url: {}
  },
  setup(t, { expose: n }) {
    const e = t, r = A({
      minDate: 0,
      maxDate: 0
    }), o = A([]), a = A({
      page: 1,
      perPage: e.perPage,
      totalItems: 0,
      totalPages: 0
    }), s = A(e.defaultSort), i = A(e.defaultSortDir), l = () => {
      const h = {
        maxDate: r.value.maxDate,
        minDate: r.value.minDate,
        page: a.value.page,
        perPage: a.value.perPage,
        q: "",
        sort: s.value,
        sortDir: i.value
      };
      hs.get(e.url, {}, h).then(
        (y) => {
          a.value = {
            page: y.data.page,
            perPage: y.data.perPage,
            totalItems: y.data.totalItems,
            totalPages: y.data.totalPages
          }, o.value = y.data.items;
        },
        () => {
          ii.genericError();
        }
      );
    }, u = P(() => !!o.value.length), c = P(() => !e.disableDate), d = P(() => !e.disableNavigation && u), g = {
      refresh: l,
      reset: () => {
        a.value.page = 1, l();
      }
    };
    return tt([i, r], () => {
      l();
    }), n(g), l(), (h, y) => (x(), _("div", {
      class: L({ "mt-4 space-y-2": c.value })
    }, [
      h.disableDate ? B("", !0) : (x(), _("div", wd, [
        k(si, {
          "date-range": r.value,
          "sort-dir": i.value,
          onSortDirChanged: y[0] || (y[0] = (w) => i.value = w),
          onDateRangeChanged: y[1] || (y[1] = (w) => r.value = w)
        }, null, 8, ["date-range", "sort-dir"])
      ])),
      u.value ? (x(), _("div", {
        key: 1,
        class: L(["overflow-hidden", { "shadow sm:rounded-md border": !h.borderless }])
      }, [
        v("ul", null, [
          (x(!0), _(te, null, ae(o.value, (w, D) => (x(), _("li", {
            key: D,
            class: L({ "border-t border-gray-200": D > 0 })
          }, [
            ge(h.$slots, "default", { item: w })
          ], 2))), 128))
        ])
      ], 2)) : ge(h.$slots, "empty", { key: 2 }, () => [
        y[4] || (y[4] = ce(" No items were found! "))
      ]),
      d.value ? (x(), V(li, {
        key: 3,
        modelValue: a.value,
        "onUpdate:modelValue": [
          y[2] || (y[2] = (w) => a.value = w),
          y[3] || (y[3] = (w) => l())
        ]
      }, null, 8, ["modelValue"])) : B("", !0)
    ], 2));
  }
}), Cd = ["href"], Dd = /* @__PURE__ */ R({
  __name: "DownloadCell",
  props: {
    propsData: {},
    attribute: {}
  },
  setup(t) {
    return (n, e) => (x(), _("a", {
      href: n.propsData[n.attribute]
    }, [
      k(m(wc), { class: "h-6 w-6 group-hover:text-gray-500 transition" })
    ], 8, Cd));
  }
}), Ed = { class: "fixed inset-0 flex flex-col items-end justify-end px-4 py-6 pointer-events-none sm:p-6 z-[45]" }, _d = { class: "rounded-lg ring-1 ring-black ring-opacity-5 overflow-hidden" }, kd = { class: "p-4" }, Sd = { class: "flex items-center" }, $d = { class: "w-0 flex-1 flex justify-between" }, Td = ["innerHTML"], Md = { class: "ml-4 shrink-0 flex" }, Pd = ["onClick"], $o = /* @__PURE__ */ R({
  __name: "Flash",
  setup(t) {
    const { flasher: n, flashes: e } = Ut(), r = (o) => {
      switch (o) {
        case "warning":
          return "border-orange-500";
        case "error":
          return "border-red-500";
        case "info":
          return "border-blue-500";
        case "success":
          return "border-green-500";
      }
    };
    return je(() => {
      md(n);
    }), (o, a) => (x(), V(m(ho), null, {
      default: N(() => [
        v("div", Ed, [
          k(Ji, {
            tag: "div",
            class: "max-w-sm space-y-2 w-full",
            "enter-active-class": "ease-out duration-300",
            "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
            "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
            "leave-active-class": "ease-in duration-100",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: N(() => [
              (x(!0), _(te, null, ae(m(e), ([s, i]) => (x(), _("div", {
                key: i.message,
                class: L(["bg-white shadow-lg rounded-lg pointer-events-auto border-t-4 transform z-10", [r(i.type)]])
              }, [
                v("div", _d, [
                  v("div", kd, [
                    v("div", Sd, [
                      v("div", $d, [
                        v("p", {
                          class: "w-0 flex-1 text-sm leading-5 font-medium text-gray-900",
                          innerHTML: i.message
                        }, null, 8, Td)
                      ]),
                      v("div", Md, [
                        v("button", {
                          class: "inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150",
                          onClick: (l) => m(n).remove(s)
                        }, a[0] || (a[0] = [
                          v("svg", {
                            class: "h-5 w-5",
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, [
                            v("path", {
                              "fill-rule": "evenodd",
                              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                              "clip-rule": "evenodd"
                            })
                          ], -1)
                        ]), 8, Pd)
                      ])
                    ])
                  ])
                ])
              ], 2))), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }));
  }
});
function Ad(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]);
}
function Od(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M4 6h16M4 12h16M4 18h7"
    })
  ]);
}
function Rd(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M4 6h16M4 12h16M4 18h16"
    })
  ]);
}
function $a(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]);
}
function Sn(t, n) {
  return x(), V("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    k("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M6 18L18 6M6 6l12 12"
    })
  ]);
}
const Id = { class: "flex" }, Ld = { class: "flex-shrink-0" }, Nd = { class: "ml-2.5" }, Fd = {
  key: 0,
  role: "list",
  class: "list-disc space-y-1 pl-5"
}, Bd = { key: 1 }, jd = {
  key: 1,
  class: "mt-4"
}, Vd = { class: "flex flex-col gap-y-1.5 -mx-2 sm:flex-row sm:gap-x-3 sm:items-center" }, Hd = { key: 0 }, Ud = ["href", "role"], qd = { key: 1 }, Wd = ["href", "role"], Yd = {
  key: 0,
  class: "ml-auto pl-3"
}, zd = { class: "-mx-1.5 -my-1.5" }, Kd = /* @__PURE__ */ R({
  __name: "InlineAlert",
  props: {
    btnLink: { default: "" },
    btnText: { default: "" },
    content: {},
    dismissable: { type: Boolean, default: !1 },
    secondaryBtnLink: { default: "" },
    secondaryBtnText: { default: "" },
    title: { default: "" },
    kind: {}
  },
  emits: ["close", "click", "click:secondary"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = A(!0), a = () => {
      o.value = !1, r("close", !0);
    }, s = P(() => {
      const l = {
        bgColor: "",
        btnAction: "",
        btnClose: "",
        contentColor: "",
        iconColor: ""
      };
      switch (e.kind) {
        case "alert":
          l.bgColor = "bg-red-50", l.btnAction = "bg-red-50 text-red-900 hover:bg-red-100 focus:ring-red-600 focus:ring-offset-red-50", l.btnClose = "bg-red-50 text-red-600 hover:bg-red-100 focus:ring-red-600 focus:ring-offset-red-50", l.contentColor = "text-red-800", l.iconColor = "text-red-400";
          break;
        case "info":
          l.bgColor = "bg-blue-50", l.btnAction = "bg-blue-50 text-blue-900 hover:bg-blue-100 focus:ring-blue-600 focus:ring-offset-blue-50", l.btnClose = "bg-blue-50 text-blue-600 hover:bg-blue-100 focus:ring-blue-600 focus:ring-offset-blue-50", l.contentColor = "text-blue-800", l.iconColor = "text-blue-400";
          break;
        case "success":
          l.bgColor = "bg-emerald-50", l.btnAction = "bg-emerald-50 text-emerald-900 hover:bg-emerald-100 focus:ring-emerald-600 focus:ring-offset-emerald-50", l.btnClose = "bg-emerald-50 text-emerald-600 hover:bg-emerald-100 focus:ring-emerald-600 focus:ring-offset-emerald-50", l.contentColor = "text-emerald-800", l.iconColor = "text-emerald-400";
          break;
        case "warn":
          l.bgColor = "bg-amber-50", l.btnAction = "bg-amber-50 text-amber-900 hover:bg-amber-100 focus:ring-amber-600 focus:ring-offset-amber-50", l.btnClose = "bg-amber-50 text-amber-600 hover:bg-amber-100 focus:ring-amber-600 focus:ring-offset-amber-50", l.contentColor = "text-amber-800", l.iconColor = "text-amber-400";
          break;
      }
      return l;
    }), i = P(() => {
      let l = null;
      switch (e.kind) {
        case "alert":
          l = Dc;
          break;
        case "info":
          l = Cc;
          break;
        case "success":
          l = Hs;
          break;
        case "warn":
          l = xc;
          break;
      }
      return l;
    });
    return (l, u) => o.value ? (x(), _("div", {
      key: 0,
      class: L(["rounded-xy p-4", s.value.bgColor])
    }, [
      v("div", Id, [
        v("div", Ld, [
          (x(), V(rt(i.value), {
            class: L(["h-5 w-5", s.value.iconColor]),
            "aria-hidden": "true"
          }, null, 8, ["class"]))
        ]),
        v("div", Nd, [
          l.title ? (x(), _("h3", {
            key: 0,
            class: L(["text-sm leading-snug font-semibold mb-1.5", s.value.contentColor])
          }, U(l.title), 3)) : B("", !0),
          v("div", {
            class: L(["text-sm", s.value.contentColor])
          }, [
            Array.isArray(l.content) ? (x(), _("ul", Fd, [
              (x(!0), _(te, null, ae(l.content, (c, d) => (x(), _("li", { key: d }, U(c), 1))), 128))
            ])) : (x(), _("p", Bd, U(l.content), 1))
          ], 2),
          l.btnText || l.secondaryBtnText ? (x(), _("div", jd, [
            v("div", Vd, [
              l.btnText ? (x(), _("div", Hd, [
                v("a", {
                  class: L(["inline-flex rounded-3xl px-2.5 py-1.5 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", s.value.btnAction]),
                  href: l.btnLink,
                  role: l.btnLink ? "link" : "button",
                  onClick: u[0] || (u[0] = (c) => l.$emit("click", c))
                }, U(l.btnText), 11, Ud)
              ])) : B("", !0),
              l.secondaryBtnText ? (x(), _("div", qd, [
                v("a", {
                  class: L(["inline-flex rounded-3xl px-2.5 py-1.5 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", s.value.btnAction]),
                  href: l.secondaryBtnLink,
                  role: l.secondaryBtnLink ? "link" : "button",
                  onClick: u[1] || (u[1] = (c) => l.$emit("click:secondary", c))
                }, U(l.secondaryBtnText), 11, Wd)
              ])) : B("", !0)
            ])
          ])) : B("", !0)
        ]),
        l.dismissable ? (x(), _("div", Yd, [
          v("div", zd, [
            v("button", {
              class: L(["inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2", s.value.btnClose]),
              type: "button",
              onClick: a
            }, [
              u[2] || (u[2] = v("span", { class: "sr-only" }, "close", -1)),
              k(m(Sn), { class: "h-4 w-4" })
            ], 2)
          ])
        ])) : B("", !0)
      ])
    ], 2)) : B("", !0);
  }
}), Gd = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }, Jd = { class: "block absolute top-0 right-0 pt-4 pr-4 sm:pt-6 sm:pr-8" }, Xd = { class: "bg-white px-4 pt-5 pb-4 sm:p-8 sm:pb-6" }, Zd = { class: "mt-3 sm:mt-0 sm:text-left" }, Qd = { class: "mt-2" }, ef = {
  key: 0,
  class: "bg-gray-50 px-4 py-3 sm:py-4 sm:px-8 sm:flex sm:flex-row-reverse"
}, tf = ["disabled", "textContent"], nf = /* @__PURE__ */ R({
  __name: "Modal",
  props: /* @__PURE__ */ ve({
    destructive: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    wide: { type: Boolean, default: !1 },
    submitText: { default: "" },
    title: { default: "" }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ve(["close", "submit"], ["update:modelValue"]),
  setup(t, { emit: n }) {
    const e = xe(t, "modelValue"), r = n, o = () => {
      r("submit");
    };
    return tt(e, (a) => {
      a || r("close");
    }), (a, s) => (x(), V(m(_n), {
      as: "template",
      show: e.value
    }, {
      default: N(() => [
        k(m(vr), {
          as: "div",
          static: "",
          class: "fixed z-30 inset-0 overflow-y-auto",
          open: e.value,
          onClose: s[3] || (s[3] = (i) => e.value = !1)
        }, {
          default: N(() => [
            v("div", Gd, [
              k(m(wt), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: N(() => [
                  k(m(br), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              s[5] || (s[5] = v("span", {
                class: "hidden sm:inline-block sm:align-middle sm:h-screen",
                "aria-hidden": "true"
              }, "​", -1)),
              k(m(wt), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: N(() => [
                  v("div", {
                    class: L(["inline-block align-bottom bg-white rounded-xy text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:rounded-xy-lg w-full", a.wide ? "sm:max-w-6xl" : "sm:max-w-2xl"])
                  }, [
                    v("div", Jd, [
                      v("button", {
                        type: "button",
                        class: "bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                        onClick: s[0] || (s[0] = (i) => e.value = !1)
                      }, [
                        s[4] || (s[4] = v("span", { class: "sr-only" }, "Close", -1)),
                        k(m(Sn), {
                          class: "h-6 w-6",
                          "aria-hidden": "true"
                        })
                      ])
                    ]),
                    v("div", Xd, [
                      v("div", Zd, [
                        k(m(go), {
                          as: "h3",
                          class: "text-center text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: N(() => [
                            ce(U(a.title), 1)
                          ]),
                          _: 1
                        }),
                        v("div", Qd, [
                          ge(a.$slots, "default")
                        ])
                      ])
                    ]),
                    a.submitText ? (x(), _("div", ef, [
                      v("button", {
                        type: "button",
                        class: L(["xy-btn w-full sm:ml-3 sm:w-auto sm:text-sm", [a.destructive ? "xy-btn-red" : "xy-btn"]]),
                        disabled: a.disabled,
                        onClick: s[1] || (s[1] = (i) => o()),
                        textContent: U(a.submitText)
                      }, null, 10, tf),
                      v("button", {
                        type: "button",
                        class: "xy-btn-neutral mt-3 w-full sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
                        onClick: s[2] || (s[2] = (i) => e.value = !1)
                      }, " Cancel ")
                    ])) : B("", !0),
                    ge(a.$slots, "buttons")
                  ], 2)
                ]),
                _: 3
              })
            ])
          ]),
          _: 3
        }, 8, ["open"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), rf = { class: "aspect-square overflow-hidden" }, of = { class: "flex justify-center relative" }, af = { class: "sr-only" }, ui = /* @__PURE__ */ R({
  __name: "XYSpinner",
  setup(t) {
    const n = ir();
    return (e, r) => {
      var o, a;
      return x(), _("div", {
        class: L((o = m(n)) != null && o.class ? (a = m(n)) == null ? void 0 : a.class : "h-20 w-20"),
        role: "status"
      }, [
        v("div", rf, [
          v("div", of, [
            v("p", af, [
              ge(e.$slots, "default", {}, () => [
                r[0] || (r[0] = ce("loading"))
              ])
            ]),
            r[1] || (r[1] = Xi('<div class="animate-spin-gear drop-shadow-sm"><svg class="h-full w-full text-xy-green-300" viewBox="0 0 129 129" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><polygon id="path-1" points="0.000248076923 0.48676924 128.472837 0.48676924 128.472837 128.800648 0.000248076923 128.800648"></polygon></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group-6-Copy-3"><g id="Group-3"><mask id="mask-2" fill="white"><use xlink:href="#path-1"></use></mask><g id="Clip-2"></g><path id="Fill-1" d="M86.3955173,100.279324 C86.3955173,100.279324 79.4778923,106.213874 64.2360462,106.755809 C48.9954404,106.213874 42.0778154,100.279324 42.0778154,100.279324 C11.8756904,81.4963011 25.2309115,49.088357 25.2309115,49.088357 C36.5680269,24.1350542 59.1839596,22.5554236 63.8105942,22.4983139 L63.8105942,22.5043894 C63.8105942,22.5043894 63.9681231,22.4983139 64.2360462,22.4958837 C64.5052096,22.4983139 64.6627385,22.5043894 64.6627385,22.5043894 L64.6627385,22.4983139 C69.2881327,22.5554236 91.9053058,24.1350542 103.241181,49.088357 C103.241181,49.088357 116.596402,81.4963011 86.3955173,100.279324 L86.3955173,100.279324 Z M128.473085,68.8191581 L128.473085,60.4677727 L117.036738,58.80187 L115.10794,49.3726905 L124.970238,43.4186983 L121.675777,35.7307578 L110.49619,38.6214817 L106.161046,32.1486416 L113.220075,23.080347 L107.361738,17.0716753 L97.9645846,23.7437918 L89.14545,17.842049 L91.8693346,6.72144964 L84.04995,3.59378109 L78.2114596,13.4628269 L69.5907865,11.8127205 L67.908825,0.48676924 L64.6627385,0.48676924 L63.8105942,0.48676924 L60.5645077,0.48676924 L58.8813058,11.8127205 L50.2618731,13.4628269 L44.4233827,3.59378109 L36.6039981,6.72144964 L39.3278827,17.842049 L30.5087481,23.7437918 L21.1103538,17.0716753 L15.2520173,23.080347 L22.3122865,32.1486416 L17.9771423,38.6214817 L6.79755577,35.7307578 L3.50185385,43.4186983 L13.3641519,49.3726905 L11.4365942,58.80187 L0.000248076923,60.4677727 L0.000248076923,68.8191581 L11.4365942,70.4850608 L13.1036712,79.0223566 L3.13718077,84.8050196 L6.29644038,92.5488548 L17.5244019,89.8513318 L23.4832096,98.5854738 L16.7466808,107.893143 L22.8134019,113.695248 L31.9699212,106.70356 L38.5067481,110.99651 L35.5881231,122.068505 L43.35045,125.332265 L49.3625942,115.565287 L58.8813058,117.47421 L60.5645077,128.801377 L63.6927577,128.801377 L64.780575,128.801377 L67.908825,128.801377 L69.5907865,117.47421 L79.1107385,115.565287 L85.1228827,125.332265 L92.8852096,122.068505 L89.9665846,110.99651 L96.5034115,106.70356 L105.659931,113.695248 L111.725412,107.893143 L104.988883,98.5854738 L110.94769,89.8513318 L122.175652,92.5488548 L125.334912,84.8050196 L115.369662,79.0223566 L117.035498,70.4850608 L128.473085,68.8191581 Z" fill="currentColor" mask="url(#mask-2)"></path></g></g></g></svg></div><div class="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center transform scale-50"><svg viewBox="0 0 280 280" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path class="fill-xy-green" d="m17.57,94.37c-3.36,13.54-5.07,28.73-5.07,45.63,0,32.02,6.04,58,18.1,77.95,3.81,4.98,7.46,9.94,10.95,14.66,21.21,23.24,54.01,34.89,98.45,34.89.71,0,1.39-.03,2.09-.03-3.62-46.93-22.27-88.31-54.36-124.11-19.79-22.07-42.96-38.86-70.16-48.99Z"></path><path class="fill-xy-blue" d="m267.5,140c0-85-42.5-127.5-127.5-127.5-55.06,0-92.27,17.86-111.66,53.53,28.32,8.48,56.67,16.85,84.98,25.37,27.05,8.14,54.01,16.55,81.06,24.67,5.45,1.64,7.5,4.76,6.63,10.27-.69,4.35-1.04,8.75-1.57,13.13-4.95,40.77-8.32,81.74-12.43,122.61,53.64-13.88,80.49-54.56,80.49-122.08Z"></path></svg></div>', 2))
          ])
        ])
      ], 2);
    };
  }
}), sf = {
  key: 0,
  class: "fixed top-0 left-0 flex flex-col items-center justify-center w-full h-full cursor-not-allowed z-40 bg-gray-50 bg-opacity-60"
}, lf = { class: "mt-2" }, To = /* @__PURE__ */ R({
  __name: "Spinner",
  setup(t) {
    const { idx: n, loading: e, maxIdx: r, messages: o, msg: a, showMsg: s } = ms(), i = () => {
      n.value++, n.value > r.value && (n.value = 0), o.value && (a.value = o.value[n.value]), s.value = !0;
    }, l = () => {
      window.setTimeout(() => {
        s.value = !1;
      }, 2500);
    };
    return (u, c) => (x(), V(m(ho), null, {
      default: N(() => [
        m(e) ? (x(), _("div", sf, [
          k(ui, { class: "w-32 h-32" }),
          Xe(v("div", lf, [
            k(lr, {
              appear: "",
              "enter-active-class": "ease-out duration-1000",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "ease-in duration-500",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0",
              onAfterEnter: l,
              onAfterLeave: i
            }, {
              default: N(() => [
                Xe(v("div", { class: "container font-medium text-lg leading-snug text-center transition-opacity" }, U(m(a)), 513), [
                  [Vo, m(s)]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [Vo, m(o)]
          ])
        ])) : B("", !0)
      ]),
      _: 1
    }));
  }
}), uf = { class: "h-screen flex overflow-hidden bg-gray-50" }, cf = { class: "relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white" }, df = { class: "absolute top-0 right-0 -mr-12 pt-2" }, ff = { class: "shrink-0 flex justify-center px-4" }, pf = ["src"], mf = { class: "mt-5 flex flex-col flex-1 h-0 overflow-y-auto" }, hf = { class: "flex-1 px-2" }, gf = { class: "space-y-1" }, vf = ["href", "target"], bf = {
  key: 0,
  class: "mt-auto"
}, yf = { class: "mt-6 px-2" }, wf = { class: "hidden lg:flex lg:shrink-0" }, xf = { class: "flex flex-col w-64" }, Cf = { class: "flex flex-col grow border-r border-gray-200 pt-5 pb-4 bg-white overflow-y-auto" }, Df = { class: "flex justify-center shrink-0 px-4" }, Ef = ["src"], _f = { class: "mt-5 grow flex flex-col" }, kf = { class: "flex-1 px-2 bg-white" }, Sf = { class: "space-y-1" }, $f = ["href", "target"], Tf = {
  key: 0,
  class: "mt-atuo"
}, Mf = { class: "mt-6 px-2" }, Pf = { class: "flex flex-col w-0 flex-1 overflow-hidden" }, Af = { class: "relative z-10 shrink-0 flex h-16 bg-xy-blue shadow" }, Of = { class: "flex-1 px-4 flex justify-between" }, Rf = { class: "flex-1 flex" }, If = { class: "flex items-center text-base leading-snug sm:text-2xl text-white" }, Lf = { class: "ml-4 flex items-center lg:ml-6" }, Nf = ["href"], Ff = { class: "flex-1 relative overflow-y-auto focus:outline-none" }, Bf = { class: "mx-auto" }, jf = /* @__PURE__ */ R({
  __name: "SidebarLayout",
  props: {
    activeUrl: { default: "" },
    iconUrl: {},
    navigation: {},
    userNavigation: {}
  },
  setup(t) {
    const n = t, e = A(!1), r = (o) => n.activeUrl === o;
    return (o, a) => (x(), _(te, null, [
      v("div", uf, [
        k(m(_n), {
          as: "template",
          show: e.value
        }, {
          default: N(() => [
            k(m(vr), {
              as: "div",
              static: "",
              class: "fixed inset-0 flex z-10 lg:hidden",
              open: e.value,
              onClose: a[1] || (a[1] = (s) => e.value = !1)
            }, {
              default: N(() => [
                k(m(wt), {
                  as: "template",
                  enter: "transition-opacity ease-linear duration-300",
                  "enter-from": "opacity-0",
                  "enter-to": "opacity-100",
                  leave: "transition-opacity ease-linear duration-300",
                  "leave-from": "opacity-100",
                  "leave-to": "opacity-0"
                }, {
                  default: N(() => [
                    k(m(br), { class: "fixed inset-0 bg-gray-600 bg-opacity-75" })
                  ]),
                  _: 1
                }),
                k(m(wt), {
                  as: "template",
                  enter: "transition ease-in-out duration-300 transform",
                  "enter-from": "-translate-x-full",
                  "enter-to": "translate-x-0",
                  leave: "transition ease-in-out duration-300 transform",
                  "leave-from": "translate-x-0",
                  "leave-to": "-translate-x-full"
                }, {
                  default: N(() => [
                    v("div", cf, [
                      k(m(wt), {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: N(() => [
                          v("div", df, [
                            v("button", {
                              class: "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                              onClick: a[0] || (a[0] = (s) => e.value = !1)
                            }, [
                              a[3] || (a[3] = v("span", { class: "sr-only" }, "Close sidebar", -1)),
                              k(m(Sn), {
                                class: "h-6 w-6 text-white",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      v("div", ff, [
                        v("img", {
                          class: "w-auto h-12",
                          src: o.iconUrl,
                          alt: "Logo"
                        }, null, 8, pf)
                      ]),
                      v("div", mf, [
                        v("div", hf, [
                          ge(o.$slots, "sidebar-nav", {}, () => [
                            v("nav", gf, [
                              (x(!0), _(te, null, ae(o.navigation, (s) => (x(), _("a", {
                                key: s.name,
                                href: s.url,
                                class: L([
                                  r(s.url) ? "bg-gray-100 text-gray-900" : "text-gray-700 hover:bg-gray-50 hover:text-gray-900",
                                  "group flex items-center px-2 py-2 text-base font-semibold rounded-md"
                                ]),
                                target: s.openInTab ? "_blank" : "_self"
                              }, [
                                (x(), V(rt(s.icon), {
                                  class: L([
                                    r(s.url) ? "text-gray-600" : "text-gray-500 group-hover:text-gray-600",
                                    "mr-4 h-6 w-6"
                                  ]),
                                  "aria-hidden": "true"
                                }, null, 8, ["class"])),
                                ce(" " + U(s.name), 1)
                              ], 10, vf))), 128))
                            ])
                          ])
                        ]),
                        o.$slots["sidebar-bottom"] ? (x(), _("div", bf, [
                          v("div", yf, [
                            ge(o.$slots, "sidebar-bottom")
                          ])
                        ])) : B("", !0)
                      ])
                    ])
                  ]),
                  _: 3
                }),
                a[4] || (a[4] = v("div", {
                  class: "shrink-0 w-14",
                  "aria-hidden": "true"
                }, null, -1))
              ]),
              _: 3
            }, 8, ["open"])
          ]),
          _: 3
        }, 8, ["show"]),
        v("div", wf, [
          v("div", xf, [
            v("div", Cf, [
              v("div", Df, [
                v("img", {
                  class: "w-auto h-12",
                  src: o.iconUrl,
                  alt: "Logo"
                }, null, 8, Ef)
              ]),
              v("div", _f, [
                v("div", kf, [
                  ge(o.$slots, "sidebar-nav", {}, () => [
                    v("nav", Sf, [
                      (x(!0), _(te, null, ae(o.navigation, (s) => (x(), _("a", {
                        key: s.name,
                        href: s.url,
                        class: L([
                          r(s.url) ? "bg-gray-100 text-gray-900" : "text-gray-800 hover:bg-gray-100 hover:text-gray-900",
                          "group flex items-center px-2 py-2 text-sm font-semibold rounded-md"
                        ]),
                        target: s.openInTab ? "_blank" : "_self"
                      }, [
                        (x(), V(rt(s.icon), {
                          class: L([
                            r(s.url) ? "text-gray-600" : "text-gray-400 group-hover:text-gray-600",
                            "mr-3 h-6 w-6"
                          ]),
                          "aria-hidden": "true"
                        }, null, 8, ["class"])),
                        ce(" " + U(s.name), 1)
                      ], 10, $f))), 128))
                    ])
                  ])
                ]),
                o.$slots["sidebar-bottom"] ? (x(), _("div", Tf, [
                  v("div", Mf, [
                    ge(o.$slots, "sidebar-bottom")
                  ])
                ])) : B("", !0)
              ])
            ])
          ])
        ]),
        v("div", Pf, [
          v("div", Af, [
            v("button", {
              class: "px-4 border-r border-gray-200 text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 lg:hidden",
              onClick: a[2] || (a[2] = (s) => e.value = !0)
            }, [
              a[5] || (a[5] = v("span", { class: "sr-only" }, "Open sidebar", -1)),
              k(m(Od), {
                class: "h-6 w-6",
                "aria-hidden": "true"
              })
            ]),
            v("div", Of, [
              v("div", Rf, [
                v("h1", If, [
                  ge(o.$slots, "header")
                ])
              ]),
              v("div", Lf, [
                k(m(vo), {
                  as: "div",
                  class: "ml-3 relative"
                }, {
                  default: N(() => [
                    v("div", null, [
                      k(m(bo), { class: "max-w-xs flex items-center text-sm text-white rounded-full hover:bg-blue-900 hover:text-gray-50 focus:outline-none focus:ring focus:text-white" }, {
                        default: N(() => [
                          a[6] || (a[6] = v("span", { class: "sr-only" }, "Open user menu", -1)),
                          k(m(bc), {
                            class: "h-8 w-8",
                            fill: "currentColor"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    k(lr, {
                      "enter-active-class": "transition ease-out duration-100",
                      "enter-from-class": "transform opacity-0 scale-95",
                      "enter-to-class": "transform opacity-100 scale-100",
                      "leave-active-class": "transition ease-in duration-75",
                      "leave-from-class": "transform opacity-100 scale-100",
                      "leave-to-class": "transform opacity-0 scale-95"
                    }, {
                      default: N(() => [
                        k(m(yo), { class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                          default: N(() => [
                            (x(!0), _(te, null, ae(o.userNavigation, (s) => (x(), V(m(wo), {
                              key: s.name
                            }, {
                              default: N(({ active: i }) => [
                                v("a", {
                                  href: s.url,
                                  class: L([
                                    i ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700 font-semibold"
                                  ])
                                }, U(s.name), 11, Nf)
                              ]),
                              _: 2
                            }, 1024))), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          v("main", Ff, [
            v("div", Bf, [
              ge(o.$slots, "default")
            ])
          ])
        ])
      ]),
      k($o),
      k(To)
    ], 64));
  }
}), oo = /* @__PURE__ */ R({
  __name: "Popover",
  props: {
    as: { default: "div" },
    position: { default: "auto" }
  },
  setup(t) {
    const n = t, e = Nt("trigger"), r = Nt("wrapper"), o = P(() => {
      const i = [Rc(5), Lc()];
      return n.position === "auto" && i.push(Oc()), i;
    }), a = P(() => {
      if (n.position !== "auto")
        return n.position;
    }), { floatingStyles: s } = ri(e, r, {
      middleware: o,
      placement: a,
      strategy: "fixed",
      whileElementsMounted: ti
    });
    return (i, l) => (x(), V(m(As), {
      as: i.as,
      class: "relative"
    }, {
      default: N(({ open: u, close: c }) => [
        k(m(ac), { ref: "trigger" }, {
          default: N(() => [
            ge(i.$slots, "button", {
              open: u,
              close: c
            })
          ]),
          _: 2
        }, 1536),
        v("div", {
          ref: "wrapper",
          class: "z-[5]",
          style: ja(m(s))
        }, [
          k(m(sc), null, {
            default: N(() => [
              ge(i.$slots, "default", {
                open: u,
                close: c
              })
            ]),
            _: 2
          }, 1024)
        ], 4)
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), Vf = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [r, o] of n)
    e[r] = o;
  return e;
}, Hf = {}, Uf = { class: "w-full max-w-xs bg-white rounded-xy p-2 border border-gray-100 shadow-md" };
function qf(t, n) {
  return x(), _("div", Uf, [
    ge(t.$slots, "default")
  ]);
}
const Wf = /* @__PURE__ */ Vf(Hf, [["render", qf]]), Yf = { class: "absolute inset-0 overflow-hidden" }, zf = { class: "fixed inset-y-0 right-0 pl-10 max-w-full flex" }, Kf = { class: "w-screen max-w-md" }, Gf = { class: "h-full flex flex-col bg-white shadow-xl overflow-y-scroll" }, Jf = { class: "py-6 px-4 bg-xy-blue-700 sm:px-6" }, Xf = { class: "flex items-center justify-between" }, Zf = { class: "ml-3 h-7 flex items-center" }, Qf = { class: "mt-1" }, ep = ["textContent"], tp = { class: "relative flex-1 py-6 px-4 sm:px-6" }, np = /* @__PURE__ */ R({
  __name: "Slideover",
  props: /* @__PURE__ */ ve({
    header: {},
    description: {}
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ve(["close"], ["update:modelValue"]),
  setup(t, { emit: n }) {
    const e = xe(t, "modelValue"), r = n;
    return tt(e, (o) => {
      o || r("close");
    }), (o, a) => (x(), V(m(_n), {
      as: "template",
      show: e.value
    }, {
      default: N(() => [
        k(m(vr), {
          as: "div",
          static: "",
          class: "fixed inset-0 z-20 overflow-hidden bg-black bg-opacity-50",
          open: e.value,
          onClose: a[1] || (a[1] = (s) => e.value = !1)
        }, {
          default: N(() => [
            v("div", Yf, [
              k(m(br), { class: "absolute inset-0" }),
              v("div", zf, [
                k(m(wt), {
                  as: "template",
                  enter: "transform transition ease-in-out duration-500 sm:duration-700",
                  "enter-from": "translate-x-full",
                  "enter-to": "translate-x-0",
                  leave: "transform transition ease-in-out duration-500 sm:duration-700",
                  "leave-from": "translate-x-0",
                  "leave-to": "translate-x-full"
                }, {
                  default: N(() => [
                    v("div", Kf, [
                      v("div", Gf, [
                        v("div", Jf, [
                          v("div", Xf, [
                            k(m(go), {
                              as: "h3",
                              class: "text-white"
                            }, {
                              default: N(() => [
                                ce(U(o.header), 1)
                              ]),
                              _: 1
                            }),
                            v("div", Zf, [
                              v("button", {
                                class: "bg-xy-blue-600 rounded-md text-gray-50 hover:text-white focus:outline-none focus:ring-2 focus:ring-white",
                                onClick: a[0] || (a[0] = (s) => e.value = !1)
                              }, [
                                a[2] || (a[2] = v("span", { class: "sr-only" }, "Close panel", -1)),
                                k(m(Sn), {
                                  class: "h-6 w-6",
                                  "aria-hidden": "true"
                                })
                              ])
                            ])
                          ]),
                          v("div", Qf, [
                            v("p", {
                              class: "text-gray-50 text-base font-medium",
                              textContent: U(o.description)
                            }, null, 8, ep)
                          ])
                        ]),
                        v("div", tp, [
                          ge(o.$slots, "default")
                        ]),
                        ge(o.$slots, "footer")
                      ])
                    ])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        }, 8, ["open"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), rp = ["onMouseover", "onMouseleave"], op = ["onMouseleave"], ap = { class: "max-w-xs" }, sp = /* @__PURE__ */ R({
  __name: "Tooltip",
  props: {
    as: { default: "span" },
    position: { default: "auto" }
  },
  setup(t) {
    var n = !1, e = null;
    const r = (a) => {
      n = !1, e && clearTimeout(e), e = setTimeout(() => {
        n || a();
      }, 100);
    }, o = (a, s) => {
      n = !0, !s && a.target && a.target.click();
    };
    return (a, s) => (x(), V(oo, {
      position: a.position,
      as: a.as
    }, {
      button: N(({ open: i, close: l }) => [
        v("div", {
          class: "leading-none relative w-4 h-4",
          onMouseover: (u) => o(u, i),
          onMouseleave: (u) => r(l)
        }, [
          k(m(Ad)),
          s[1] || (s[1] = v("div", { class: "p-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" }, null, -1))
        ], 40, rp)
      ]),
      default: N(({ close: i }) => [
        v("div", {
          class: "sm:min-w-max bg-white rounded-xy px-3.5 py-2.5 border border-gray-100 drop-shadow-md text-xs text-gray-900 leading-snug font-medium",
          onMouseover: s[0] || (s[0] = et((l) => Zi(n) ? n.value = !0 : n = !0, ["prevent"])),
          onMouseleave: et((l) => r(i), ["prevent"])
        }, [
          v("div", ap, [
            ge(a.$slots, "default")
          ])
        ], 40, op)
      ]),
      _: 3
    }, 8, ["position", "as"]));
  }
}), ip = { class: "min-h-screen bg-gray-50" }, lp = { class: "mx-auto px-4 sm:px-6 lg:px-8" }, up = { class: "flex justify-between h-16" }, cp = { class: "flex" }, dp = { class: "shrink-0 flex items-center" }, fp = ["src"], pp = { class: "hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8" }, mp = ["href", "aria-current"], hp = { class: "hidden sm:ml-6 sm:flex sm:items-center" }, gp = ["href"], vp = { class: "-mr-2 flex items-center sm:hidden" }, bp = { class: "pt-2 pb-3 space-y-1" }, yp = ["href", "aria-current"], wp = { class: "pt-4 pb-3 border-t border-gray-200" }, xp = { class: "flex items-center px-4" }, Cp = { class: "shrink-0" }, Dp = { class: "ml-3" }, Ep = ["textContent"], _p = ["textContent"], kp = { class: "mt-3 space-y-1" }, Sp = ["href"], $p = { class: "mx-auto sm:px-6 lg:px-8" }, Tp = { class: "px-4 py-8 sm:px-0" }, Mp = /* @__PURE__ */ R({
  __name: "StackedLayout",
  props: {
    activeUrl: { default: "" },
    currentUser: {},
    iconUrl: {},
    navigation: {},
    userNavigation: {}
  },
  setup(t) {
    const n = t, e = (r) => n.activeUrl === r;
    return (r, o) => (x(), _(te, null, [
      v("div", ip, [
        k(m(Xu), {
          as: "nav",
          class: "bg-white shadow-sm"
        }, {
          default: N(({ open: a }) => [
            v("div", lp, [
              v("div", up, [
                v("div", cp, [
                  v("div", dp, [
                    v("img", {
                      class: "block h-8 w-auto",
                      src: r.iconUrl,
                      alt: "XY Trees"
                    }, null, 8, fp)
                  ]),
                  v("div", pp, [
                    (x(!0), _(te, null, ae(r.navigation, (s) => (x(), _("a", {
                      key: s.name,
                      href: s.url,
                      class: L([
                        e(s.url) ? "border-blue-500 text-gray-900" : "border-transparent text-gray-700 hover:text-gray-900 hover:border-blue-500",
                        "inline-flex items-center px-1 pt-1 border-b-2 text-sm font-semibold"
                      ]),
                      "aria-current": e(s.url) ? "page" : void 0
                    }, U(s.name), 11, mp))), 128))
                  ])
                ]),
                v("div", hp, [
                  k(m(vo), {
                    as: "div",
                    class: "ml-3 relative"
                  }, {
                    default: N(() => [
                      v("div", null, [
                        k(m(bo), { class: "bg-white flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" }, {
                          default: N(() => [
                            o[0] || (o[0] = v("span", { class: "sr-only" }, "Open user menu", -1)),
                            k(m($a), { class: "text-gray-500 h-8 w-8 rounded-full" })
                          ]),
                          _: 1
                        })
                      ]),
                      k(lr, {
                        "enter-active-class": "transition ease-out duration-200",
                        "enter-from-class": "transform opacity-0 scale-95",
                        "enter-to-class": "transform opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75",
                        "leave-from-class": "transform opacity-100 scale-100",
                        "leave-to-class": "transform opacity-0 scale-95"
                      }, {
                        default: N(() => [
                          k(m(yo), { class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                            default: N(() => [
                              (x(!0), _(te, null, ae(r.userNavigation, (s) => (x(), V(m(wo), {
                                key: s.name
                              }, {
                                default: N(({ active: i }) => [
                                  v("a", {
                                    href: s.url,
                                    class: L([
                                      i ? "bg-gray-100" : "",
                                      "block px-4 py-2 text-sm text-gray-700 font-semibold"
                                    ])
                                  }, U(s.name), 11, gp)
                                ]),
                                _: 2
                              }, 1024))), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                v("div", vp, [
                  k(m(Zu), { class: "bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" }, {
                    default: N(() => [
                      o[1] || (o[1] = v("span", { class: "sr-only" }, "Open main menu", -1)),
                      a ? (x(), V(m(Sn), {
                        key: 1,
                        class: "block h-6 w-6",
                        "aria-hidden": "true"
                      })) : (x(), V(m(Rd), {
                        key: 0,
                        class: "block h-6 w-6",
                        "aria-hidden": "true"
                      }))
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            ]),
            k(m(Qu), { class: "sm:hidden" }, {
              default: N(() => [
                v("div", bp, [
                  (x(!0), _(te, null, ae(r.navigation, (s) => (x(), _("a", {
                    key: s.name,
                    href: s.url,
                    class: L([
                      e(s.url) ? "bg-blue-50 border-blue-500 text-blue-700" : "border-transparent text-gray-700 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-900",
                      "block pl-3 pr-4 py-2 border-l-4 text-base font-semibold"
                    ]),
                    "aria-current": e(s.url) ? "page" : void 0
                  }, U(s.name), 11, yp))), 128))
                ]),
                v("div", wp, [
                  v("div", xp, [
                    v("div", Cp, [
                      k(m($a), { class: "text-gray-500 h-10 w-10 rounded-full" })
                    ]),
                    v("div", Dp, [
                      r.currentUser.name ? (x(), _("div", {
                        key: 0,
                        class: "text-base font-medium text-gray-800",
                        textContent: U(r.currentUser.name)
                      }, null, 8, Ep)) : B("", !0),
                      v("div", {
                        class: "text-sm font-medium text-gray-500",
                        textContent: U(r.currentUser.email)
                      }, null, 8, _p)
                    ])
                  ]),
                  v("div", kp, [
                    (x(!0), _(te, null, ae(r.userNavigation, (s) => (x(), _("a", {
                      key: s.name,
                      href: s.url,
                      class: "block px-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100"
                    }, U(s.name), 9, Sp))), 128))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        ge(r.$slots, "header"),
        v("main", null, [
          v("div", $p, [
            v("div", Tp, [
              ge(r.$slots, "default")
            ])
          ])
        ])
      ]),
      k($o),
      k(To)
    ], 64));
  }
}), Pp = (t) => t == null, Ap = {
  clearSelection() {
    console.warn(
      "clearSelection() was called on a static table, did you mean to use DynamicTable?"
    );
  },
  refresh() {
    console.warn(
      "refresh() was called on a static table, did you mean to use DynamicTable?"
    );
  },
  reset() {
    console.warn(
      "reset() was called on a static table, did you mean to use DynamicTable?"
    );
  },
  selectedData: P(() => [])
}, ci = (t, n, e, r = Ap) => {
  const o = A(n), a = A(t), s = A(e), i = P(() => s.value.actions.length > 0), l = P(() => o.value.filter((c) => c.show ?? !0).map((c) => {
    let d = "";
    switch ((c == null ? void 0 : c.alignment) || "left") {
      case "left":
        d = "text-left";
        break;
      case "right":
        d = "text-right";
        break;
      case "center":
        d = "text-center";
        break;
    }
    return {
      ...c,
      alignment: d
    };
  })), u = P(() => a.value.map((c, d) => ({
    actions: s.value.actions.map((f) => ({
      ...f,
      disabled: typeof f.disabled == "function" ? f.disabled.apply(void 0, [c, d]) : f.disabled,
      onClick: () => f.onClick(c, d, r),
      show: typeof f.show == "function" ? f.show.apply(void 0, [c, d]) : f.show
    })),
    rowData: c,
    cells: l.value.map((f) => {
      const g = typeof f.render == "function" ? f.render.apply(void 0, [c, d]) : c[f.render], h = (f == null ? void 0 : f.classNames) || "";
      return {
        ...f,
        isComponent: Qi(g),
        classNames: typeof h == "function" ? h.apply(void 0, [c, d]) : h,
        val: g
      };
    })
  })));
  return {
    columns: l,
    hasActions: i,
    isEmptyCellValue: Pp,
    rows: u
  };
}, Op = {
  key: 0,
  class: "flex items-center space-x-2 justify-end"
}, Rp = { class: "isolate inline-flex rounded-md shadow-sm" }, Ip = ["disabled", "onClick"], Lp = { class: "relative inline-flex items-center gap-x-1.5" }, ao = /* @__PURE__ */ R({
  __name: "TableActionButtons",
  props: {
    actions: { default: () => [] }
  },
  setup(t) {
    const n = t, { actions: e, hasActions: r } = qs(It(n, "actions"));
    return (o, a) => m(r) ? (x(), _("div", Op, [
      v("span", Rp, [
        (x(!0), _(te, null, ae(m(e), (s, i) => (x(), _("button", {
          key: i,
          type: "button",
          class: L(["group relative inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10 disabled:text-gray-400 disabled:cursor-not-allowed", {
            "rounded-l-md": i === 0,
            "-ml-px": i > 0,
            "rounded-r-md": i === m(e).length - 1
          }]),
          disabled: s.disabled,
          onClick: et(s.onClick, ["stop"])
        }, [
          v("span", Lp, [
            s.icon ? (x(), V(rt(s.icon), {
              key: 0,
              class: L(["-ml-0.5 h-4 w-4 group-disabled:text-gray-300", s.label ? "text-gray-400" : "text-gray-600"]),
              "aria-hidden": "true"
            }, null, 8, ["class"])) : B("", !0),
            ce(" " + U(s.label), 1)
          ])
        ], 10, Ip))), 128))
      ])
    ])) : B("", !0);
  }
}), Np = { class: "flex flex-col" }, Fp = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }, Bp = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }, jp = { class: "overflow-hidden border-b border-gray-200 shadow sm:rounded-lg" }, Vp = { class: "min-w-full divide-y divide-gray-200" }, Hp = { class: "bg-gray-100" }, Up = {
  key: 0,
  class: "px-6 py-3 text-xs font-medium tracking-wider text-gray-900 uppercase leading-4"
}, qp = { class: "bg-white" }, Wp = {
  key: 0,
  class: "px-6 py-2 text-sm text-gray-700 whitespace-nowrap leading-5"
}, Yp = { key: 0 }, zp = ["colspan"], Kp = /* @__PURE__ */ R({
  __name: "DataTable",
  props: {
    tableActions: { default: () => ({ type: "dropdown", actions: [] }) },
    tableColumns: {},
    tableData: {}
  },
  setup(t) {
    const n = t, { columns: e, hasActions: r, isEmptyCellValue: o, rows: a } = ci(
      It(n, "tableData"),
      It(n, "tableColumns"),
      It(n, "tableActions")
    );
    return (s, i) => (x(), _("div", Np, [
      v("div", Fp, [
        v("div", Bp, [
          v("div", jp, [
            v("table", Vp, [
              v("thead", Hp, [
                v("tr", null, [
                  (x(!0), _(te, null, ae(m(e), (l, u) => (x(), _("th", {
                    key: u,
                    class: L(["px-6 py-3 text-xs font-medium tracking-wider text-gray-900 uppercase leading-4", l.alignment])
                  }, U(l.title), 3))), 128)),
                  m(r) ? (x(), _("th", Up)) : B("", !0)
                ])
              ]),
              v("tbody", qp, [
                (x(!0), _(te, null, ae(m(a), (l, u) => (x(), _("tr", {
                  key: u,
                  class: "even:bg-gray-50"
                }, [
                  (x(!0), _(te, null, ae(l.cells, (c, d) => (x(), V(rt("td"), {
                    key: d,
                    class: L(["px-6 py-4 text-sm text-gray-700 whitespace-nowrap leading-5", c.alignment])
                  }, {
                    default: N(() => [
                      c.isComponent ? (x(), V(rt(c.val), { key: 0 })) : (x(), _("span", {
                        key: 1,
                        class: L(c.classNames)
                      }, U(m(o)(c.val) ? "-" : String(c.val)), 3))
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128)),
                  m(r) ? (x(), _("td", Wp, [
                    s.tableActions.type === "dropdown" ? (x(), V(m(_o), {
                      key: 0,
                      actions: l.actions
                    }, null, 8, ["actions"])) : (x(), V(ao, {
                      key: 1,
                      actions: l.actions
                    }, null, 8, ["actions"]))
                  ])) : B("", !0)
                ]))), 128)),
                m(a).length === 0 ? (x(), _("tr", Yp, [
                  v("td", {
                    colspan: m(e).length + (m(r) ? 1 : 0),
                    class: "px-6 py-4 text-sm text-gray-700 whitespace-nowrap leading-5"
                  }, " No items were found! ", 8, zp)
                ])) : B("", !0)
              ])
            ])
          ])
        ])
      ])
    ]));
  }
}), Gp = { class: "flex items-center justify-center space-x-8" }, Jp = { class: "font-medium" }, Xp = { class: "flex items-center space-x-5" }, Zp = {
  key: 0,
  class: "block w-2.5 h-2.5 bg-xy-green rounded-full hover:bg-green-900 focus:bg-green-900"
}, Qp = {
  key: 1,
  class: "relative flex items-center justify-center"
}, em = {
  key: 2,
  href: "#",
  class: "block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400 focus:bg-gray-400"
}, tm = {
  key: 0,
  class: "flex shrink-0"
}, nm = {
  key: 0,
  class: "inline-flex rounded-md shadow-sm"
}, rm = ["textContent"], om = { class: "ml-3 inline-flex rounded-md shadow-sm" }, am = ["textContent"], sm = /* @__PURE__ */ R({
  __name: "Steps",
  props: {
    hideActions: { type: Boolean, default: !1 },
    hidePrevious: { type: Boolean, default: !1 },
    nextText: { default: "Next" },
    previousText: { default: "Back" },
    step: {},
    total: {}
  },
  emits: ["next", "previous"],
  setup(t, { emit: n }) {
    const e = n, r = () => {
      e("next");
    }, o = () => {
      e("previous");
    };
    return (a, s) => (x(), _("div", null, [
      v("nav", Gp, [
        v("p", Jp, "Step " + U(a.step) + " of " + U(a.total), 1),
        v("ul", Xp, [
          (x(!0), _(te, null, ae(a.total, (i) => (x(), _("li", { key: i }, [
            a.step > i ? (x(), _("span", Zp)) : a.step === i ? (x(), _("div", Qp, s[0] || (s[0] = [
              v("span", { class: "absolute w-5 h-5 p-px flex" }, [
                v("span", { class: "w-full h-full rounded-full bg-green-100" })
              ], -1),
              v("span", { class: "relative block w-2.5 h-2.5 bg-xy-green rounded-full" }, null, -1)
            ]))) : (x(), _("span", em))
          ]))), 128))
        ])
      ]),
      a.hideActions ? B("", !0) : (x(), _("div", tm, [
        a.hidePrevious ? B("", !0) : (x(), _("span", nm, [
          v("button", {
            type: "button",
            class: "xy-btn-secondary",
            onClick: o,
            textContent: U(a.previousText)
          }, null, 8, rm)
        ])),
        v("span", om, [
          v("button", {
            type: "button",
            class: "xy-btn",
            onClick: r,
            textContent: U(a.nextText)
          }, null, 8, am)
        ])
      ]))
    ]));
  }
}), im = { class: "flex flex-col mb-4 space-y-4 lg:space-y-0 lg:flex-row lg:justify-between" }, lm = {
  key: 0,
  class: "w-full max-w-lg lg:max-w-xs"
}, um = { class: "flex items-center gap-x-2" }, cm = { class: "flex-1" }, dm = {
  key: 1,
  class: "w-full max-w-lg lg:max-w-xs"
}, fm = { class: "flex items-center gap-x-2" }, pm = { class: "flex-1" }, mm = { class: "relative z-0 min-w-full align-middle border-b border-gray-200 shadow sm:rounded-lg overflow-x-auto" }, hm = { class: "min-w-full divide-y divide-gray-200" }, gm = { class: "bg-gray-100" }, vm = {
  key: 0,
  scope: "col",
  class: "pl-6 w-4 leading-none"
}, bm = ["checked", "indeterminate"], ym = ["onClick"], wm = { key: 0 }, xm = { key: 1 }, Cm = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  class: "h-5 inline"
}, Dm = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  class: "h-5 inline"
}, Em = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  class: "h-5 inline"
}, _m = {
  key: 1,
  class: "px-6 py-3 text-xs font-medium tracking-wider text-gray-900 uppercase leading-4"
}, km = { key: 0 }, Sm = {
  colspan: "100%",
  class: "px-6 py-2.5 border-t bg-neutral-50"
}, $m = { class: "flex items-center gap-x-3" }, Tm = { class: "text-sm shrink-0" }, Mm = { class: "font-medium" }, Pm = { class: "font-medium" }, Am = { class: "bg-white" }, Om = ["onClick"], Rm = {
  key: 0,
  class: "pl-6 w-4 leading-none"
}, Im = ["disabled", "value"], Lm = {
  key: 1,
  class: "px-6 py-2 text-sm text-gray-700 whitespace-nowrap leading-5"
}, Nm = { key: 0 }, Fm = ["colspan"], Bm = {
  key: 0,
  class: "mt-4"
}, jm = /* @__PURE__ */ R({
  __name: "DynamicTable",
  props: /* @__PURE__ */ ve({
    tableActions: { default: () => ({ type: "dropdown", actions: [] }) },
    tableBulkActions: { default: () => ({ actions: [] }) },
    tableColumns: {},
    tableOptions: {}
  }, {
    selected: {
      required: !1,
      default: []
    },
    selectedModifiers: {}
  }),
  emits: /* @__PURE__ */ ve(["click:row"], ["update:selected"]),
  setup(t, { expose: n }) {
    var Tn;
    const e = t, r = () => {
      const X = {
        minDate: u.value.minDate,
        maxDate: u.value.maxDate,
        page: c.value.page,
        perPage: c.value.perPage,
        sort: i.value,
        sortDir: l.value,
        q: d.value
      };
      w(), hs.get(
        e.tableOptions.url,
        { skipLoader: !1 },
        X
      ).then(
        (W) => {
          c.value = {
            page: W.data.page,
            perPage: W.data.perPage,
            totalItems: W.data.totalItems,
            totalPages: W.data.totalPages
          }, s.value = W.data.items;
        },
        () => {
          ii.genericError();
        }
      );
    }, o = () => {
      c.value.page = 1, r();
    }, a = () => {
      if (h.value.maxRange) {
        const X = /* @__PURE__ */ new Date(), W = X.setDate(
          X.getDate() - h.value.maxRange
        ), xt = /* @__PURE__ */ new Date();
        u.value = {
          minDate: Math.floor(W / 1e3),
          maxDate: Math.floor(xt.getTime() / 1e3)
        };
      }
    }, s = A([]), i = A(
      e.tableOptions.defaultSort ? e.tableOptions.defaultSort : ""
    ), l = A(
      e.tableOptions.defaultSortDirection ? e.tableOptions.defaultSortDirection : "desc"
    ), u = A({
      minDate: 0,
      maxDate: 0
    }), c = A({
      page: 1,
      perPage: ((Tn = e.tableOptions) == null ? void 0 : Tn.perPage) || 10,
      totalItems: 0,
      totalPages: 0
    }), d = A(""), f = (X) => {
      X && (c.value.page = 1, u.value = X, r());
    }, g = (X) => {
      i.value == X ? l.value = l.value === "desc" ? "asc" : "desc" : (i.value = X, l.value = "desc"), r();
    }, h = P(() => typeof e.tableOptions.dateSearch == "object" ? e.tableOptions.dateSearch : {}), y = P(() => !!nn.value.length), w = () => {
      D.value = [];
    }, D = xe(t, "selected"), T = P(() => s.value.filter((X) => D.value.includes(X == null ? void 0 : X.id))), M = P(() => D.value.filter((X) => Z.value.includes(X))), K = P(() => e.tableBulkActions.actions.filter((X) => X.show ?? !0).map((X) => ({
      ...X,
      disabled: D.value.length === 0 || X.disabled,
      onClick: () => X.onClick.apply(void 0, [
        D.value,
        T.value,
        ne
      ])
    }))), q = P(() => K.value.length > 0), Z = P(() => s.value.filter((X) => X.id === void 0 ? !1 : !!(e.tableBulkActions.isSelectable === void 0 || e.tableBulkActions.isSelectable(X))).map((X) => X.id)), H = P(
      () => M.value.length > 0 && M.value.length === Z.value.length
    ), _e = P(
      () => M.value.length > 0 && M.value.length < Z.value.length
    ), J = (X) => {
      if (X.target.checked) {
        D.value = Z.value.map((xt) => xt);
        return;
      }
      w();
    }, ne = {
      clearSelection: w,
      selectedData: T,
      refresh: r,
      reset: o
    }, { columns: he, hasActions: be, isEmptyCellValue: $e, rows: nn } = ci(
      s,
      It(e, "tableColumns"),
      It(e, "tableActions"),
      ne
    );
    return tt(
      () => e.tableOptions.refreshTrigger,
      () => {
        r();
      }
    ), tt(
      () => e.tableOptions.reloadTrigger,
      () => {
        o();
      }
    ), n(ne), a(), r(), (X, W) => {
      var Mn;
      const xt = Va("BaseInput");
      return x(), _("div", null, [
        v("div", im, [
          X.tableOptions.search ? (x(), _("div", lm, [
            W[7] || (W[7] = v("label", {
              for: "table-search",
              class: "sr-only"
            }, "Search", -1)),
            v("div", um, [
              W[6] || (W[6] = v("div", {
                "aria-hidden": "true",
                class: "shrink-0 aspect-square rounded-full bg-gray-50 text-gray-400 h-10 w-10 flex items-center justify-center pointer-events-none"
              }, [
                v("svg", {
                  class: "w-5 h-5",
                  fill: "currentColor",
                  viewBox: "0 0 20 20"
                }, [
                  v("path", {
                    "fill-rule": "evenodd",
                    d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
                    "clip-rule": "evenodd"
                  })
                ])
              ], -1)),
              v("div", cm, [
                k(xt, {
                  id: "table-search",
                  modelValue: d.value,
                  "onUpdate:modelValue": W[0] || (W[0] = (ie) => d.value = ie),
                  modelModifiers: { trim: !0 },
                  type: "search",
                  placeholder: "Search",
                  onChange: W[1] || (W[1] = (ie) => o())
                }, null, 8, ["modelValue"])
              ])
            ])
          ])) : B("", !0),
          X.tableOptions.dateSearch ? (x(), _("div", dm, [
            W[9] || (W[9] = v("label", {
              for: "table-date-range",
              class: "sr-only"
            }, "Date Range", -1)),
            v("div", fm, [
              W[8] || (W[8] = v("div", {
                "aria-hidden": "true",
                class: "shrink-0 aspect-square rounded-full bg-gray-50 text-gray-400 h-10 w-10 flex items-center justify-center pointer-events-none"
              }, [
                v("svg", {
                  class: "h-5 w-5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  v("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  })
                ])
              ], -1)),
              v("div", pm, [
                k(ko, Fe({
                  id: "table-date-range",
                  modelValue: u.value,
                  "onUpdate:modelValue": W[2] || (W[2] = (ie) => u.value = ie)
                }, { ...h.value }, { "onUpdate:modelValue": f }), null, 16, ["modelValue"])
              ])
            ])
          ])) : B("", !0)
        ]),
        v("div", mm, [
          v("table", hm, [
            v("thead", gm, [
              v("tr", null, [
                q.value ? (x(), _("th", vm, [
                  v("input", {
                    class: L([
                      "h-4 w-4 rounded cursor-pointer",
                      "disabled:bg-gray-100 disabled:border-gray-200  disabled:cursor-not-allowed disabled:opacity-100",
                      "checked:disabled:bg-xy-blue checked:disabled:border-xy-blue checked:disabled:opacity-50",
                      "border-gray-300 focus:ring-xy-blue-500"
                    ]),
                    checked: H.value,
                    indeterminate: _e.value,
                    type: "checkbox",
                    onChange: J
                  }, null, 40, bm)
                ])) : B("", !0),
                (x(!0), _(te, null, ae(m(he), (ie, rn) => (x(), _("th", {
                  key: rn,
                  class: L(["px-6 py-3 text-xs font-medium tracking-wider text-gray-900 uppercase leading-4", ie.alignment])
                }, [
                  v("div", {
                    class: L(["inline-flex items-center gap-2", { "cursor-pointer": ie.sort }]),
                    onClick: et((on) => ie.sort ? g(ie.sort) : void 0, ["prevent"])
                  }, [
                    ie.title ? (x(), _("span", wm, U(ie.title), 1)) : B("", !0),
                    ie.sort ? (x(), _("span", xm, [
                      i.value !== ie.sort ? (x(), _("svg", Cm, W[10] || (W[10] = [
                        v("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M8 9l4-4 4 4m0 6l-4 4-4-4"
                        }, null, -1)
                      ]))) : l.value == "desc" ? (x(), _("svg", Dm, W[11] || (W[11] = [
                        v("path", {
                          "fill-rule": "evenodd",
                          d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
                          "clip-rule": "evenodd"
                        }, null, -1)
                      ]))) : (x(), _("svg", Em, W[12] || (W[12] = [
                        v("path", {
                          "fill-rule": "evenodd",
                          d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                          "clip-rule": "evenodd"
                        }, null, -1)
                      ])))
                    ])) : B("", !0)
                  ], 10, ym)
                ], 2))), 128)),
                m(be) ? (x(), _("th", _m)) : B("", !0)
              ]),
              q.value && D.value.length > 0 ? (x(), _("tr", km, [
                v("td", Sm, [
                  v("div", $m, [
                    v("div", Tm, [
                      W[13] || (W[13] = ce(" Selected ")),
                      v("span", Mm, U(M.value.length), 1),
                      W[14] || (W[14] = ce(" of ")),
                      v("span", Pm, U(Z.value.length), 1)
                    ]),
                    k(ao, { actions: K.value }, null, 8, ["actions"])
                  ])
                ])
              ])) : B("", !0)
            ]),
            v("tbody", Am, [
              (x(!0), _(te, null, ae(m(nn), (ie, rn) => {
                var on, Pn;
                return x(), _("tr", {
                  key: rn,
                  class: "even:bg-gray-50",
                  onClick: (Te) => X.$emit("click:row", ie.rowData)
                }, [
                  q.value ? (x(), _("td", Rm, [
                    Xe(v("input", {
                      "onUpdate:modelValue": W[3] || (W[3] = (Te) => D.value = Te),
                      class: L([
                        "h-4 w-4 rounded cursor-pointer",
                        "disabled:bg-gray-100 disabled:border-gray-200  disabled:cursor-not-allowed disabled:opacity-100",
                        "checked:disabled:bg-xy-blue checked:disabled:border-xy-blue checked:disabled:opacity-50",
                        "border-gray-300 focus:ring-xy-blue-500"
                      ]),
                      disabled: !Z.value.includes((on = ie.rowData) == null ? void 0 : on.id),
                      type: "checkbox",
                      value: (Pn = ie.rowData) == null ? void 0 : Pn.id
                    }, null, 8, Im), [
                      [uo, D.value]
                    ])
                  ])) : B("", !0),
                  (x(!0), _(te, null, ae(ie.cells, (Te, an) => (x(), V(rt("td"), {
                    key: an,
                    class: L(["px-6 py-4 text-sm text-gray-700 whitespace-nowrap leading-5", Te.alignment])
                  }, {
                    default: N(() => [
                      Te.isComponent ? (x(), V(rt(Te.val), { key: 0 })) : (x(), _("span", {
                        key: 1,
                        class: L(Te.classNames)
                      }, U(m($e)(Te.val) ? "-" : String(Te.val)), 3))
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128)),
                  m(be) ? (x(), _("td", Lm, [
                    X.tableActions.type === "dropdown" ? (x(), V(m(_o), {
                      key: 0,
                      actions: ie.actions
                    }, null, 8, ["actions"])) : (x(), V(ao, {
                      key: 1,
                      actions: ie.actions
                    }, null, 8, ["actions"]))
                  ])) : B("", !0)
                ], 8, Om);
              }), 128)),
              y.value ? B("", !0) : (x(), _("tr", Nm, [
                v("td", {
                  colspan: m(he).length + (m(be) ? 1 : 0),
                  class: "px-6 py-4 text-sm text-gray-700 whitespace-nowrap leading-5"
                }, " No items were found! ", 8, Fm)
              ]))
            ])
          ])
        ]),
        y.value ? (x(), _("div", Bm, [
          k(m(di), {
            modelValue: c.value,
            "onUpdate:modelValue": [
              W[4] || (W[4] = (ie) => c.value = ie),
              W[5] || (W[5] = (ie) => r())
            ],
            "page-options": (Mn = X.tableOptions) == null ? void 0 : Mn.pageOptions
          }, null, 8, ["modelValue", "page-options"])
        ])) : B("", !0)
      ]);
    };
  }
}), Vm = { class: "flex flex-col items-center space-y-3.5 sm:flex-row sm:space-y-0 sm:gap-x-3 sm:justify-center" }, Hm = { class: "text-center text-sm text-neutral-700 sm:text-left sm:mr-auto sm:w-1/3" }, Um = { class: "font-medium" }, qm = { class: "font-medium" }, Wm = { class: "font-medium" }, Ym = { class: "flex flex-col items-center space-y-3.5 sm:flex-row sm:space-y-0 sm:gap-x-3 sm:flex-1" }, zm = { class: "flex gap-3 items-center justify-center shrink-0 md:w-1/2" }, Km = ["disabled"], Gm = { class: "max-w-[50px]" }, Jm = { class: "text-sm" }, Xm = { class: "font-medium" }, Zm = ["disabled"], Qm = { class: "max-w-[150px] sm:ml-auto" }, di = /* @__PURE__ */ R({
  __name: "TablePaginator",
  props: /* @__PURE__ */ ve({
    pageOptions: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue"), r = P({
      get: () => e.value.page,
      set: (c) => {
        e.value = {
          ...e.value,
          page: c
        };
      }
    }), o = P({
      get: () => e.value.perPage,
      set: (c) => {
        e.value = {
          ...e.value,
          page: 1,
          perPage: c
        };
      }
    }), a = P(() => n.pageOptions ? n.pageOptions : [
      { label: "5 per page", value: 5 },
      { label: "10 per page", value: 10 },
      { label: "20 per page", value: 20 },
      { label: "50 per page", value: 50 }
    ]), s = Kn((c) => {
      c !== null && c !== r.value && (r.value = c);
    }, 350), i = Kn(() => {
      r.value <= 1 || (r.value = r.value - 1);
    }, 250), l = Kn(() => {
      r.value >= e.value.totalPages || (r.value = r.value + 1);
    }, 250), u = P(() => {
      const { page: c, perPage: d, totalItems: f } = e.value;
      return {
        start: f > 0 ? (c - 1) * d + 1 : 0,
        end: Math.min(c * d, f)
      };
    });
    return (c, d) => (x(), _("div", Vm, [
      v("p", Hm, [
        d[3] || (d[3] = ce(" Showing ")),
        v("span", Um, U(u.value.start), 1),
        d[4] || (d[4] = ce(" to ")),
        v("span", qm, U(u.value.end), 1),
        d[5] || (d[5] = ce(" of ")),
        v("span", Wm, U(e.value.totalItems), 1),
        d[6] || (d[6] = ce(" results "))
      ]),
      v("div", Ym, [
        v("div", zm, [
          v("button", {
            class: "xy-btn-neutral",
            disabled: r.value <= 1,
            type: "button",
            onClick: d[0] || (d[0] = et((f) => r.value--, ["prevent"]))
          }, d[7] || (d[7] = [
            ce(" ← "),
            v("span", { class: "sr-only" }, "Previous", -1)
          ]), 8, Km),
          v("div", Gm, [
            k(m(yi), {
              "model-value": r.value,
              min: 1,
              max: e.value.totalPages,
              type: "number",
              "onUpdate:modelValue": m(s),
              onKeydown: [
                Ho(et(m(i), ["prevent"]), ["down"]),
                Ho(et(m(l), ["prevent"]), ["up"])
              ]
            }, null, 8, ["model-value", "max", "onUpdate:modelValue", "onKeydown"])
          ]),
          v("div", Jm, [
            d[8] || (d[8] = ce(" of ")),
            v("span", Xm, U(e.value.totalPages), 1)
          ]),
          v("button", {
            class: "xy-btn-neutral",
            disabled: r.value >= e.value.totalPages,
            type: "button",
            onClick: d[1] || (d[1] = et((f) => r.value++, ["prevent"]))
          }, d[9] || (d[9] = [
            v("span", { class: "sr-only" }, "Next", -1),
            ce(" → ")
          ]), 8, Zm)
        ]),
        v("div", Qm, [
          k(m(So), {
            modelValue: o.value,
            "onUpdate:modelValue": d[2] || (d[2] = (f) => o.value = f),
            options: a.value
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]));
  }
}), eh = { class: "hidden sm:block" }, th = ["onClick", "textContent"], nh = /* @__PURE__ */ R({
  __name: "Tabs",
  props: /* @__PURE__ */ ve({
    pillDesign: { type: Boolean, default: !1 },
    tabs: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue"), r = (a, s) => {
      let i = "";
      return n.pillDesign ? (i = "px-12 py-2 font-semibold text-md leading-5 rounded-t-md focus:outline-none ", e.value === a ? i = i + "focus:bg-white text-gray-700 bg-white border-b-2 border-blue-500" : i = i + "text-gray-700 hover:text-gray-900 focus:text-gray-900 focus:bg-gray-100 border border-gray-200", i) : (i = "px-1 py-4 text-sm font-semibold border-b-2 whitespace-nowrap leading-5 focus:outline-none ", e.value === a ? i = i + "border-blue-500 text-xy-blue focus:text-blue-800 focus:border-blue-700" : i = i + "border-transparent text-gray-700 hover:text-gray-900 hover:border-gray-300 focus:text-gray-900 focus:border-gray-300", s && (i = i + " ml-8"), i);
    }, o = P(() => !n.pillDesign);
    return (a, s) => {
      const i = Va("Select");
      return x(), _("div", null, [
        v("div", {
          class: L(["sm:hidden", { "mb-4": a.pillDesign }])
        }, [
          s[1] || (s[1] = v("label", {
            for: "tabs",
            class: "sr-only"
          }, "Select a tab", -1)),
          k(i, {
            modelValue: e.value,
            "onUpdate:modelValue": s[0] || (s[0] = (l) => e.value = l),
            name: "tabs",
            options: a.tabs
          }, null, 8, ["modelValue", "options"])
        ], 2),
        v("div", eh, [
          v("div", {
            class: L({ "border-b border-gray-200": o.value })
          }, [
            v("nav", {
              class: L(["flex", [a.pillDesign ? "ml-8" : "-mb-px"]])
            }, [
              (x(!0), _(te, null, ae(a.tabs, (l, u) => (x(), _("a", {
                key: u,
                href: "#",
                class: L(r(l.value, u > 0)),
                onClick: et((c) => e.value = l.value, ["prevent"]),
                textContent: U(l.label)
              }, null, 10, th))), 128))
            ], 2)
          ], 2)
        ])
      ]);
    };
  }
}), rh = {
  key: 0,
  class: "sr-only"
}, oh = { class: "ml-3 mt-0.5" }, ah = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "Toggle",
  props: /* @__PURE__ */ ve({
    label: { default: "" },
    help: { default: "" }
  }, {
    modelValue: { type: Boolean, ...de },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = xe(t, "modelValue", de), e = ir(), r = P(() => Zr(e, "disabled"));
    return (o, a) => (x(), V(m(uc), {
      as: "div",
      class: "flex items-start"
    }, {
      default: N(() => [
        k(m(cc), {
          modelValue: n.value,
          "onUpdate:modelValue": a[0] || (a[0] = (s) => n.value = s),
          class: L([
            n.value ? "bg-xy-blue" : "bg-gray-200",
            r.value ? "opacity-75 cursor-not-allowed" : "cursor-pointer",
            "relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-xy-blue-500"
          ]),
          disabled: r.value
        }, {
          default: N(() => [
            o.label ? B("", !0) : (x(), _("span", rh, "Use")),
            v("span", {
              "aria-hidden": "true",
              class: L([
                n.value ? "translate-x-5" : "translate-x-0",
                "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
              ])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["modelValue", "class", "disabled"]),
        v("div", oh, [
          o.label ? (x(), V(m(dc), { key: 0 }, {
            default: N(() => [
              k(qe, {
                label: o.label,
                class: L(r.value ? "cursor-not-allowed" : "cursor-pointer")
              }, null, 8, ["label", "class"])
            ]),
            _: 1
          })) : B("", !0),
          o.help ? (x(), V(m(fc), { key: 1 }, {
            default: N(() => [
              k(Re, { text: o.help }, null, 8, ["text"])
            ]),
            _: 1
          })) : B("", !0)
        ])
      ]),
      _: 1
    }));
  }
}), sh = { "aria-label": "Progress" }, ih = {
  role: "list",
  class: "flex items-center"
}, lh = {
  class: "absolute inset-0 flex items-center",
  "aria-hidden": "true"
}, uh = ["aria-current"], ch = {
  key: 1,
  class: "h-3 w-3 rounded-full bg-xy-blue",
  "aria-hidden": "true"
}, dh = { class: "sr-only" }, fh = {
  key: 2,
  class: "sr-only"
}, ph = /* @__PURE__ */ R({
  __name: "ProgressCircles",
  props: {
    current: {},
    steps: {}
  },
  setup(t) {
    const n = t, e = P(() => n.steps.map((r, o) => {
      let a;
      return n.current > o ? a = "complete" : n.current === o ? a = "current" : a = "incomplete", {
        name: r.name,
        description: (r == null ? void 0 : r.description) || "",
        status: a
      };
    }));
    return (r, o) => (x(), _("nav", sh, [
      v("ol", ih, [
        (x(!0), _(te, null, ae(e.value, (a, s) => (x(), _("li", {
          key: a.name,
          class: L([s !== e.value.length - 1 ? "pr-8" : "", "relative"])
        }, [
          v("div", lh, [
            v("div", {
              class: L([
                "h-0.5 w-full",
                a.status === "complete" ? "bg-xy-blue" : "bg-gray-300"
              ])
            }, null, 2)
          ]),
          v("div", {
            class: L({
              "relative flex h-5 w-5 items-center justify-center rounded-full": !0,
              "bg-xy-blue": a.status === "complete",
              "border-2 border-indigo-600 bg-white": a.status === "current",
              "border-2 border-gray-300 bg-white": a.status === "incomplete"
            }),
            "aria-current": a.status === "current" ? !0 : void 0
          }, [
            a.status === "complete" ? (x(), V(m(Us), {
              key: 0,
              class: "h-3 w-3 text-white",
              "aria-hidden": "true"
            })) : a.status === "current" ? (x(), _("span", ch)) : B("", !0),
            v("span", dh, U(a.name), 1),
            a.description ? (x(), _("span", fh, U(a.description), 1)) : B("", !0)
          ], 10, uh)
        ], 2))), 128))
      ])
    ]));
  }
}), mh = { "aria-label": "Progress" }, hh = {
  role: "list",
  class: "overflow-hidden"
}, gh = ["aria-current"], vh = { class: "flex h-9 items-center" }, bh = {
  key: 1,
  class: "h-2.5 w-2.5 rounded-full bg-xy-blue"
}, yh = { class: "ml-4 flex min-w-0 flex-col" }, wh = {
  key: 0,
  class: "text-sm text-gray-600"
}, xh = /* @__PURE__ */ R({
  __name: "ProgressCirclesLabeled",
  props: {
    current: {},
    steps: {}
  },
  setup(t) {
    const n = t, e = P(() => n.steps.map((r, o) => {
      let a;
      return n.current > o ? a = "complete" : n.current === o ? a = "current" : a = "incomplete", {
        name: r.name,
        description: (r == null ? void 0 : r.description) || "",
        status: a
      };
    }));
    return (r, o) => (x(), _("div", mh, [
      v("ol", hh, [
        (x(!0), _(te, null, ae(e.value, (a, s) => (x(), _("li", {
          key: s,
          class: L([s !== e.value.length - 1 ? "pb-6" : "", "relative"])
        }, [
          s !== e.value.length - 1 ? (x(), _("div", {
            key: 0,
            class: L([
              "absolute left-3 top-3 -ml-px mt-0.5 h-full w-0.5",
              a.status === "complete" ? "bg-xy-blue" : "bg-gray-300"
            ]),
            "aria-hidden": "true"
          }, null, 2)) : B("", !0),
          v("div", {
            class: "group relative flex items-start",
            "aria-current": a.status === "current" ? !0 : void 0
          }, [
            v("span", vh, [
              v("span", {
                class: L({
                  "relative z-10 flex h-6 w-6 items-center justify-center rounded-full": !0,
                  "bg-xy-blue ": a.status === "complete",
                  "border-2 border-xy-blue bg-white": a.status === "current",
                  "border-2 border-gray-300 bg-white": a.status === "incomplete"
                })
              }, [
                a.status === "complete" ? (x(), V(m(Us), {
                  key: 0,
                  class: "h-4 w-4 text-white",
                  "aria-hidden": "true"
                })) : a.status === "current" ? (x(), _("span", bh)) : B("", !0)
              ], 2)
            ]),
            v("span", yh, [
              v("span", {
                class: L({
                  "text-sm font-bold": !0,
                  "text-gray-800": a.status === "complete",
                  "text-xy-blue": a.status === "current",
                  "text-gray-600": a.status === "incomplete",
                  "mt-2": !a.description
                })
              }, U(a.name), 3),
              a.description ? (x(), _("span", wh, U(a.description), 1)) : B("", !0)
            ])
          ], 8, gh)
        ], 2))), 128))
      ])
    ]));
  }
}), Ch = ["id", "aria-labelledby", "aria-describedby", "aria-errormessage", "placeholder", "type"], Dh = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "BaseInput",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    modelValue: {},
    type: {},
    label: {},
    help: {},
    placeholder: {}
  }, dt), {
    modelValue: {
      ...de,
      // NOTE(spk): transform with caution.  The emitted value will be locally updated
      // in this component and applied to the input's value attribute.
      //
      // The upside to this side effect for number inputs is that we can enforce allowing
      // only character sets that can be parsed into numbers across browsers (Firefox).
      //
      // Example: calling v.trim() may prevent the use of the space character by the user.
      //
      // https://github.com/vuejs/core/commit/de174e1aa756508c7542605a448e55a373afb1ed#diff-f1e0971afb7e61e75d37d0fc7d7f993c9681dddb7c689cb455d217a246b3d6f0
      set: (t) => props.type === "number" ? ra(t) : t
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: n }) {
    const e = t, r = xe(t, "modelValue", {
      ...de,
      // NOTE(spk): transform with caution.  The emitted value will be locally updated
      // in this component and applied to the input's value attribute.
      //
      // The upside to this side effect for number inputs is that we can enforce allowing
      // only character sets that can be parsed into numbers across browsers (Firefox).
      //
      // Example: calling v.trim() may prevent the use of the space character by the user.
      //
      // https://github.com/vuejs/core/commit/de174e1aa756508c7542605a448e55a373afb1ed#diff-f1e0971afb7e61e75d37d0fc7d7f993c9681dddb7c689cb455d217a246b3d6f0
      set: (d) => e.type === "number" ? ra(d) : d
    }), o = Nt("input"), { errorState: a, inputID: s, isRequired: i, onInvalid: l, inputValidation: u } = ft(e);
    n({ input: o });
    const c = P(() => {
      switch (e.type) {
        case "number":
          return {
            max: Number.MAX_SAFE_INTEGER,
            min: Number.MIN_SAFE_INTEGER
          };
        case "email":
          return {
            pattern: Ru
          };
        case "tel":
          return {
            pattern: Iu
          };
        case "url":
          return {
            pattern: Lu
          };
        default:
          return {};
      }
    });
    return (d, f) => (x(), _("div", null, [
      k(qe, {
        id: `${m(s)}-label`,
        class: "mb-2",
        for: m(s),
        label: d.label,
        required: m(i)
      }, null, 8, ["id", "for", "label", "required"]),
      Xe(v("input", Fe({
        id: m(s),
        ref: "input",
        "onUpdate:modelValue": f[0] || (f[0] = (g) => r.value = g),
        "aria-labelledby": d.label ? `${m(s)}-label` : void 0,
        "aria-describedby": d.help ? `${m(s)}-help` : void 0,
        "aria-errormessage": m(a) ? `${m(s)}-error` : void 0,
        class: [
          "block w-full rounded-md border-0 py-2 shadow-sm ring-1 ring-inset focus:ring-2 sm:text-sm sm:leading-6",
          "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-700 disabled:ring-gray-200",
          m(a) ? "text-red-900 ring-red-700 placeholder:text-red-300 focus:ring-red-700" : "text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-xy-blue-500"
        ],
        placeholder: d.placeholder,
        type: d.type
      }, { ...c.value, ...d.$attrs }, {
        onInput: f[1] || (f[1] = //@ts-ignore
        (...g) => m(u) && m(u)(...g)),
        onInvalid: f[2] || (f[2] = //@ts-ignore
        (...g) => m(l) && m(l)(...g))
      }), null, 16, Ch), [
        [
          el,
          r.value,
          void 0,
          { trim: !0 }
        ]
      ]),
      k(Re, {
        id: `${m(s)}-help`,
        class: "mt-1",
        text: d.help
      }, null, 8, ["id", "text"]),
      k(ot, {
        id: `${m(s)}-error`,
        class: "mt-0.5",
        text: m(a)
      }, null, 8, ["id", "text"])
    ]));
  }
}), Eh = { class: "relative flex items-start" }, _h = { class: "flex items-center h-5" }, kh = ["id", "aria-labelledby", "aria-describedby", "aria-errormessage", "checked"], Sh = { class: "ml-3" }, $h = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "Checkbox",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    modelValue: { type: [Boolean, null] },
    label: {},
    help: {},
    placeholder: {}
  }, dt), {
    modelValue: { type: [Boolean, null], ...de },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", de), {
      aria: r,
      inputID: o,
      isDisabled: a,
      isRequired: s,
      errorState: i,
      validate: l,
      onInvalid: u
    } = ft(n);
    return (c, d) => (x(), _("div", Eh, [
      v("div", _h, [
        Xe(v("input", Fe({
          id: m(o),
          "onUpdate:modelValue": d[0] || (d[0] = (f) => e.value = f),
          "aria-labelledby": m(r).labelledby,
          "aria-describedby": m(r).describedby,
          "aria-errormessage": m(r).errormessage,
          checked: e.value || void 0,
          class: [
            "h-4 w-4 rounded text-xy-blue cursor-pointer",
            "disabled:bg-gray-100 disabled:border-gray-200  disabled:cursor-not-allowed disabled:opacity-100",
            "checked:disabled:bg-xy-blue checked:disabled:border-xy-blue checked:disabled:opacity-50",
            m(i) ? "border-red-700 focus:ring-red-700" : "border-gray-300 focus:ring-xy-blue-500"
          ],
          type: "checkbox"
        }, c.$attrs, {
          onChange: d[1] || (d[1] = //@ts-ignore
          (...f) => m(l) && m(l)(...f)),
          onInvalid: d[2] || (d[2] = //@ts-ignore
          (...f) => m(u) && m(u)(...f))
        }), null, 16, kh), [
          [uo, e.value]
        ])
      ]),
      v("div", Sh, [
        k(qe, {
          id: m(r).labelledby,
          for: m(o),
          label: c.label,
          class: L(m(a) ? "cursor-not-allowed" : "cursor-pointer"),
          required: m(s)
        }, null, 8, ["id", "for", "label", "class", "required"]),
        k(Re, {
          id: m(r).describedby,
          text: c.help
        }, null, 8, ["id", "text"]),
        k(ot, {
          id: m(r).errormessage,
          class: "mt-0.5",
          text: m(i)
        }, null, 8, ["id", "text"])
      ])
    ]));
  }
}), Th = ["id", "aria-labelledby", "aria-describedby", "aria-errormessage", "placeholder"], Mh = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "DateTimeInput",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    modelValue: {},
    label: {},
    help: {},
    placeholder: {}
  }, dt), {
    modelValue: {
      ...de,
      get: (t) => t && oa(t),
      set: (t) => t && new Date(t).toISOString()
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", {
      ...de,
      get: (l) => l && oa(l),
      set: (l) => l && new Date(l).toISOString()
    }), { errorState: r, inputID: o, isRequired: a, onInvalid: s, inputValidation: i } = ft(n);
    return (l, u) => (x(), _("div", null, [
      k(qe, {
        id: `${m(o)}-label`,
        class: "mb-2",
        for: m(o),
        label: l.label,
        required: m(a)
      }, null, 8, ["id", "for", "label", "required"]),
      Xe(v("input", Fe({
        id: m(o),
        "onUpdate:modelValue": u[0] || (u[0] = (c) => e.value = c),
        "aria-labelledby": l.label ? `${m(o)}-label` : void 0,
        "aria-describedby": l.help ? `${m(o)}-help` : void 0,
        "aria-errormessage": m(r) ? `${m(o)}-error` : void 0,
        class: [
          "block w-full rounded-md border-0 py-2 shadow-sm ring-1 ring-inset focus:ring-2 sm:text-sm sm:leading-6",
          "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-700 disabled:ring-gray-200",
          m(r) ? "text-red-900 ring-red-700 placeholder:text-red-300 focus:ring-red-700" : "text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-xy-blue-500"
        ],
        placeholder: l.placeholder,
        type: "datetime-local"
      }, l.$attrs, {
        onInput: u[1] || (u[1] = //@ts-ignore
        (...c) => m(i) && m(i)(...c)),
        onInvalid: u[2] || (u[2] = //@ts-ignore
        (...c) => m(s) && m(s)(...c))
      }), null, 16, Th), [
        [co, e.value]
      ]),
      k(Re, {
        id: `${m(o)}-help`,
        class: "mt-1",
        text: l.help
      }, null, 8, ["id", "text"]),
      k(ot, {
        id: `${m(o)}-error`,
        class: "mt-0.5",
        text: m(r)
      }, null, 8, ["id", "text"])
    ]));
  }
}), Ph = {
  key: 0,
  class: "text-red-700/80"
}, $n = /* @__PURE__ */ R({
  __name: "FieldsetLegend",
  props: {
    label: { default: "" },
    required: { type: Boolean, default: !1 },
    tag: { default: "legend" }
  },
  setup(t) {
    const n = t, e = P(() => n.required && /\*$/gm.exec(n.label) !== null ? n.label.substring(0, n.label.length - 1) : n.label);
    return (r, o) => r.label ? (x(), V(rt(r.tag), Fe({
      key: 0,
      class: "block text-sm leading-6 font-semibold text-gray-800"
    }, r.$attrs), {
      default: N(() => [
        ce(U(e.value) + " ", 1),
        n.required ? (x(), _("span", Ph, "*")) : B("", !0)
      ]),
      _: 1
    }, 16)) : B("", !0);
  }
}), Ah = ["aria-labelledby", "aria-describedby", "aria-errormessage"], Oh = { key: 0 }, Rh = { class: "flex" }, Ih = { class: "flex items-center h-5" }, Lh = ["id", "aria-labelledby", "aria-describedby", "disabled", "value"], Nh = { class: "ml-3" }, Fh = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "MultiCheckboxes",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    max: {},
    min: {},
    modelValue: {},
    options: {},
    label: {},
    help: {},
    placeholder: {},
    columns: {}
  }, dt), {
    modelValue: {
      ...de,
      // NOTE(spk): The Vue.js specific handling of initial prop values null vs undefined
      // means we can't rely on the the "default" param of defineModel here.  Ensuring the
      // getter returns an array type allows for a consistent checkbox v-model binding similar to
      // the example in the official Vue.js docs.
      //
      // When a parent component passes a null v-model the parent ref stays null until
      // a mutation occurs which is consistent with other input components.
      get: (t) => Array.isArray(t) ? t : []
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", {
      ...de,
      // NOTE(spk): The Vue.js specific handling of initial prop values null vs undefined
      // means we can't rely on the the "default" param of defineModel here.  Ensuring the
      // getter returns an array type allows for a consistent checkbox v-model binding similar to
      // the example in the official Vue.js docs.
      //
      // When a parent component passes a null v-model the parent ref stays null until
      // a mutation occurs which is consistent with other input components.
      get: (g) => Array.isArray(g) ? g : []
    }), { aria: r, inputID: o, isDisabled: a, errorState: s, validate: i } = ft(n), l = P(() => n.min || null), u = P(() => n.max || null), c = P(() => {
      var h;
      const g = ((h = e.value) == null ? void 0 : h.length) || 0;
      return l.value !== null && g < l.value ? `Please select at least ${l.value} of these options.` : u.value !== null && g > u.value ? `Please limit your selection to ${u.value} of these options.` : l.value !== null && u.value !== null && (g < l.value || g > u.value) ? `Please select between ${l.value} and ${u.value} of these options.` : "";
    }), d = Nt("errorInput"), f = () => {
      var g;
      s.value || (s.value = c.value, (g = d.value) == null || g.setCustomValidity(c.value));
    };
    return (g, h) => (x(), _("fieldset", {
      class: "relative space-y-6",
      "aria-labelledby": m(r).labelledby,
      "aria-describedby": m(r).describedby,
      "aria-errormessage": m(r).errormessage
    }, [
      g.label ? (x(), _("div", Oh, [
        k($n, {
          id: m(r).labelledby,
          label: g.label,
          required: !!l.value
        }, null, 8, ["id", "label", "required"]),
        g.help ? (x(), V(Re, {
          key: 0,
          id: m(r).describedby,
          class: "mt-1",
          tag: "p",
          text: g.help
        }, null, 8, ["id", "text"])) : B("", !0),
        k(ot, {
          id: m(r).errormessage,
          class: "mt-1",
          text: m(s)
        }, null, 8, ["id", "text"])
      ])) : B("", !0),
      v("div", Rh, [
        v("div", {
          class: L(["grid gap-y-5", {
            "sm:grid sm:gap-x-10": g.columns !== void 0,
            "sm:grid-cols-2": g.columns === 2,
            "sm:grid-cols-3": g.columns === 3
          }])
        }, [
          (x(!0), _(te, null, ae(g.options, (y, w) => (x(), _("div", {
            key: y.value,
            class: "flex items-start"
          }, [
            v("div", Ih, [
              Xe(v("input", Fe({
                id: `${m(o)}-${w}`,
                "onUpdate:modelValue": h[0] || (h[0] = (D) => e.value = D),
                "aria-labelledby": `${m(o)}-${w}-label`,
                "aria-describedby": y.help ? `${m(o)}-${w}-help` : void 0,
                disabled: y.disabled,
                class: [
                  "h-4 w-4 rounded cursor-pointer",
                  "disabled:bg-gray-100 disabled:border-gray-200  disabled:cursor-not-allowed disabled:opacity-100",
                  "checked:disabled:bg-xy-blue checked:disabled:border-xy-blue checked:disabled:opacity-50",
                  m(s) ? "border-red-700 focus:ring-red-700" : "border-gray-300 focus:ring-xy-blue-500"
                ],
                type: "checkbox",
                value: y.value,
                ref_for: !0
              }, g.$attrs, {
                onChange: h[1] || (h[1] = //@ts-ignore
                (...D) => m(i) && m(i)(...D))
              }), null, 16, Lh), [
                [uo, e.value]
              ])
            ]),
            v("div", Nh, [
              k(qe, {
                id: `${m(o)}-${w}-label`,
                for: `${m(o)}-${w}`,
                label: y.label,
                class: L(
                  m(a) || y.disabled ? "cursor-not-allowed" : "cursor-pointer"
                )
              }, null, 8, ["id", "for", "label", "class"]),
              k(Re, {
                id: `${m(o)}-${w}-help`,
                text: y.help
              }, null, 8, ["id", "text"])
            ])
          ]))), 128))
        ], 2)
      ]),
      c.value ? (x(), _("input", {
        key: 1,
        ref: "errorInput",
        required: "",
        class: "sr-only top-1 left-1",
        "aria-hidden": "",
        type: "checkbox",
        onInvalid: f
      }, null, 544)) : B("", !0)
    ], 8, Ah));
  }
});
function Ta(t) {
  const { anchorOffset: n = 0, focusOffset: e = 0 } = t.ownerDocument.getSelection() || {}, r = Math.min(n, e), o = Math.max(n, e);
  return [r, o];
}
function Bh(t, [n, e]) {
  var r, o, a, s;
  const i = t.ownerDocument, l = i.createRange();
  l.setStart(t.firstChild || t, Math.min(n, (o = (r = t.textContent) === null || r === void 0 ? void 0 : r.length) !== null && o !== void 0 ? o : 0)), l.setEnd(t.lastChild || t, Math.min(e, (s = (a = t.textContent) === null || a === void 0 ? void 0 : a.length) !== null && s !== void 0 ? s : 0));
  const u = i.getSelection();
  u && (u.removeAllRanges(), u.addRange(l));
}
class jh {
  constructor(n) {
    this.element = n, this.maxLength = 1 / 0;
  }
  get value() {
    return this.element.innerText.replace(/\n\n$/, `
`);
  }
  set value(n) {
    this.element.innerHTML = n.replace(/\n$/, `

`);
  }
  get selectionStart() {
    return Ta(this.element)[0];
  }
  get selectionEnd() {
    return Ta(this.element)[1];
  }
  setSelectionRange(n, e) {
    Bh(this.element, [n ?? 0, e ?? 0]);
  }
  select() {
    this.setSelectionRange(0, this.value.length);
  }
}
function Vh(t) {
  const n = new jh(t);
  return new Proxy(t, {
    get(e, r) {
      if (r in n)
        return n[r];
      const o = e[r];
      return typeof o == "function" ? o.bind(e) : o;
    },
    // eslint-disable-next-line @typescript-eslint/max-params
    set(e, r, o, a) {
      return Reflect.set(r in n ? n : e, r, o, a);
    }
  });
}
const Hh = (t) => t.isContentEditable ? Vh(t) : t.querySelector("input,textarea") || t, Mo = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class Uh {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const n = this.past.pop();
    n && this.now && (this.future.push(this.now), this.updateElement(n, "historyUndo"));
  }
  redo() {
    const n = this.future.pop();
    n && this.now && (this.past.push(this.now), this.updateElement(n, "historyRedo"));
  }
  updateHistory(n) {
    if (!this.now) {
      this.now = n;
      return;
    }
    const e = this.now.value !== n.value, r = this.now.selection.some((o, a) => o !== n.selection[a]);
    !e && !r || (e && (this.past.push(this.now), this.future = []), this.now = n);
  }
  updateElement(n, e) {
    this.now = n, this.updateElementState(n, { inputType: e, data: null });
  }
}
function qh(t, ...n) {
  return n.every(({ value: e }) => e === t.value);
}
function Wh(t, ...n) {
  return n.every(({ value: e, selection: r }) => e === t.value && r[0] === t.selection[0] && r[1] === t.selection[1]);
}
function Yh({ value: t, selection: n }, e, r) {
  const [o, a] = n, s = typeof r == "function" ? r({ value: t, selection: n }) : r;
  return {
    value: t,
    selection: s === "replace" ? [o, Math.max(o + e.length, a)] : [o, a]
  };
}
function _r(t) {
  return typeof t == "string";
}
function Ma(t, n, e, r) {
  let o = "";
  for (let a = n.length; a < t.length; a++) {
    const s = t[a] || "", i = (r == null ? void 0 : r.value[a]) === s;
    if (!_r(s) || s === e && !i)
      return o;
    o += s;
  }
  return o;
}
function fi(t, n) {
  return Array.isArray(n) ? t.length === n.length && Array.from(t).every((e, r) => {
    const o = n[r] || "";
    return _r(o) ? e === o : e.match(o);
  }) : n.test(t);
}
function zh(t, n, e) {
  let r = null, o = null;
  const a = Array.from(t.value).reduce((i, l, u) => {
    const c = Ma(n, i, l, e), d = i + c, f = n[d.length] || "";
    return r === null && u >= t.selection[0] && (r = d.length), o === null && u >= t.selection[1] && (o = d.length), _r(f) ? d + f : l.match(f) ? d + l : d;
  }, ""), s = Ma(n, a, "", e);
  return {
    value: fi(a + s, n) ? a + s : a,
    selection: [r ?? a.length, o ?? a.length]
  };
}
function Kh({ value: t, selection: n }, e) {
  const [r, o] = n;
  let a = r, s = o;
  const i = Array.from(t).reduce((l, u, c) => {
    const d = l + u;
    return r === c && (a = l.length), o === c && (s = l.length), d.match(e) ? d : l;
  }, "");
  return {
    value: i,
    selection: [
      Math.min(a, i.length),
      Math.min(s, i.length)
    ]
  };
}
function Un(t, n, e = null) {
  if (fi(t.value, n))
    return t;
  const { value: r, selection: o } = Array.isArray(n) ? zh(t, n, e) : Kh(t, n);
  return {
    selection: o,
    value: Array.isArray(n) ? r.slice(0, n.length) : r
  };
}
function Pa(t, n) {
  if (!Array.isArray(n))
    return t;
  const [e, r] = t.selection, o = [], a = Array.from(t.value).reduce((s, i, l) => {
    const u = n[l] || "";
    return l === e && o.push(s.length), l === r && o.push(s.length), _r(u) && u === i ? s : s + i;
  }, "");
  return o.length < 2 && o.push(...new Array(2 - o.length).fill(a.length)), {
    value: a,
    selection: [o[0], o[1]]
  };
}
class so {
  constructor(n, e) {
    this.initialElementState = n, this.maskOptions = e, this.value = "", this.selection = [0, 0];
    const { value: r, selection: o } = Un(this.initialElementState, this.getMaskExpression(this.initialElementState));
    this.value = r, this.selection = o;
  }
  addCharacters([n, e], r) {
    const { value: o, maskOptions: a } = this, s = this.getMaskExpression({
      value: o.slice(0, n) + r + o.slice(e),
      selection: [n + r.length, n + r.length]
    }), i = { value: o, selection: [n, e] }, l = Pa(i, s), [u, c] = Yh(l, r, a.overwriteMode).selection, d = l.value.slice(0, u) + r, f = d.length, g = Un({
      value: d + l.value.slice(c),
      selection: [f, f]
    }, s, i);
    if (o.slice(0, n) === Un({
      value: d,
      selection: [f, f]
    }, s, i).value || Wh(this, g))
      throw new Error("Invalid mask value");
    this.value = g.value, this.selection = g.selection;
  }
  deleteCharacters([n, e]) {
    if (n === e || !e)
      return;
    const { value: r } = this, o = this.getMaskExpression({
      value: r.slice(0, n) + r.slice(e),
      selection: [n, n]
    }), a = { value: r, selection: [n, e] }, s = Pa(a, o), [i, l] = s.selection, u = s.value.slice(0, i) + s.value.slice(l), c = Un({ value: u, selection: [i, i] }, o, a);
    this.value = c.value, this.selection = c.selection;
  }
  getMaskExpression(n) {
    const { mask: e } = this.maskOptions;
    return typeof e == "function" ? e(n) : e;
  }
}
class Gh {
  constructor(n) {
    this.element = n, this.listeners = [];
  }
  listen(n, e, r) {
    const o = e;
    this.element.addEventListener(n, o, r), this.listeners.push(() => this.element.removeEventListener(n, o, r));
  }
  destroy() {
    this.listeners.forEach((n) => n());
  }
}
const at = {
  CTRL: 1,
  ALT: 2,
  SHIFT: 4,
  META: 8
}, hn = {
  Y: 89,
  Z: 90
};
function gn(t, n, e) {
  return t.ctrlKey === !!(n & at.CTRL) && t.altKey === !!(n & at.ALT) && t.shiftKey === !!(n & at.SHIFT) && t.metaKey === !!(n & at.META) && /**
   * We intentionally use legacy {@link KeyboardEvent#keyCode `keyCode`} property. It is more
   * "keyboard-layout"-independent than {@link KeyboardEvent#key `key`} or {@link KeyboardEvent#code `code`} properties.
   * @see {@link https://github.com/taiga-family/maskito/issues/315 `KeyboardEvent#code` issue}
   */
  t.keyCode === e;
}
function Jh(t) {
  return gn(t, at.CTRL, hn.Y) || // Windows
  gn(t, at.CTRL | at.SHIFT, hn.Z) || // Windows & Android
  gn(t, at.META | at.SHIFT, hn.Z);
}
function Xh(t) {
  return gn(t, at.CTRL, hn.Z) || // Windows & Android
  gn(t, at.META, hn.Z);
}
function Po(t, n) {
  var e;
  const r = t.value;
  if (typeof n == "string")
    t.value = n;
  else {
    const [o, a] = n.selection;
    t.value = n.value, t.matches(":focus") && ((e = t.setSelectionRange) === null || e === void 0 || e.call(t, o, a));
  }
  t.value !== r && t.dispatchEvent(new Event(
    "input",
    /**
     * React handles this event only on bubbling phase
     *
     * here is the list of events that are processed in the capture stage, others are processed in the bubbling stage
     * https://github.com/facebook/react/blob/cb2439624f43c510007f65aea5c50a8bb97917e4/packages/react-dom-bindings/src/events/DOMPluginEventSystem.js#L222
     */
    { bubbles: !0 }
  ));
}
function Zh({ value: t, selection: n }, e) {
  const [r, o] = n;
  if (r !== o)
    return [r, o];
  const a = e ? t.slice(r).indexOf(`
`) + 1 || t.length : t.slice(0, o).lastIndexOf(`
`) + 1;
  return [e ? r : a, e ? a : o];
}
function Qh({ value: t, selection: n }, e) {
  const [r, o] = n;
  return r !== o ? [r, o] : (e ? [r, o + 1] : [r - 1, o]).map((s) => Math.min(Math.max(s, 0), t.length));
}
const eg = /\s+$/g, tg = /^\s+/g, Aa = /\s/;
function ng({ value: t, selection: n }, e) {
  const [r, o] = n;
  if (r !== o)
    return [r, o];
  if (e) {
    const l = t.slice(r), [u] = l.match(tg) || [
      ""
    ], c = l.trimStart().search(Aa);
    return [
      r,
      c !== -1 ? r + u.length + c : t.length
    ];
  }
  const a = t.slice(0, o), [s] = a.match(eg) || [""], i = a.trimEnd().split("").reverse().findIndex((l) => Aa.exec(l));
  return [
    i !== -1 ? o - s.length - i : 0,
    o
  ];
}
function rr(t = []) {
  return (n, ...e) => t.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...e)), n);
}
function kr(t, n) {
  const e = Object.assign(Object.assign({}, Mo), n), r = rr(e.preprocessors), o = rr(e.postprocessors), a = typeof t == "string" ? { value: t, selection: [0, 0] } : t, { elementState: s } = r({ elementState: a, data: "" }, "validation"), i = new so(s, e), { value: l, selection: u } = o(i, a);
  return typeof t == "string" ? l : { value: l, selection: u };
}
class rg extends Uh {
  constructor(n, e) {
    super(), this.element = n, this.maskitoOptions = e, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new Gh(this.element), this.options = Object.assign(Object.assign({}, Mo), this.maskitoOptions), this.upcomingElementState = null, this.preprocessor = rr(this.options.preprocessors), this.postprocessor = rr(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (Jh(r))
        return r.preventDefault(), this.redo();
      if (Xh(r))
        return r.preventDefault(), this.undo();
    }), this.eventListener.listen("beforeinput", (r) => {
      var o, a, s;
      const i = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: i,
            selection: Qh(this.elementState, i)
          });
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
          return this.handleDelete({
            event: r,
            isForward: i,
            selection: Zh(this.elementState, i),
            force: !0
          });
        case "deleteWordBackward":
        case "deleteWordForward":
          return this.handleDelete({
            event: r,
            isForward: i,
            selection: ng(this.elementState, i),
            force: !0
          });
        case "historyRedo":
          return r.preventDefault(), this.redo();
        // historyUndo/historyRedo will not be triggered if value was modified programmatically
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "insertCompositionText":
          return;
        // will be handled inside `compositionend` event
        case "insertLineBreak":
        case "insertParagraph":
          return this.handleEnter(r);
        case "insertReplacementText":
          return;
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertText":
        default:
          return this.handleInsert(r, (s = (o = r.data) !== null && o !== void 0 ? o : (
            // `event.data` for `contentEditable` is always `null` for paste/drop events
            (a = r.dataTransfer) === null || a === void 0 ? void 0 : a.getData("text/plain")
          )) !== null && s !== void 0 ? s : "");
      }
    }), this.eventListener.listen("input", () => {
      this.upcomingElementState && (this.updateElementState(this.upcomingElementState), this.upcomingElementState = null);
    }, { capture: !0 }), this.eventListener.listen("input", ({ inputType: r }) => {
      r !== "insertCompositionText" && (this.ensureValueFitsMask(), this.updateHistory(this.elementState));
    }), this.eventListener.listen("compositionend", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((n) => n == null ? void 0 : n());
  }
  updateElementState({ value: n, selection: e }, r) {
    const o = this.elementState.value;
    this.updateValue(n), this.updateSelectionRange(e), r && o !== n && this.dispatchInputEvent(r);
  }
  get elementState() {
    const { value: n, selectionStart: e, selectionEnd: r } = this.element;
    return {
      value: n,
      selection: [e ?? 0, r ?? 0]
    };
  }
  get maxLength() {
    const { maxLength: n } = this.element;
    return n === -1 ? 1 / 0 : n;
  }
  updateSelectionRange([n, e]) {
    var r;
    const { element: o } = this;
    o.matches(":focus") && (o.selectionStart !== n || o.selectionEnd !== e) && ((r = o.setSelectionRange) === null || r === void 0 || r.call(o, n, e));
  }
  updateValue(n) {
    this.element.value = n;
  }
  ensureValueFitsMask() {
    this.updateElementState(kr(this.elementState, this.options), {
      inputType: "insertText",
      data: null
    });
  }
  dispatchInputEvent(n = {
    inputType: "insertText",
    data: null
  }) {
    globalThis.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, n), { bubbles: !0, cancelable: !1 })));
  }
  handleDelete({ event: n, selection: e, isForward: r, force: o = !1 }) {
    const a = {
      value: this.elementState.value,
      selection: e
    }, [s, i] = a.selection, { elementState: l } = this.preprocessor({
      elementState: a,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), u = new so(l, this.options), [c, d] = l.selection;
    u.deleteCharacters([c, d]);
    const f = this.postprocessor(u, a);
    if (!(a.value.slice(0, s) + a.value.slice(i) === f.value && !o && !this.element.isContentEditable)) {
      if (qh(a, l, u, f))
        return n.preventDefault(), this.updateSelectionRange(r ? [d, d] : [c, c]);
      this.upcomingElementState = f;
    }
  }
  handleInsert(n, e) {
    const { options: r, maxLength: o, element: a, elementState: s } = this, { elementState: i, data: l = e } = this.preprocessor({
      data: e,
      elementState: s
    }, "insert"), u = new so(i, r);
    try {
      u.addCharacters(i.selection, l);
    } catch {
      return n.preventDefault();
    }
    const [c, d] = i.selection, f = s.value.slice(0, c) + e + s.value.slice(d), g = this.postprocessor(u, s);
    if (g.value.length > o)
      return n.preventDefault();
    (f !== g.value || a.isContentEditable) && (this.upcomingElementState = g, r.overwriteMode === "replace" && f.length > o && this.dispatchInputEvent({ inputType: "insertText", data: e }));
  }
  handleEnter(n) {
    (this.isTextArea || this.element.isContentEditable) && this.handleInsert(n, `
`);
  }
}
const or = /* @__PURE__ */ new Map(), io = /* @__PURE__ */ new Map();
async function Oa(t, n) {
  var e, r;
  const o = (e = n == null ? void 0 : n.elementPredicate) !== null && e !== void 0 ? e : Hh;
  io.set(t, o);
  const a = await o(t);
  io.get(t) === o && ((r = or.get(t)) === null || r === void 0 || r.destroy(), n && or.set(t, new rg(a, n)));
}
const og = {
  unmounted: (t) => {
    var n;
    (n = or.get(t)) === null || n === void 0 || n.destroy(), or.delete(t), io.delete(t);
  },
  mounted: async (t, { value: n }) => Oa(t, n),
  updated: async (t, { value: n, oldValue: e }) => {
    n !== e && await Oa(t, n);
  }
};
function ar(t, n, e) {
  const r = Math.min(Number(e), Math.max(Number(n), Number(t)));
  return t instanceof Date ? new Date(r) : r;
}
const ag = [".", ",", "б", "ю"], sg = " ", ig = "​", pi = "–", mi = "—", sr = "-", lo = "−", hi = "ー", lg = [":", "."];
function tn(t) {
  return t;
}
function ug() {
}
const gi = /[\\^$.*+?()[\]{}|]/g, cg = new RegExp(gi.source);
function Ne(t) {
  return t && cg.test(t) ? t.replaceAll(gi, String.raw`\$&`) : t;
}
function mt(t, { prefix: n, postfix: e }) {
  var r, o;
  const a = new RegExp(`^${Ne(n)}`), s = new RegExp(`${Ne(e)}$`), [i = ""] = (r = t.match(a)) !== null && r !== void 0 ? r : [], [l = ""] = (o = t.match(s)) !== null && o !== void 0 ? o : [];
  return {
    extractedPrefix: i,
    extractedPostfix: l,
    cleanValue: i || l ? t.slice(i.length, l.length ? -l.length : 1 / 0) : t
  };
}
function dg(t, n) {
  let e = "";
  for (let r = 0; r < t.length; r++) {
    if (t[r] !== n[r])
      return e;
    e += t[r];
  }
  return e;
}
function Ra(t) {
  return t.replaceAll(/[０-９]/g, (n) => String.fromCharCode(n.charCodeAt(0) - 65248));
}
function fg() {
  return ({ elementState: t, data: n }) => {
    const { value: e, selection: r } = t;
    return {
      elementState: {
        selection: r,
        value: Ra(e)
      },
      data: Ra(n)
    };
  };
}
new RegExp(`[${lg.map(Ne).join("")}]$`);
function pg(t) {
  const n = new RegExp(`${Ne(t)}$`);
  return t ? ({ value: e, selection: r }, o) => {
    if (!e && !o.value.endsWith(t))
      return { value: e, selection: r };
    if (!e.endsWith(t) && !o.value.endsWith(t))
      return { selection: r, value: e + t };
    const a = o.value.replace(n, ""), s = o.selection[1] > a.length, i = dg(a, e);
    return {
      selection: r,
      value: Array.from(t).reverse().reduce((l, u, c) => {
        const d = l.length - 1 - c, f = i[d] === u && s;
        return l[d] !== u || f ? l.slice(0, d + 1) + u + l.slice(d + 1) : l;
      }, e)
    };
  } : tn;
}
function mg(t) {
  return t ? ({ value: n, selection: e }, r) => {
    if (n.startsWith(t) || // already valid
    !n && !r.value.startsWith(t))
      return { value: n, selection: e };
    const [o, a] = e, s = Array.from(t).reduce((l, u, c) => l[c] === u ? l : l.slice(0, c) + u + l.slice(c), n), i = s.length - n.length;
    return {
      selection: [o + i, a + i],
      value: s
    };
  } : tn;
}
function Ao(t, n, e) {
  return (r, o) => {
    const a = () => n(r, o);
    return r.addEventListener(t, a, e), () => r.removeEventListener(t, a, e);
  };
}
function hg({ prefix: t, postfix: n }) {
  return ({ elementState: e, data: r }) => {
    const { cleanValue: o } = mt(r, {
      prefix: t,
      postfix: n
    });
    return {
      elementState: e,
      data: o
    };
  };
}
function vi({ decimalSeparator: t, isNegativeAllowed: n, precision: e, thousandSeparator: r, prefix: o, postfix: a, decimalPseudoSeparators: s = [], pseudoMinuses: i = [], minusSign: l }) {
  const u = Ia(o), c = String.raw`\d`, d = n ? `[${l}${i.map((w) => `\\${w}`).join("")}]?` : "", f = r ? `[${c}${Ne(r).replaceAll(/\s/g, String.raw`\s`)}]*` : `[${c}]*`, g = Number.isFinite(e) ? e : "", h = e > 0 ? `([${Ne(t)}${s.map(Ne).join("")}]${c}{0,${g}})?` : "", y = Ia(a);
  return new RegExp(`^${u}${d}${f}${h}${y}$`);
}
function Ia(t) {
  return t ? `${t.split("").map((n) => `${Ne(n)}?`).join("")}` : "";
}
function Sr(t, n = ".") {
  const e = !!new RegExp(`^\\D*[${lo}\\${sr}${pi}${mi}${hi}]`).exec(t), r = Ne(n), o = t.replaceAll(new RegExp(`${r}(?!\\d)`, "g"), "").replaceAll(new RegExp(`[^\\d${r}]`, "g"), "").replace(n, n && ".");
  return o ? +`${e ? sr : ""}${o}` : NaN;
}
function gg(t) {
  var n;
  const e = String(t), [r = "", o] = e.split("e-");
  let a = e;
  if (o) {
    const [, s] = r.split("."), i = Number(o) + ((n = s == null ? void 0 : s.length) !== null && n !== void 0 ? n : 0);
    a = t.toFixed(i);
  }
  return a;
}
function bi(t, { decimalSeparator: n, minusSign: e }) {
  const [r = "", o = ""] = n ? t.split(n) : [t], a = Ne(e), [, s = "", i = ""] = new RegExp(`^(?:[^\\d${a}])?(${a})?(.*)`).exec(r) || [];
  return { minus: s, integerPart: i, decimalPart: o };
}
function vg({ decimalSeparator: t, thousandSeparator: n, decimalPseudoSeparators: e = ag }) {
  return e.filter((r) => r !== n && r !== t);
}
function bg({ decimalSeparator: t, precision: n, decimalZeroPadding: e, prefix: r, postfix: o }) {
  return n <= 0 || !e ? tn : ({ value: a, selection: s }) => {
    const { cleanValue: i, extractedPrefix: l, extractedPostfix: u } = mt(a, {
      prefix: r,
      postfix: o
    });
    if (Number.isNaN(Sr(i, t)))
      return { value: a, selection: s };
    const [c, d = ""] = i.split(t);
    return {
      value: l + c + t + d.padEnd(n, "0") + u,
      selection: s
    };
  };
}
function yg({ prefix: t, postfix: n, decimalSeparator: e, minusSign: r }) {
  return ({ value: o, selection: a }) => {
    const [s] = a, { cleanValue: i, extractedPrefix: l, extractedPostfix: u } = mt(o, {
      prefix: t,
      postfix: n
    }), { minus: c, integerPart: d, decimalPart: f } = bi(i, {
      decimalSeparator: e,
      minusSign: r
    }), g = !d && !f && !!e && i.includes(e);
    return !d && !Number(f) && s === (c + l).length || g ? {
      selection: a,
      value: l + c + u
    } : { value: o, selection: a };
  };
}
function wg({ decimalSeparator: t, decimalPseudoSeparators: n, pseudoMinuses: e, prefix: r, postfix: o, minusSign: a }) {
  let s = !0;
  const i = vi({
    decimalSeparator: t,
    decimalPseudoSeparators: n,
    pseudoMinuses: e,
    prefix: "",
    postfix: "",
    thousandSeparator: "",
    precision: 1 / 0,
    isNegativeAllowed: !0,
    minusSign: a
  });
  return ({ elementState: l, data: u }) => {
    if (!s)
      return { elementState: l, data: u };
    s = !1;
    const { value: c, selection: d } = l, [f, g] = d, { extractedPrefix: h, cleanValue: y, extractedPostfix: w } = mt(c, {
      prefix: r,
      postfix: o
    }), D = kr({
      selection: [
        Math.max(f - h.length, 0),
        ar(g - h.length, 0, y.length)
      ],
      value: y
    }, {
      mask: i
    }), [T, M] = D.selection;
    return {
      elementState: {
        selection: [
          T + h.length,
          M + h.length
        ],
        value: h + D.value + w
      },
      data: u
    };
  };
}
function xg({ decimalSeparator: t, thousandSeparator: n, prefix: e, postfix: r }) {
  const o = (s) => {
    const i = Ne(n);
    return s.replace(
      // all leading zeroes followed by another zero
      new RegExp(`^(\\D+)?[0${i}]+(?=0)`),
      "$1"
    ).replace(
      // zero followed by not-zero digit
      new RegExp(`^(\\D+)?[0${i}]+(?=[1-9])`),
      "$1"
    );
  }, a = (s, i) => {
    const l = s.slice(0, i), u = s.slice(i).startsWith("0");
    return l.length - o(l).length + (u ? 1 : 0);
  };
  return ({ value: s, selection: i }) => {
    const [l, u] = i, { cleanValue: c, extractedPrefix: d, extractedPostfix: f } = mt(s, {
      prefix: e,
      postfix: r
    }), g = !!t && c.includes(t), [h = "", y = ""] = t ? c.split(t) : [c], w = o(h);
    if (h === w)
      return { value: s, selection: i };
    const D = l - a(s, l), T = u - a(s, u);
    return {
      value: d + w + (g ? t : "") + y + f,
      selection: [Math.max(D, 0), Math.max(T, 0)]
    };
  };
}
function Cg({ min: t, max: n, decimalSeparator: e, minusSign: r }) {
  return ({ value: o, selection: a }) => {
    const s = Sr(o, e), i = (
      /**
       * We cannot limit lower bound if user enters positive number.
       * The same for upper bound and negative number.
       * ___
       * @example (min = 5)
       * Empty input => Without this condition user cannot type 42 (the first digit will be rejected)
       * ___
       * @example (max = -10)
       * Value is -10 => Without this condition user cannot delete 0 to enter another digit
       */
      s > 0 ? Math.min(s, n) : Math.max(s, t)
    );
    if (s && i !== s) {
      const l = `${i}`.replace(".", e).replace(sr, r);
      return {
        value: l,
        selection: [l.length, l.length]
      };
    }
    return {
      value: o,
      selection: a
    };
  };
}
function Dg({ decimalSeparator: t, thousandSeparator: n, decimalZeroPadding: e }) {
  return ({ elementState: r, data: o }, a) => {
    const { value: s, selection: i } = r, [l, u] = i, c = s.slice(l, u), d = e ? [t, n] : [n], f = e && l > s.indexOf(t) && !!c.match(/^0+$/gi);
    return a !== "deleteBackward" && a !== "deleteForward" || !d.includes(c) && !f ? {
      elementState: r,
      data: o
    } : {
      elementState: {
        value: s,
        selection: a === "deleteForward" ? [u, u] : [l, l]
      },
      data: o
    };
  };
}
function Eg({ decimalSeparator: t, precision: n, prefix: e, postfix: r }) {
  const o = new RegExp(`^\\D*${Ne(t)}`);
  return ({ elementState: a, data: s }) => {
    const { value: i, selection: l } = a, { cleanValue: u, extractedPrefix: c } = mt(i, {
      prefix: e,
      postfix: r
    }), [d, f] = l, g = ar(d - c.length, 0, u.length), h = ar(f - c.length, 0, u.length);
    if (n <= 0 || u.slice(0, g).includes(t) || u.slice(h).includes(t) || !s.match(o))
      return { elementState: a, data: s };
    const y = /\d+/.exec(u.slice(0, g));
    return {
      elementState: a,
      data: y ? s : `0${s}`
    };
  };
}
function La({ validCharacter: t, pseudoCharacters: n, prefix: e, postfix: r }) {
  const o = new RegExp(`[${n.join("")}]`, "gi");
  return ({ elementState: a, data: s }) => {
    const { value: i, selection: l } = a, { cleanValue: u, extractedPostfix: c, extractedPrefix: d } = mt(i, {
      prefix: e,
      postfix: r
    });
    return {
      elementState: {
        selection: l,
        value: d + u.replace(o, t) + c
      },
      data: s.replace(o, t)
    };
  };
}
function _g({ decimalSeparator: t, prefix: n, postfix: e }) {
  return t ? ({ elementState: r, data: o }) => {
    const { value: a, selection: s } = r, [i, l] = s, { cleanValue: u } = mt(a, { prefix: n, postfix: e });
    return {
      elementState: r,
      data: !u.includes(t) || a.slice(i, l + 1).includes(t) ? o : o.replaceAll(new RegExp(Ne(t), "gi"), "")
    };
  } : tn;
}
function kg({ thousandSeparator: t, decimalSeparator: n, prefix: e, postfix: r, minusSign: o }) {
  if (!t)
    return tn;
  const a = (...s) => s.every((i) => /\s/.test(i));
  return ({ value: s, selection: i }) => {
    const [l, u] = i;
    let [c, d] = i;
    const { cleanValue: f, extractedPostfix: g, extractedPrefix: h } = mt(s, {
      prefix: e,
      postfix: r
    }), { minus: y, integerPart: w, decimalPart: D } = bi(f, {
      decimalSeparator: n,
      minusSign: o
    }), T = n && f.includes(n), M = f.length - (y + w + (T ? n + D : "")).length;
    M > 0 && l && l <= M && (c -= M), M > 0 && u && u <= M && (d -= M);
    const K = Array.from(w).reduceRight((q, Z, H) => {
      const J = !(!H && Z === t) && !!q.length && (q.length + 1) % 4 === 0, ne = Z === t || a(Z, t);
      return J && ne ? t + q : !J && ne ? (H && H <= l && c--, H && H <= u && d--, q) : J ? (H < l && c++, H < u && d++, Z + t + q) : Z + q;
    }, "");
    return {
      value: h + y + K + (T ? n : "") + D + g,
      selection: [c, d]
    };
  };
}
function Sg({ precision: t, decimalSeparator: n, prefix: e, postfix: r }) {
  if (t > 0 || !n)
    return tn;
  const o = new RegExp(`${Ne(n)}.*$`, "g");
  return ({ elementState: a, data: s }) => {
    const { value: i, selection: l } = a, { cleanValue: u, extractedPrefix: c, extractedPostfix: d } = mt(i, {
      prefix: e,
      postfix: r
    }), [f, g] = l, h = c + u.replace(o, "") + d;
    return {
      elementState: {
        selection: [
          Math.min(f, h.length),
          Math.min(g, h.length)
        ],
        value: h
      },
      data: s.replace(o, "")
    };
  };
}
const Na = [0, 0];
function $g({ decimalSeparator: t, thousandSeparator: n, prefix: e, postfix: r }) {
  const o = xg({
    decimalSeparator: t,
    thousandSeparator: n,
    prefix: e,
    postfix: r
  });
  return Ao("blur", (a) => {
    const s = o({
      value: a.value,
      selection: Na
    }, { value: "", selection: Na }).value;
    Po(a, s);
  }, { capture: !0 });
}
function Tg({ min: t, max: n, decimalSeparator: e }) {
  return Ao("blur", (r, o) => {
    const a = Sr(r.value, e), s = ar(a, t, n);
    !Number.isNaN(a) && a !== s && Po(r, kr(gg(s), o));
  }, { capture: !0 });
}
function Mg({ decimalSeparator: t, prefix: n, postfix: e }) {
  return t ? Ao("blur", (r) => {
    const { cleanValue: o, extractedPostfix: a, extractedPrefix: s } = mt(r.value, { prefix: n, postfix: e }), i = s + o.replace(new RegExp(`^(\\D+)?${Ne(t)}`), `$10${t}`) + a;
    Po(r, i);
  }, { capture: !0 }) : ug;
}
function Pg({ max: t = Number.MAX_SAFE_INTEGER, min: n = Number.MIN_SAFE_INTEGER, precision: e = 0, thousandSeparator: r = sg, decimalSeparator: o = ".", decimalPseudoSeparators: a, decimalZeroPadding: s = !1, prefix: i = "", postfix: l = "", minusSign: u = lo } = {}) {
  const c = [
    sr,
    pi,
    mi,
    hi,
    lo
  ].filter((h) => h !== r && h !== o && h !== u), d = vg({
    decimalSeparator: o,
    thousandSeparator: r,
    decimalPseudoSeparators: a
  }), f = i.endsWith(o) && e > 0 ? `${i}${ig}` : i, g = wg({
    decimalSeparator: o,
    decimalPseudoSeparators: d,
    pseudoMinuses: c,
    prefix: f,
    postfix: l,
    minusSign: u
  });
  return o = e <= 0 && o === r ? "" : o, Object.assign(Object.assign({}, Mo), { mask: vi({
    decimalSeparator: o,
    precision: e,
    thousandSeparator: r,
    prefix: f,
    postfix: l,
    isNegativeAllowed: n < 0,
    minusSign: u
  }), preprocessors: [
    fg(),
    g,
    hg({ prefix: f, postfix: l }),
    La({
      validCharacter: u,
      pseudoCharacters: c,
      prefix: f,
      postfix: l
    }),
    La({
      validCharacter: o,
      pseudoCharacters: d,
      prefix: f,
      postfix: l
    }),
    Eg({
      decimalSeparator: o,
      precision: e,
      prefix: f,
      postfix: l
    }),
    Dg({
      decimalSeparator: o,
      decimalZeroPadding: s,
      thousandSeparator: r
    }),
    Sg({
      precision: e,
      decimalSeparator: o,
      prefix: f,
      postfix: l
    }),
    _g({
      decimalSeparator: o,
      prefix: f,
      postfix: l
    })
  ], postprocessors: [
    Cg({ decimalSeparator: o, min: n, max: t, minusSign: u }),
    mg(f),
    pg(l),
    kg({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: f,
      postfix: l,
      minusSign: u
    }),
    bg({
      decimalSeparator: o,
      decimalZeroPadding: s,
      precision: e,
      prefix: f,
      postfix: l
    }),
    yg({
      prefix: f,
      postfix: l,
      decimalSeparator: o,
      minusSign: u
    })
  ], plugins: [
    $g({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: f,
      postfix: l
    }),
    Mg({
      decimalSeparator: o,
      prefix: f,
      postfix: l
    }),
    Tg({ min: n, max: t, decimalSeparator: o })
  ], overwriteMode: s ? ({ value: h, selection: [y] }) => y <= h.indexOf(o) ? "shift" : "replace" : "shift" });
}
const Ag = ["id", "aria-labelledby", "aria-describedby", "aria-errormessage", "placeholder"], Og = ["value", "name", "min", "max", "required"], yi = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "NumberInput",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    max: {},
    min: {},
    modelValue: {},
    precision: {},
    type: {},
    label: {},
    help: {},
    placeholder: {}
  }, {
    ...dt,
    max: Number.MAX_SAFE_INTEGER,
    min: Number.MIN_SAFE_INTEGER,
    precision: 0,
    type: "number"
  }), {
    modelValue: de,
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: n }) {
    const e = t, r = P(() => {
      const h = {
        decimalSeparator: ".",
        thousandSeparator: ",",
        min: e.min,
        max: e.max,
        precision: e.precision,
        minusSign: "-"
      };
      switch (e.type) {
        case "money":
          h.decimalZeroPadding = !0, h.precision = 2, h.prefix = "$";
          break;
        case "raw-number":
          h.thousandSeparator = "";
          break;
      }
      return Pg(h);
    }), o = xe(t, "modelValue", de), a = P({
      get: () => {
        if (o.value === null || o.value === void 0)
          return "";
        let h = o.value;
        return e.type === "money" && (h = h / 100), kr(h.toString(), r.value);
      },
      set: (h) => {
        if (h === "") {
          o.value = null;
          return;
        }
        let y = Sr(h);
        if (isNaN(y)) {
          o.value = null;
          return;
        }
        if (e.type === "money") {
          let w = y.toString().split("."), D = parseInt(w[0], 10), T = w.length > 1 ? parseInt(w[1].padEnd(2, "0"), 10) : 0;
          y = D * 100 + T;
        }
        o.value = y;
      }
    }), s = Nt("input"), {
      errorState: i,
      inputID: l,
      isRequired: u,
      nameAttr: c,
      onInvalid: d,
      inputValidation: f
    } = ft(e), g = P(() => {
      const h = ir(), { name: y, ...w } = h;
      return w;
    });
    return n({ input: s }), (h, y) => (x(), _("div", null, [
      k(qe, {
        id: `${m(l)}-label`,
        class: "mb-2",
        for: m(l),
        label: h.label,
        required: m(u)
      }, null, 8, ["id", "for", "label", "required"]),
      Xe(v("input", Fe({
        id: m(l),
        ref: "input",
        "onUpdate:modelValue": y[0] || (y[0] = (w) => a.value = w),
        "aria-labelledby": h.label ? `${m(l)}-label` : void 0,
        "aria-describedby": h.help ? `${m(l)}-help` : void 0,
        "aria-errormessage": m(i) ? `${m(l)}-error` : void 0,
        class: [
          "block w-full rounded-md border-0 py-2 shadow-sm ring-1 ring-inset focus:ring-2 sm:text-sm sm:leading-6",
          "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-700 disabled:ring-gray-200",
          m(i) ? "text-red-900 ring-red-700 placeholder:text-red-300 focus:ring-red-700" : "text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-xy-blue-500"
        ],
        placeholder: h.placeholder,
        type: "text",
        inputmode: "decimal"
      }, { ...g.value }, {
        onInput: y[1] || (y[1] = //@ts-ignore
        (...w) => m(f) && m(f)(...w))
      }), null, 16, Ag), [
        [co, a.value],
        [m(og), r.value]
      ]),
      k(Re, {
        id: `${m(l)}-help`,
        class: "mt-1",
        text: h.help
      }, null, 8, ["id", "text"]),
      k(ot, {
        id: `${m(l)}-error`,
        class: "mt-0.5",
        text: m(i)
      }, null, 8, ["id", "text"]),
      v("input", {
        value: o.value,
        class: "sr-only",
        "aria-hidden": "true",
        name: m(c),
        min: h.min,
        max: h.max,
        required: m(u),
        tabindex: "-1",
        type: "number",
        onInvalid: y[2] || (y[2] = //@ts-ignore
        (...w) => m(d) && m(d)(...w))
      }, null, 40, Og)
    ]));
  }
}), Rg = ["aria-labelledby", "aria-describedby", "aria-errormessage"], Ig = { key: 0 }, Lg = { class: "flex" }, Ng = { class: "flex items-center h-5" }, Fg = ["id", "aria-describedby", "aria-labelledby", "disabled", "name", "value"], Bg = { class: "ml-3" }, jg = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "Radio",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    modelValue: {},
    options: {},
    label: {},
    help: {},
    placeholder: {},
    columns: {}
  }, dt), {
    modelValue: de,
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", de), {
      aria: r,
      errorState: o,
      inputID: a,
      isDisabled: s,
      isRequired: i,
      onInvalid: l,
      validate: u
    } = ft(n);
    return (c, d) => (x(), _("fieldset", {
      class: "space-y-6",
      "aria-labelledby": m(r).labelledby,
      "aria-describedby": m(r).describedby,
      "aria-errormessage": m(r).errormessage
    }, [
      c.label ? (x(), _("div", Ig, [
        k($n, {
          id: m(r).labelledby,
          label: c.label,
          required: m(i)
        }, null, 8, ["id", "label", "required"]),
        c.help ? (x(), V(Re, {
          key: 0,
          id: m(r).describedby,
          class: "mt-1",
          tag: "p",
          text: c.help
        }, null, 8, ["id", "text"])) : B("", !0),
        k(ot, {
          id: m(r).errormessage,
          class: "mt-1",
          text: m(o)
        }, null, 8, ["id", "text"])
      ])) : B("", !0),
      v("div", Lg, [
        v("div", {
          class: L(["grid gap-y-5", {
            "sm:grid sm:gap-x-10": c.columns !== void 0,
            "sm:grid-cols-2": c.columns === 2,
            "sm:grid-cols-3": c.columns === 3
          }])
        }, [
          (x(!0), _(te, null, ae(c.options, (f, g) => (x(), _("div", {
            key: f.value,
            class: "flex items-start"
          }, [
            v("div", Ng, [
              Xe(v("input", Fe({
                id: `${m(a)}-${g}`,
                "onUpdate:modelValue": d[0] || (d[0] = (h) => e.value = h),
                "aria-describedby": f.help ? `${m(a)}-${g}-help` : void 0,
                "aria-labelledby": `${m(a)}-${g}-label`,
                class: [
                  "h-4 w-4 cursor-pointer text-xy-blue",
                  "disabled:bg-gray-100 disabled:border-gray-200  disabled:cursor-not-allowed disabled:opacity-100",
                  "checked:disabled:bg-xy-blue checked:disabled:border-xy-blue checked:disabled:opacity-50",
                  m(o) ? "border-red-700 focus:ring-red-700" : "border-gray-300  focus:ring-xy-blue-500"
                ],
                disabled: f.disabled,
                name: m(a),
                type: "radio",
                value: f.value,
                ref_for: !0
              }, c.$attrs, {
                onChange: d[1] || (d[1] = //@ts-ignore
                (...h) => m(u) && m(u)(...h)),
                onInvalid: d[2] || (d[2] = //@ts-ignore
                (...h) => m(l) && m(l)(...h))
              }), null, 16, Fg), [
                [Wr, e.value]
              ])
            ]),
            v("div", Bg, [
              k(qe, {
                id: `${m(a)}-${g}-label`,
                for: `${m(a)}-${g}`,
                label: f.label,
                class: L(
                  m(s) || f.disabled ? "cursor-not-allowed" : "cursor-pointer"
                )
              }, null, 8, ["id", "for", "label", "class"]),
              k(Re, {
                id: `${m(a)}-${g}-help`,
                text: f.help
              }, null, 8, ["id", "text"])
            ])
          ]))), 128))
        ], 2)
      ])
    ], 8, Rg));
  }
}), Vg = { class: "flex-1 flex pr-1" }, Hg = { class: "flex flex-col" }, Ug = {
  key: 1,
  class: "mt-auto mb-0"
}, qg = ["checked", "name", "required", "value"], Wg = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "RadioCards",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    options: {},
    modelValue: {},
    label: {},
    help: {},
    placeholder: {},
    columns: {}
  }, dt), {
    modelValue: de,
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", de), { aria: r, isDisabled: o, isRequired: a, nameAttr: s, errorState: i, onInvalid: l } = ft(n), u = (c) => {
      c && (i.value = "");
    };
    return (c, d) => (x(), V(m(ic), {
      modelValue: e.value,
      "onUpdate:modelValue": [
        d[1] || (d[1] = (f) => e.value = f),
        u
      ],
      disabled: m(o),
      "aria-invalid": m(i) ? "true" : null,
      "aria-errormessage": m(r).errormessage
    }, {
      default: N(() => [
        c.label ? (x(), V(m(fa), {
          key: 0,
          class: "block"
        }, {
          default: N(() => [
            k($n, {
              tag: "div",
              label: c.label,
              required: m(a)
            }, null, 8, ["label", "required"])
          ]),
          _: 1
        })) : B("", !0),
        c.help ? (x(), V(m(Fr), {
          key: 1,
          class: "mt-1"
        }, {
          default: N(() => [
            k(Re, { text: c.help }, null, 8, ["text"])
          ]),
          _: 1
        })) : B("", !0),
        k(ot, {
          id: m(r).errormessage,
          class: "mt-1",
          text: m(i)
        }, null, 8, ["id", "text"]),
        v("div", {
          class: L(["mt-6 grid grid-cols-1 gap-y-5 gap-x-4 relative", {
            "sm:grid-cols-2": c.columns === 2,
            "sm:grid-cols-3": c.columns === 3
          }])
        }, [
          (x(!0), _(te, null, ae(c.options, (f) => (x(), V(m(lc), {
            key: f.value,
            as: "template",
            disabled: m(o) || f.disabled,
            value: f.value
          }, {
            default: N(({
              active: g,
              checked: h,
              disabled: y
            }) => [
              v("div", {
                class: L(["relative border rounded-lg shadow-sm p-4 flex focus:outline-none", [
                  y ? "cursor-not-allowed bg-gray-50 border-gray-200 opacity-90" : "cursor-pointer bg-white border-gray-300",
                  m(i) && !y ? "border-red-700" : "",
                  h ? "border-transparent" : "",
                  g ? "border-xy-blue ring-2 ring-xy-blue-500" : ""
                ]])
              }, [
                v("div", Vg, [
                  v("div", Hg, [
                    k(m(fa), { as: "div" }, {
                      default: N(() => [
                        k(qe, {
                          tag: "div",
                          class: "mt-auto mb-auto",
                          label: f.label
                        }, null, 8, ["label"])
                      ]),
                      _: 2
                    }, 1024),
                    f.help ? (x(), V(m(Fr), {
                      key: 0,
                      as: "div"
                    }, {
                      default: N(() => [
                        k(Re, {
                          tag: "div",
                          class: "mt-auto",
                          text: f.help
                        }, null, 8, ["text"])
                      ]),
                      _: 2
                    }, 1024)) : B("", !0),
                    f.sublabel || c.$slots.sublabel ? (x(), _("div", Ug, [
                      k(m(Fr), {
                        as: "div",
                        class: "text-sm/5 font-medium mt-4 text-gray-800"
                      }, {
                        default: N(() => [
                          ge(c.$slots, "sublabel", {
                            active: g,
                            checked: h,
                            disabled: y,
                            option: f
                          }, () => [
                            ce(U(f.sublabel), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])) : B("", !0)
                  ])
                ]),
                k(m(Hs), {
                  class: L([h ? "" : "invisible", "h-5 w-5 text-xy-blue"]),
                  "aria-hidden": "true"
                }, null, 8, ["class"]),
                v("div", {
                  class: L([
                    g ? "border" : "border-2",
                    h ? "border-xy-blue" : "border-transparent",
                    "absolute -inset-px rounded-lg pointer-events-none"
                  ]),
                  "aria-hidden": "true"
                }, null, 2),
                v("input", {
                  class: "sr-only top-1 left-1",
                  "aria-hidden": "true",
                  checked: h,
                  name: m(s),
                  required: m(a),
                  tabindex: "-1",
                  type: "radio",
                  value: f.value,
                  onInvalid: d[0] || (d[0] = //@ts-ignore
                  (...w) => m(l) && m(l)(...w))
                }, null, 40, qg)
              ], 2)
            ]),
            _: 2
          }, 1032, ["disabled", "value"]))), 128))
        ], 2)
      ]),
      _: 3
    }, 8, ["modelValue", "disabled", "aria-invalid", "aria-errormessage"]));
  }
}), Yg = ["id", "aria-labelledby", "aria-describedby", "aria-errormessage", "placeholder"], zg = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "TextArea",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    modelValue: {},
    label: {},
    help: {},
    placeholder: {}
  }, dt), {
    modelValue: de,
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", de), { aria: r, inputID: o, isRequired: a, errorState: s, onInvalid: i, inputValidation: l } = ft(n);
    return (u, c) => (x(), _("div", null, [
      k(qe, {
        id: m(r).labelledby,
        class: "mb-2",
        for: m(o),
        label: u.label,
        required: m(a)
      }, null, 8, ["id", "for", "label", "required"]),
      Xe(v("textarea", Fe({
        id: m(o),
        "onUpdate:modelValue": c[0] || (c[0] = (d) => e.value = d),
        "aria-labelledby": m(r).labelledby,
        "aria-describedby": m(r).describedby,
        "aria-errormessage": m(r).errormessage,
        class: [
          "block w-full rounded-md border-0 py-2 shadow-sm ring-1 ring-inset focus:ring-2 sm:text-sm sm:leading-6",
          "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-700 disabled:ring-gray-200",
          m(s) ? "text-red-900 ring-red-700 placeholder:text-red-300 focus:ring-red-700" : "text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-xy-blue-500"
        ],
        placeholder: u.placeholder
      }, u.$attrs, {
        onInput: c[1] || (c[1] = //@ts-ignore
        (...d) => m(l) && m(l)(...d)),
        onInvalid: c[2] || (c[2] = //@ts-ignore
        (...d) => m(i) && m(i)(...d))
      }), null, 16, Yg), [
        [co, e.value]
      ]),
      k(Re, {
        id: m(r).describedby,
        class: "mt-1",
        text: u.help
      }, null, 8, ["id", "text"]),
      k(ot, {
        id: m(r).errormessage,
        class: "mt-0.5",
        text: m(s)
      }, null, 8, ["id", "text"])
    ]));
  }
}), Kg = ["aria-labelledby", "aria-describedby", "aria-errormessage"], Gg = { key: 0 }, Jg = ["for"], Xg = ["id", "name"], Zg = ["for"], Qg = ["id", "name"], e0 = /* @__PURE__ */ R({
  inheritAttrs: !1,
  __name: "YesOrNoRadio",
  props: /* @__PURE__ */ ve(/* @__PURE__ */ ut({
    modelValue: { type: [Boolean, null] },
    label: {},
    help: {},
    placeholder: {}
  }, dt), {
    modelValue: { type: [Boolean, null], ...de },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = t, e = xe(t, "modelValue", de), {
      aria: r,
      isDisabled: o,
      isRequired: a,
      nameAttr: s,
      errorState: i,
      onInvalid: l,
      validate: u
    } = ft(n);
    return (c, d) => (x(), _("fieldset", {
      class: "space-y-6",
      "aria-labelledby": m(r).labelledby,
      "aria-describedby": m(r).describedby,
      "aria-errormessage": m(r).errormessage
    }, [
      c.label ? (x(), _("div", Gg, [
        k($n, {
          id: m(r).labelledby,
          class: "block my-auto",
          label: c.label,
          required: m(a),
          tag: "legend"
        }, null, 8, ["id", "label", "required"]),
        c.help ? (x(), V(Re, {
          key: 0,
          id: m(r).describedby,
          class: "mt-1",
          tag: "p",
          text: c.help
        }, null, 8, ["id", "text"])) : B("", !0),
        k(ot, {
          id: m(r).errormessage,
          class: "mt-1",
          text: m(i)
        }, null, 8, ["id", "text"])
      ])) : B("", !0),
      v("div", null, [
        v("label", {
          class: L(["inline-flex items-center group", m(o) ? "cursor-not-allowed" : "cursor-pointer"]),
          for: `${m(s)}-true`
        }, [
          Xe(v("input", Fe({
            id: `${m(s)}-true`,
            "onUpdate:modelValue": d[0] || (d[0] = (f) => e.value = f),
            type: "radio",
            class: [
              "h-4 w-4 text-xy-blue cursor-pointer",
              "disabled:bg-gray-100 disabled:border-gray-200  disabled:cursor-not-allowed disabled:opacity-100",
              "checked:disabled:bg-xy-blue checked:disabled:border-xy-blue checked:disabled:opacity-50",
              m(i) ? "border-red-700 focus:ring-red-700" : "border-gray-300  focus:ring-xy-blue-500"
            ],
            name: m(s),
            value: !0
          }, c.$attrs, {
            onChange: d[1] || (d[1] = //@ts-ignore
            (...f) => m(u) && m(u)(...f)),
            onInvalid: d[2] || (d[2] = //@ts-ignore
            (...f) => m(l) && m(l)(...f))
          }), null, 16, Xg), [
            [Wr, e.value]
          ]),
          k(qe, {
            class: "ml-3",
            label: "Yes",
            tag: "span"
          })
        ], 10, Jg),
        v("label", {
          class: L(["inline-flex items-center ml-6", m(o) ? "cursor-not-allowed" : "cursor-pointer"]),
          for: `${m(s)}-false`
        }, [
          Xe(v("input", Fe({
            id: `${m(s)}-false`,
            "onUpdate:modelValue": d[3] || (d[3] = (f) => e.value = f),
            type: "radio",
            class: [
              "h-4 w-4 text-xy-blue cursor-pointer",
              "disabled:bg-gray-100 disabled:border-gray-200  disabled:cursor-not-allowed disabled:opacity-100",
              "checked:disabled:bg-xy-blue checked:disabled:border-xy-blue checked:disabled:opacity-50",
              m(i) ? "border-red-700 focus:ring-red-700" : "border-gray-300  focus:ring-xy-blue-500"
            ],
            name: m(s),
            value: !1
          }, c.$attrs, {
            onChange: d[4] || (d[4] = //@ts-ignore
            (...f) => m(u) && m(u)(...f)),
            onInvalid: d[5] || (d[5] = //@ts-ignore
            (...f) => m(l) && m(l)(...f))
          }), null, 16, Qg), [
            [Wr, e.value]
          ]),
          k(qe, {
            class: "ml-3",
            label: "No",
            tag: "span"
          })
        ], 10, Zg)
      ])
    ], 8, Kg));
  }
}), t0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActionsDropdown: _o,
  BaseInput: Dh,
  Cards: zc,
  Checkbox: $h,
  ContentModal: Qc,
  DataTable: Kp,
  DateFilter: si,
  DateRangePicker: ko,
  DateTime: Mh,
  DetailList: xd,
  DownloadCell: Dd,
  DynamicTable: jm,
  FieldsetLegend: $n,
  Flash: $o,
  InlineAlert: Kd,
  InputError: ot,
  InputHelp: Re,
  InputLabel: qe,
  Modal: nf,
  MultiCheckboxes: Fh,
  NumberInput: yi,
  Paginator: li,
  Popover: oo,
  PopoverContent: Wf,
  PopoverPosition: oo,
  ProgressCircles: ph,
  ProgressCirclesLabeled: xh,
  Radio: jg,
  RadioCards: Wg,
  Select: So,
  SidebarLayout: jf,
  Slideover: np,
  Spinner: To,
  StackedLayout: Mp,
  Steps: sm,
  TablePaginator: di,
  Tabs: nh,
  TextArea: zg,
  Toggle: ah,
  Tooltip: sp,
  XYSpinner: ui,
  YesOrNoRadio: e0
}, Symbol.toStringTag, { value: "Module" })), R0 = function(n) {
  Object.entries(t0).forEach(([e, r]) => {
    n.component(e, r);
  });
};
export {
  _o as ActionsDropdown,
  hs as BaseAPI,
  Dh as BaseInput,
  zc as Cards,
  $h as Checkbox,
  Qc as ContentModal,
  Kp as DataTable,
  si as DateFilter,
  ko as DateRangePicker,
  Mh as DateTime,
  xd as DetailList,
  Dd as DownloadCell,
  jm as DynamicTable,
  $n as FieldsetLegend,
  $o as Flash,
  Kd as InlineAlert,
  ot as InputError,
  Re as InputHelp,
  qe as InputLabel,
  nf as Modal,
  Fh as MultiCheckboxes,
  yi as NumberInput,
  li as Paginator,
  oo as Popover,
  Wf as PopoverContent,
  oo as PopoverPosition,
  ph as ProgressCircles,
  xh as ProgressCirclesLabeled,
  jg as Radio,
  Wg as RadioCards,
  So as Select,
  jf as SidebarLayout,
  np as Slideover,
  To as Spinner,
  Mp as StackedLayout,
  sm as Steps,
  di as TablePaginator,
  nh as Tabs,
  zg as TextArea,
  ah as Toggle,
  sp as Tooltip,
  ui as XYSpinner,
  e0 as YesOrNoRadio,
  Kn as debounceFn,
  D0 as debounceLeading,
  R0 as default,
  Ru as emailPattern,
  Ou as isHttpCancel,
  Au as isHttpError,
  ra as looseToNumber,
  _0 as numericInputTypes,
  Iu as phonePattern,
  C0 as setBaseAPIDefaults,
  E0 as textInputTypes,
  k0 as throttleFn,
  Lu as urlPattern,
  ii as useAppFlasher,
  Ut as useAppFlashes,
  na as useAppSpinner,
  kn as useBaseAPI,
  $0 as useBaseAPIDelete,
  S0 as useBaseAPIGet,
  T0 as useBaseAPIPatch,
  M0 as useBaseAPIPost,
  P0 as useBaseAPIPut,
  pd as useFlashes,
  ft as useInputField,
  Mu as useSpinnerDisplay,
  A0 as useTabHistory,
  O0 as useUrlSearchParams
};
